var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/init-masonry-registry.ts
import {
  MasonryDriverActionController,
  MasonryDriverNodeRenderersRegistry
} from "@leagueplatform/masonry";

// src/node-renderers/chart-renderer/chart-renderer.tsx
import React38 from "react";
import { Box as Box3 } from "@leagueplatform/genesis-core";

// src/node-renderers/chart-renderer/chart.component.tsx
import * as React37 from "react";

// src/components/charts/core/range-graph/utils/use-health-metric-values.ts
import {
  NUMERIC_YEAR_MONTH_DAY,
  useFormatDateByUserProfileLocation
} from "@leagueplatform/web-common";
import { compareAsc } from "date-fns";

// src/components/charts/core/range-graph/utils/group-by-key.ts
function groupByKey(getKey, items) {
  const groupedItems = items == null ? void 0 : items.reduce((acc, item) => {
    var _a;
    const key = getKey(item);
    return __spreadProps(__spreadValues({}, acc), {
      // Append the item to the key group, if doesn't already exist create a new array.
      [key]: [...(_a = acc[key]) != null ? _a : [], item]
    });
  }, {});
  return groupedItems;
}

// src/components/charts/core/range-graph/utils/use-health-metric-values.ts
function useHealthMetricValuesV3(healthMetrics) {
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation();
  const groupedByDate = groupByKey(
    (item) => formatDateWithUserProfileLocation(item.timestamp, __spreadValues({}, NUMERIC_YEAR_MONTH_DAY)),
    healthMetrics
  );
  const consolidatedHealthMetrics = Object.entries(groupedByDate).map(([, healthMetricsByDate]) => {
    const representativeTimestampForDay = healthMetricsByDate[0].timestamp;
    const groupedByMetricType = groupByKey(
      (item) => item.metricComponent.data.name,
      healthMetricsByDate
    );
    const healthMetricsMinMax = Object.entries(groupedByMetricType).map(
      ([type, healthMetricsByType]) => {
        let value = null;
        let label;
        const values = healthMetricsByType.map((m) => m.value).filter((v) => v !== null);
        if (values.length > 1) {
          const min = Math.min(...values);
          const max = Math.max(...values);
          const minMetric = healthMetricsByType.find((m) => m.value === min);
          const maxMetric = healthMetricsByType.find((m) => m.value === max);
          value = [min, max];
          label = [minMetric.label, maxMetric.label];
        } else if (values.length === 1) {
          const metric = healthMetricsByType.find(
            (m) => m.value === values[0]
          );
          value = values[0];
          label = metric.label;
        }
        return {
          type,
          timestamp: representativeTimestampForDay,
          value,
          label,
          aggregationStrategyLabel: healthMetricsByType[0].aggregationStrategyLabel,
          indicator: healthMetricsByType[0].indicator,
          metric: healthMetricsByType[0].metricComponent
        };
      }
    );
    return healthMetricsMinMax.sort(
      (a, b) => a.metric.data.order - b.metric.data.order
    );
  }).flat();
  const sortedConsolidatedHealthMetrics = consolidatedHealthMetrics.sort(
    (a, b) => compareAsc(new Date(a.timestamp), new Date(b.timestamp))
  );
  return sortedConsolidatedHealthMetrics;
}
function useHealthMetricValues(healthMetrics) {
  const healthMetricsIsolate = healthMetrics.map((metric) => __spreadProps(__spreadValues({}, metric), {
    metricComponent: {
      data: {
        name: metric.config.data.name,
        order: metric.config.data.order,
        unit: metric.config.data.unit
      }
    }
  }));
  return useHealthMetricValuesV3(healthMetricsIsolate);
}

// src/components/charts/core/xychart/primitives/Shape.tsx
import * as React from "react";
import { useTheme } from "@leagueplatform/genesis-core";
import { Circle, Polygon } from "@visx/shape";
var shapes = ["circle", "square"];
function calculateAdjustedCircleRadius(radius, strokeWidth) {
  const adjustedRadius = radius + strokeWidth / 2;
  return adjustedRadius;
}
function calculateAdjustedRectSize(size, strokeWidth) {
  const adjustedSize = size + strokeWidth;
  return adjustedSize;
}
var shapeMap = {
  circle: ({ x, y, radius, fill, ariaLabel, strokeWidth = 0, strokeColor }) => /* @__PURE__ */ React.createElement(
    Circle,
    {
      cx: x,
      cy: y,
      r: calculateAdjustedCircleRadius(radius, strokeWidth),
      strokeWidth,
      stroke: strokeColor,
      vectorEffect: "non-scaling-stroke",
      fill,
      "aria-label": ariaLabel,
      style: { pointerEvents: "none" }
    }
  ),
  square: ({ x, y, radius, fill, ariaLabel, strokeWidth = 0, strokeColor }) => /* @__PURE__ */ React.createElement(
    Polygon,
    {
      sides: 4,
      rotate: 90,
      center: { x, y },
      size: calculateAdjustedRectSize(radius, strokeWidth),
      strokeWidth,
      vectorEffect: "non-scaling-stroke",
      stroke: strokeColor,
      fill,
      "aria-label": ariaLabel,
      style: { pointerEvents: "none" }
    }
  )
};
function Shape(_a) {
  var _b = _a, { shape } = _b, props = __objRest(_b, ["shape"]);
  return shapeMap[shape](props);
}
function useShapeTheme({ shape }) {
  var _a, _b, _c, _d;
  const theme = useTheme();
  const colorMap = {
    circle: {
      light: (_a = theme.colors.dataVizCategoricalOne) != null ? _a : theme.colors.decorativeBrandPrimaryBrightest,
      dark: (_b = theme.colors.dataVizCategoricalTwo) != null ? _b : theme.colors.decorativeBrandPrimaryDark
    },
    square: {
      light: (_c = theme.colors.dataVizCategoricalFour) != null ? _c : theme.colors.decorativeBrandSecondaryBrightest,
      dark: (_d = theme.colors.dataVizCategoricalFive) != null ? _d : theme.colors.decorativeBrandSecondaryDark
    }
  };
  return colorMap[shape];
}
function ShapeIcon({ shape }) {
  const shapeTheme = useShapeTheme({ shape });
  const theme = useTheme();
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      height: theme.sizes.threeQuarters.value,
      width: theme.sizes.threeQuarters.value,
      viewBox: "0 0 16 16"
    },
    /* @__PURE__ */ React.createElement(Shape, { shape, x: 8, y: 8, radius: 8, fill: shapeTheme.dark }),
    ";"
  );
}

// src/components/charts/core/bar-graph/bar-graph.tsx
import * as React19 from "react";

// src/components/charts/constants/chart-views.ts
var CHART_VIEWS = {
  WEEKLY: "weekly",
  MONTHLY: "monthly"
};

// src/components/charts/core/bar-graph/weekly-bar-graph.tsx
import * as React17 from "react";
import {
  SHORT_WEEKDAY_FORMAT,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation2
} from "@leagueplatform/web-common";
import { useThemeRawValues as useThemeRawValues5 } from "@leagueplatform/genesis-core";

// src/components/charts/core/xychart/xychart.tsx
import * as React5 from "react";
import { useTheme as useCommonsTheme } from "@leagueplatform/genesis-commons";
import useMeasure from "react-use-measure";
import { useTooltip as useTooltip2 } from "@visx/tooltip";
import { Group } from "@visx/group";
import { createScale } from "@visx/scale";

// src/components/charts/core/xychart/providers/chart-data-provider.tsx
import React2 from "react";
var ChartContext = React2.createContext(void 0);
ChartContext.displayName = "ChartContext";
var ChartProvider = ChartContext.Provider;
function useChart() {
  const context = React2.useContext(ChartContext);
  if (context === void 0) {
    throw new Error("useChart must be used within a ChartProvider");
  }
  return context;
}

// src/components/charts/core/xychart/providers/tooltip-provider.tsx
import React3 from "react";
var TooltipContext = React3.createContext(
  void 0
);
TooltipContext.displayName = "TooltipContext";
var TooltipProvider = TooltipContext.Provider;
function useTooltip() {
  const context = React3.useContext(TooltipContext);
  if (context === void 0) {
    throw new Error("useTooltip must be used within a TooltipProvider");
  }
  return context;
}

// src/components/charts/core/xychart/components/grid-column-line.tsx
import * as React4 from "react";
import { useTheme as useTheme2 } from "@leagueplatform/genesis-commons";
function GridColumnLine() {
  const { xMax, yMax } = useChart();
  const theme = useTheme2();
  return /* @__PURE__ */ React4.createElement(
    "line",
    {
      x1: xMax,
      y1: 0,
      x2: xMax,
      y2: yMax,
      stroke: theme.colors.onSurface.border.subdued,
      strokeWidth: theme.borderWidths.thick,
      strokeDasharray: "5"
    }
  );
}

// src/components/charts/core/xychart/xychart.tsx
function XYChart({
  children,
  data,
  accessors,
  margin: initialMargin,
  title,
  desc,
  xScale: xScaleConfig,
  yScale: yScaleConfig
}) {
  var _a, _b, _c, _d;
  const theme = useCommonsTheme();
  const tooltip = useTooltip2();
  const [ref, bounds] = useMeasure();
  const { width, height } = bounds;
  const margin3 = {
    top: (_a = initialMargin == null ? void 0 : initialMargin.top) != null ? _a : theme.space.three,
    bottom: (_b = initialMargin == null ? void 0 : initialMargin.bottom) != null ? _b : 0,
    left: (_c = initialMargin == null ? void 0 : initialMargin.left) != null ? _c : 0,
    right: (_d = initialMargin == null ? void 0 : initialMargin.right) != null ? _d : 0
  };
  const dimensions = { width, height, margin: margin3 };
  const xMax = width - margin3.left - margin3.right;
  const yMax = height - margin3.top - margin3.bottom;
  const xScale = createScale(__spreadValues({
    range: [0, xMax],
    domain: data.map(accessors.xAccessor)
  }, xScaleConfig));
  const yScale = createScale(__spreadValues({
    range: [yMax, 0]
  }, yScaleConfig));
  return /* @__PURE__ */ React5.createElement(TooltipProvider, { value: tooltip }, /* @__PURE__ */ React5.createElement(
    ChartProvider,
    {
      value: {
        dimensions,
        xMax,
        yMax,
        xScale,
        yScale,
        margin: margin3
      }
    },
    /* @__PURE__ */ React5.createElement(
      "svg",
      {
        ref,
        width: "100%",
        height: "100%",
        viewBox: `0 0 ${width} ${height}`
      },
      /* @__PURE__ */ React5.createElement("title", null, title),
      /* @__PURE__ */ React5.createElement("desc", null, desc),
      /* @__PURE__ */ React5.createElement(Group, { left: margin3.left, top: margin3.top }, /* @__PURE__ */ React5.createElement(GridColumnLine, null), children)
    )
  ));
}

// src/components/charts/core/xychart/components/grid.tsx
import * as React7 from "react";

// src/components/charts/core/xychart/primitives/Grid.tsx
import * as React6 from "react";
import { Grid as VisxGrid } from "@visx/grid";
import { useTheme as useTheme3, useThemeRawValues } from "@leagueplatform/genesis-core";
function Grid(props) {
  const theme = useTheme3();
  const rawTheme = useThemeRawValues();
  return /* @__PURE__ */ React6.createElement(
    VisxGrid,
    __spreadValues({
      stroke: theme.colors.onSurfaceBorderSubdued,
      strokeWidth: rawTheme.borderWidths.thick,
      strokeDasharray: "3 3",
      rowLineStyle: { strokeDasharray: "none" },
      columnLineStyle: { strokeDasharray: 5 }
    }, props)
  );
}

// src/components/charts/core/xychart/utils/get-scale-step.ts
function getScaleStep(scale) {
  var _a;
  const s = scale;
  return s && "step" in s ? (_a = s == null ? void 0 : s.step()) != null ? _a : 0 : 0;
}

// src/components/charts/core/xychart/components/grid.tsx
function Grid2(_a) {
  var _b = _a, { centerColumns = false } = _b, props = __objRest(_b, ["centerColumns"]);
  const { xMax, yMax, xScale, yScale } = useChart();
  const step = getScaleStep(xScale);
  return /* @__PURE__ */ React7.createElement(
    Grid,
    __spreadValues({
      xScale,
      yScale,
      width: xMax,
      height: yMax,
      xOffset: centerColumns ? step / 2 : 0
    }, props)
  );
}

// src/components/charts/core/xychart/components/bar.tsx
import * as React9 from "react";

// src/components/charts/core/xychart/primitives/Bar.tsx
import * as React8 from "react";
import { BarRounded as VisxBarRounded } from "@visx/shape";
import { useTheme as useTheme4, useThemeRawValues as useThemeRawValues2 } from "@leagueplatform/genesis-core";
function Bar(_a) {
  var _b = _a, { highlight, radius } = _b, props = __objRest(_b, ["highlight", "radius"]);
  var _a2;
  const theme = useTheme4();
  const rawTheme = useThemeRawValues2();
  return /* @__PURE__ */ React8.createElement(
    VisxBarRounded,
    __spreadValues({
      top: true,
      radius,
      strokeDasharray: "3 3",
      strokeWidth: rawTheme.borderWidths.thick,
      fill: (_a2 = theme.colors.dataVizSingleColorBrand) != null ? _a2 : theme.colors.decorativeBrandPrimaryDark
    }, props)
  );
}

// src/components/charts/core/xychart/utils/get-scale-bandwidth.ts
function getScaleBandwidth(scale) {
  var _a;
  const s = scale;
  return s && "bandwidth" in s ? (_a = s == null ? void 0 : s.bandwidth()) != null ? _a : 0 : 0;
}

// src/components/charts/core/xychart/components/bar.tsx
var compose = (scale, accessor) => (d) => scale(accessor(d));
function Bar2(_a) {
  var _b = _a, {
    accessors,
    datum,
    highlight
  } = _b, props = __objRest(_b, [
    "accessors",
    "datum",
    "highlight"
  ]);
  const { xScale, yScale, yMax } = useChart();
  const { showTooltip, hideTooltip } = useTooltip();
  const xPoint = compose(xScale, accessors.xAccessor);
  const yPoint = compose(yScale, accessors.yAccessor);
  const barWidth = getScaleBandwidth(xScale);
  const barHeight = yMax - yPoint(datum);
  const barX = xPoint(datum);
  const barY = yMax - barHeight;
  const barCenterPoint = barX + barWidth / 2;
  const handleShowTooltip = () => {
    showTooltip({
      tooltipData: datum,
      tooltipLeft: barCenterPoint,
      tooltipTop: barY
    });
  };
  const handleHideTooltip = () => {
    hideTooltip();
  };
  return /* @__PURE__ */ React9.createElement(
    Bar,
    __spreadValues({
      x: barX != null ? barX : 0,
      y: barY,
      width: barWidth,
      height: barHeight,
      tabIndex: 0,
      onFocus: handleShowTooltip,
      onMouseEnter: handleShowTooltip,
      onMouseLeave: handleHideTooltip,
      onBlur: handleHideTooltip
    }, props)
  );
}

// src/components/charts/core/xychart/components/axis-left.tsx
import * as React11 from "react";

// src/components/charts/core/xychart/primitives/AxisLeft.tsx
import * as React10 from "react";
import { AxisLeft as VisxAxisLeft } from "@visx/axis";
import { useTheme as useTheme5, useThemeRawValues as useThemeRawValues3 } from "@leagueplatform/genesis-core";
function AxisLeft(props) {
  const theme = useTheme5();
  const rawTheme = useThemeRawValues3();
  return /* @__PURE__ */ React10.createElement(
    VisxAxisLeft,
    __spreadValues({
      tickStroke: theme.colors.onSurfaceBorderSubdued,
      stroke: theme.colors.onSurfaceBorderDefault,
      strokeWidth: rawTheme.borderWidths.thick,
      labelProps: {
        fill: theme.colors.onSurfaceTextPrimary,
        fontSize: rawTheme.fontSizes.headingThree,
        textAnchor: "middle",
        fontWeight: "bold"
      },
      tickLabelProps: () => ({
        fontSize: rawTheme.fontSizes.headingTwo,
        fill: theme.colors.onSurfaceTextSubdued,
        textAnchor: "end",
        dy: 6
      })
    }, props)
  );
}

// src/components/charts/core/xychart/components/axis-left.tsx
function AxisLeft2(_a) {
  var _b = _a, { onWidthChange } = _b, props = __objRest(_b, ["onWidthChange"]);
  const { yScale } = useChart();
  const leftAxisRef = React11.useRef(null);
  const [currentWidth, setCurrentWidth] = React11.useState();
  React11.useLayoutEffect(() => {
    var _a2;
    if (((_a2 = leftAxisRef.current) == null ? void 0 : _a2.getBBox) && onWidthChange) {
      const { width } = leftAxisRef.current.getBBox();
      if (currentWidth !== width) {
        setCurrentWidth(width);
        onWidthChange(width);
      }
    }
  }, [currentWidth, onWidthChange]);
  return /* @__PURE__ */ React11.createElement(
    AxisLeft,
    __spreadValues({
      innerRef: leftAxisRef,
      scale: yScale
    }, props)
  );
}

// src/components/charts/core/xychart/components/axis-bottom.tsx
import * as React13 from "react";

// src/components/charts/core/xychart/primitives/AxisBottom.tsx
import * as React12 from "react";
import { AxisBottom as VisxAxisBottom } from "@visx/axis";
import { useTheme as useTheme6, useThemeRawValues as useThemeRawValues4 } from "@leagueplatform/genesis-core";
function AxisBottom(props) {
  const theme = useTheme6();
  const rawTheme = useThemeRawValues4();
  return /* @__PURE__ */ React12.createElement(
    VisxAxisBottom,
    __spreadValues({
      tickStroke: theme.colors.onSurfaceBorderSubdued,
      labelOffset: rawTheme.space.oneAndHalf,
      labelProps: {
        fill: theme.colors.onSurfaceTextPrimary,
        fontSize: rawTheme.fontSizes.headingThree,
        textAnchor: "middle",
        fontWeight: "bold"
      },
      stroke: theme.colors.onSurfaceBorderDefault,
      strokeWidth: rawTheme.borderWidths.thick,
      tickLabelProps: () => ({
        fontSize: rawTheme.fontSizes.headingTwo,
        fill: theme.colors.onSurfaceTextSubdued,
        textAnchor: "middle"
      })
    }, props)
  );
}

// src/components/charts/core/xychart/components/axis-bottom.tsx
function AxisBottom2(_a) {
  var _b = _a, { onHeightChange } = _b, props = __objRest(_b, ["onHeightChange"]);
  const { xScale, yMax } = useChart();
  const bottomAxisRef = React13.useRef(null);
  const [currentHeight, setCurrentHeight] = React13.useState();
  React13.useLayoutEffect(() => {
    var _a2;
    if (((_a2 = bottomAxisRef.current) == null ? void 0 : _a2.getBBox) && onHeightChange) {
      const { height } = bottomAxisRef.current.getBBox();
      if (currentHeight !== height) {
        setCurrentHeight(height);
        onHeightChange(height);
      }
    }
  }, [currentHeight, onHeightChange]);
  return /* @__PURE__ */ React13.createElement(
    AxisBottom,
    __spreadValues({
      innerRef: bottomAxisRef,
      top: yMax,
      scale: xScale
    }, props)
  );
}

// src/components/charts/core/xychart/components/tooltip.tsx
import * as React15 from "react";
import { useTooltipInPortal } from "@visx/tooltip";
import { GDSThemeProvider, useTheme as useTheme8 } from "@leagueplatform/genesis-core";
import { trackAnalyticsEvent, EVENT_NAME } from "@leagueplatform/analytics";
import { useParamsLegacy as useParams } from "@leagueplatform/routing";

// src/components/charts/core/xychart/components/tooltip-line.tsx
import * as React14 from "react";
import { Line as VisxLine } from "@visx/shape";
import { useTheme as useTheme7 } from "@leagueplatform/genesis-commons";
function TooltipLine({ snapToDatum }) {
  const { margin: margin3 } = useChart();
  const theme = useTheme7();
  const { tooltipLeft, tooltipTop } = useTooltip();
  return /* @__PURE__ */ React14.createElement("g", null, /* @__PURE__ */ React14.createElement(
    VisxLine,
    {
      from: { x: tooltipLeft, y: -margin3.top * 1.2 },
      to: { x: tooltipLeft, y: tooltipTop },
      stroke: theme.colors.decorative.brand.primary.dark,
      strokeWidth: 2,
      pointerEvents: "none",
      strokeDasharray: "0"
    }
  ), snapToDatum ? /* @__PURE__ */ React14.createElement(React14.Fragment, null, /* @__PURE__ */ React14.createElement(
    "circle",
    {
      cx: tooltipLeft,
      cy: tooltipTop,
      r: 12,
      fill: "white",
      stroke: theme.colors.decorative.brand.primary.brightest,
      strokeWidth: 2,
      pointerEvents: "none"
    }
  ), /* @__PURE__ */ React14.createElement(
    "circle",
    {
      cx: tooltipLeft,
      cy: tooltipTop,
      r: 10,
      fill: "white",
      stroke: theme.colors.decorative.brand.primary.dark,
      strokeWidth: 2,
      pointerEvents: "none"
    }
  )) : null);
}

// src/components/charts/core/xychart/components/tooltip.tsx
function Tooltip({ children, snapToDatum }) {
  const { dataType } = useParams();
  const { margin: margin3 } = useChart();
  const theme = useTheme8();
  const { tooltipData, tooltipLeft } = useTooltip();
  const { containerRef, TooltipInPortal } = useTooltipInPortal({
    detectBounds: false,
    scroll: false
  });
  const setContainerRef = React15.useCallback(
    (ownRef) => {
      var _a;
      containerRef((_a = ownRef == null ? void 0 : ownRef.parentElement) != null ? _a : null);
    },
    [containerRef]
  );
  React15.useEffect(() => {
    if (tooltipData) {
      trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
        product_area: "dashboard" /* DASHBOARD */,
        screen_name: "dashboard metrics screen" /* DASHBOARD_METRIC_SCREEN */,
        metric_type: dataType,
        detail: "graph value click"
      });
    }
  }, [tooltipData, dataType]);
  return /* @__PURE__ */ React15.createElement(React15.Fragment, null, /* @__PURE__ */ React15.createElement("svg", { ref: setContainerRef }), tooltipData ? /* @__PURE__ */ React15.createElement(React15.Fragment, null, /* @__PURE__ */ React15.createElement(TooltipLine, { snapToDatum }), /* @__PURE__ */ React15.createElement(
    TooltipInPortal,
    {
      left: tooltipLeft,
      offsetLeft: margin3.left,
      applyPositionStyle: true,
      style: {
        pointerEvents: "none"
      }
    },
    /* @__PURE__ */ React15.createElement(GDSThemeProvider, { theme }, children(tooltipData))
  )) : null);
}

// src/hooks/use-last-truthy-value.tsx
import * as React16 from "react";
function useLastTruthyValue(value, initialValue) {
  const lastTruthyRef = React16.useRef(initialValue);
  React16.useEffect(() => {
    if (value) {
      lastTruthyRef.current = value;
    }
  }, [value]);
  return lastTruthyRef;
}

// src/components/charts/core/bar-graph/utils/get-rounded-y-max.ts
function roundAxisValueUp(value) {
  let roundBy = 10;
  if (value > 900) {
    roundBy = 1e3;
  } else if (value > 90) {
    roundBy = 100;
  }
  const roundedValue = Math.ceil(value / roundBy) * roundBy;
  return roundedValue;
}
function getRoundedYMax(data, accessors) {
  const maxValue = Math.max(
    ...data.map(accessors.yAccessor).filter((datum) => datum !== null).flat()
  );
  return roundAxisValueUp(maxValue);
}
function useGetRoundedYMax(data, accessors, initialValue, yMaxFromEnums) {
  let yMax = 0;
  if (data.length > 0) {
    yMax = getRoundedYMax(data, accessors);
  }
  const prevYMaxRef = useLastTruthyValue(yMax, initialValue);
  if (!yMax) {
    yMax = prevYMaxRef.current;
  }
  if (yMaxFromEnums > 0) {
    return yMaxFromEnums;
  }
  return yMax;
}

// src/components/charts/core/bar-graph/utils/use-calculate-left-axis-label-offset.ts
import { getStringWidth } from "@visx/text";
import { useIntl } from "@leagueplatform/locales";
var DEFAULT_VISX_LEFT_AXIS_TICK_OFFSET = 36;
function useGetLeftAxisLabelOffset(yMax) {
  var _a;
  const { formatNumber } = useIntl();
  return ((_a = getStringWidth(formatNumber(yMax))) != null ? _a : 0) + DEFAULT_VISX_LEFT_AXIS_TICK_OFFSET;
}

// src/components/charts/core/bar-graph/weekly-bar-graph.tsx
var NUM_X_TICKS = 2;
function WeeklyBarGraph({
  data,
  accessors,
  title,
  description,
  axisLeftLabel,
  axisBottomLabel,
  ariaDatumLabel,
  renderTooltip,
  yMaxFromEnums
}) {
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation2();
  const rawTheme = useThemeRawValues5();
  const yMax = useGetRoundedYMax(data, accessors, 100, yMaxFromEnums);
  const labelOffset = useGetLeftAxisLabelOffset(yMax);
  const [leftMargin, setLeftMargin] = React17.useState(0);
  const [bottomMargin, setBottomMargin] = React17.useState(0);
  return /* @__PURE__ */ React17.createElement(
    XYChart,
    {
      title,
      desc: description,
      data,
      accessors,
      margin: {
        left: leftMargin,
        bottom: bottomMargin
      },
      xScale: { type: "band", paddingInner: 0.3, paddingOuter: 0.15 },
      yScale: {
        type: "linear",
        domain: [0, yMax]
      }
    },
    /* @__PURE__ */ React17.createElement(Grid2, { rowTickValues: [0, yMax / NUM_X_TICKS, yMax], centerColumns: true }),
    /* @__PURE__ */ React17.createElement(
      AxisLeft2,
      {
        label: axisLeftLabel,
        labelOffset,
        tickValues: [0, yMax / NUM_X_TICKS, yMax],
        onWidthChange: (width) => setLeftMargin(width)
      }
    ),
    /* @__PURE__ */ React17.createElement(
      AxisBottom2,
      {
        label: axisBottomLabel,
        tickFormat: (timestamp) => formatDateWithUserProfileLocation(timestamp, SHORT_WEEKDAY_FORMAT),
        onHeightChange: (height) => setBottomMargin(height)
      }
    ),
    data.map((datum, i) => {
      const isLastBar = data.length - 1 === i;
      return /* @__PURE__ */ React17.createElement(
        Bar2,
        {
          key: `bar-${accessors.xAccessor(datum)}:${accessors.yAccessor(
            datum
          )}`,
          datum,
          accessors,
          highlight: isLastBar,
          "aria-label": ariaDatumLabel(datum),
          radius: rawTheme.radii.large
        }
      );
    }),
    /* @__PURE__ */ React17.createElement(Tooltip, { snapToDatum: true }, renderTooltip)
  );
}

// src/components/charts/core/bar-graph/monthly-bar-graph.tsx
import * as React18 from "react";

// src/hooks/use-get-default-timezone.hook.ts
import { useGetUserProfile } from "@leagueplatform/web-common";
function useGetDefaultTimezone() {
  const { data: userProfileData } = useGetUserProfile({ staleTime: Infinity });
  const { defaultTimezone } = userProfileData || {};
  return defaultTimezone;
}

// src/components/charts/core/bar-graph/monthly-bar-graph.tsx
import { useThemeRawValues as useThemeRawValues6 } from "@leagueplatform/genesis-core";

// src/components/charts/core/utils/use-monthly-ticks.ts
import isSameDay from "date-fns/isSameDay";
import differenceInCalendarMonths from "date-fns/differenceInCalendarMonths";
import differenceInCalendarDays from "date-fns/differenceInCalendarDays";
import {
  SHORT_MONTH_FORMAT,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation3,
  getZonedDate
} from "@leagueplatform/web-common";
var RENDER_EVERY_N_DAY = 6;
function getMonthlyXAxisTicks(data, defaultTimezone) {
  const mostRecentDatum = getZonedDate(data[data.length - 1], defaultTimezone);
  const ticks = data.filter((lastUpdate) => {
    const dayDifference = differenceInCalendarDays(
      mostRecentDatum,
      getZonedDate(lastUpdate, defaultTimezone)
    );
    return dayDifference !== 0 && dayDifference % RENDER_EVERY_N_DAY === 0;
  }).filter(
    (date, index, dates) => !dates.slice(index + 1).find(
      (d) => isSameDay(
        getZonedDate(d, defaultTimezone),
        getZonedDate(date, defaultTimezone)
      )
    )
  );
  return ticks;
}
function formatMonthlyTick(format, defaultTimezone) {
  const formatTick = (timestamp, index, dates) => {
    const shouldShowMonth = index === 0 || differenceInCalendarMonths(
      getZonedDate(timestamp, defaultTimezone),
      getZonedDate(dates[index - 1].value, defaultTimezone)
    ) > 0;
    const formattedTick = format(
      timestamp,
      shouldShowMonth ? SHORT_MONTH_FORMAT : { day: "numeric" }
    );
    return formattedTick;
  };
  return formatTick;
}
function useMonthlyTicks(data, defaultTimezone) {
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation3();
  const tickFormater = formatMonthlyTick(formatDateWithUserProfileLocation);
  const ticks = getMonthlyXAxisTicks(data, defaultTimezone);
  return [tickFormater, ticks];
}

// src/components/charts/core/bar-graph/monthly-bar-graph.tsx
var NUM_X_TICKS2 = 2;
function MonthlyBarGraph({
  data,
  accessors,
  title,
  description,
  axisLeftLabel,
  axisBottomLabel,
  ariaDatumLabel,
  renderTooltip,
  yMaxFromEnums
}) {
  const defaultTimezone = useGetDefaultTimezone();
  const rawTheme = useThemeRawValues6();
  const yMax = useGetRoundedYMax(data, accessors, 100, yMaxFromEnums);
  const labelOffset = useGetLeftAxisLabelOffset(yMax);
  const [leftMargin, setLeftMargin] = React18.useState(0);
  const [bottomMargin, setBottomMargin] = React18.useState(0);
  const [formatBottomTick, xAxisTicks] = useMonthlyTicks(
    data.map(accessors.xAccessor),
    defaultTimezone
  );
  return /* @__PURE__ */ React18.createElement(
    XYChart,
    {
      title,
      desc: description,
      data,
      accessors,
      margin: {
        left: leftMargin,
        bottom: bottomMargin
      },
      xScale: { type: "band", paddingInner: 0.3, paddingOuter: 0.15 },
      yScale: {
        type: "linear",
        domain: [0, yMax]
      }
    },
    /* @__PURE__ */ React18.createElement(
      Grid2,
      {
        rowTickValues: [0, yMax / NUM_X_TICKS2, yMax],
        columnTickValues: xAxisTicks,
        centerColumns: true
      }
    ),
    /* @__PURE__ */ React18.createElement(
      AxisLeft2,
      {
        label: axisLeftLabel,
        labelOffset,
        tickValues: [0, yMax / NUM_X_TICKS2, yMax],
        onWidthChange: (width) => setLeftMargin(width)
      }
    ),
    /* @__PURE__ */ React18.createElement(
      AxisBottom2,
      {
        label: axisBottomLabel,
        tickValues: xAxisTicks,
        tickFormat: formatBottomTick,
        onHeightChange: (height) => setBottomMargin(height)
      }
    ),
    data.map((datum, i) => {
      const isLastBar = data.length - 1 === i;
      return /* @__PURE__ */ React18.createElement(
        Bar2,
        {
          key: `bar-${accessors.xAccessor(datum)}:${accessors.yAccessor(
            datum
          )}`,
          datum,
          accessors,
          highlight: isLastBar,
          "aria-label": ariaDatumLabel(datum),
          radius: rawTheme.radii.small
        }
      );
    }),
    /* @__PURE__ */ React18.createElement(Tooltip, { snapToDatum: true }, renderTooltip)
  );
}

// src/components/charts/core/bar-graph/bar-graph.tsx
function BarGraph(_a) {
  var _b = _a, { chartView } = _b, props = __objRest(_b, ["chartView"]);
  if (chartView === CHART_VIEWS.WEEKLY) {
    return /* @__PURE__ */ React19.createElement(WeeklyBarGraph, __spreadValues({}, props));
  }
  if (chartView === CHART_VIEWS.MONTHLY) {
    return /* @__PURE__ */ React19.createElement(MonthlyBarGraph, __spreadValues({}, props));
  }
  return null;
}

// src/components/charts/core/bar-graph/masonry-bar-graph-interval-selector.tsx
import * as React21 from "react";
import { useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation4 } from "@leagueplatform/web-common";
import { useThemeRawValues as useThemeRawValues7 } from "@leagueplatform/genesis-core";

// src/components/charts/core/bar-graph/masonry-bar-graph.tsx
import * as React20 from "react";
var NUM_X_TICKS3 = 2;
function MasonryBarGraph({
  data,
  accessors,
  title,
  description,
  axisLeftLabel,
  axisBottomLabel,
  ariaDatumLabel,
  renderTooltip,
  barPadding,
  barRadius,
  yAxisMax,
  xAxisTicks,
  xAxisTickFormat
}) {
  const yAxisLabelOffset = useGetLeftAxisLabelOffset(yAxisMax);
  const [leftMargin, setLeftMargin] = React20.useState(0);
  const [bottomMargin, setBottomMargin] = React20.useState(0);
  return /* @__PURE__ */ React20.createElement(
    XYChart,
    {
      title,
      desc: description,
      data,
      accessors,
      margin: {
        left: leftMargin,
        bottom: bottomMargin
      },
      xScale: {
        type: "band",
        paddingInner: barPadding,
        paddingOuter: barPadding / 2
      },
      yScale: {
        type: "linear",
        domain: [0, yAxisMax]
      }
    },
    /* @__PURE__ */ React20.createElement(
      Grid2,
      {
        rowTickValues: [0, yAxisMax / NUM_X_TICKS3, yAxisMax],
        columnTickValues: xAxisTicks,
        centerColumns: true
      }
    ),
    /* @__PURE__ */ React20.createElement(
      AxisLeft2,
      {
        label: axisLeftLabel,
        labelOffset: yAxisLabelOffset,
        tickValues: [0, yAxisMax / NUM_X_TICKS3, yAxisMax],
        onWidthChange: (width) => setLeftMargin(width)
      }
    ),
    /* @__PURE__ */ React20.createElement(
      AxisBottom2,
      {
        label: axisBottomLabel,
        tickValues: xAxisTicks,
        tickFormat: xAxisTickFormat,
        onHeightChange: (height) => setBottomMargin(height)
      }
    ),
    data.map((datum, i) => {
      const isLastBar = data.length - 1 === i;
      return /* @__PURE__ */ React20.createElement(
        Bar2,
        {
          key: `bar-${accessors.xAccessor(datum)}:${accessors.yAccessor(
            datum
          )}`,
          datum,
          accessors,
          highlight: isLastBar,
          "aria-label": ariaDatumLabel(datum),
          radius: barRadius
        }
      );
    }),
    /* @__PURE__ */ React20.createElement(Tooltip, { snapToDatum: true }, renderTooltip)
  );
}

// src/components/charts/core/bar-graph/masonry-bar-graph-interval-selector.tsx
function MasonryBarGraphIntervalSelector(_a) {
  var _b = _a, {
    interval
  } = _b, props = __objRest(_b, [
    "interval"
  ]);
  const defaultTimezone = useGetDefaultTimezone();
  const rawTheme = useThemeRawValues7();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation4();
  if (interval === "weekly") {
    return /* @__PURE__ */ React21.createElement(
      MasonryBarGraph,
      __spreadValues({
        xAxisTickFormat: (timestamp) => formatDateWithUserProfileLocation(timestamp, {
          weekday: "short"
        }),
        barRadius: rawTheme.radii.large,
        barPadding: 0.3
      }, props)
    );
  }
  if (interval === "monthly") {
    return /* @__PURE__ */ React21.createElement(
      MasonryBarGraph,
      __spreadValues({
        xAxisTicks: getMonthlyXAxisTicks(
          props.data.map(props.accessors.xAccessor),
          defaultTimezone
        ),
        xAxisTickFormat: formatMonthlyTick(
          formatDateWithUserProfileLocation,
          defaultTimezone
        ),
        barRadius: rawTheme.radii.small,
        barPadding: 0.3
      }, props)
    );
  }
  if (interval === "yearly") {
    return /* @__PURE__ */ React21.createElement(
      MasonryBarGraph,
      __spreadValues({
        xAxisTickFormat: (timestamp) => formatDateWithUserProfileLocation(timestamp, {
          month: "narrow"
        }),
        barRadius: rawTheme.radii.large,
        barPadding: 0.5
      }, props)
    );
  }
  if (interval === "5-yearly") {
    return /* @__PURE__ */ React21.createElement(
      MasonryBarGraph,
      __spreadValues({
        xAxisTickFormat: (timestamp) => formatDateWithUserProfileLocation(timestamp, {
          year: "numeric"
        }),
        barRadius: rawTheme.radii.large,
        barPadding: 0.5
      }, props)
    );
  }
  return null;
}

// src/components/charts/core/range-graph/masonry-range-graph-interval-selector.tsx
import * as React25 from "react";
import { useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation6 } from "@leagueplatform/web-common";

// src/components/charts/core/range-graph/masonry-range-graph.tsx
import * as React24 from "react";
import {
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation5,
  NUMERIC_YEAR_MONTH_DAY as NUMERIC_YEAR_MONTH_DAY2
} from "@leagueplatform/web-common";

// src/components/charts/core/xychart/components/range-bar.tsx
import * as React22 from "react";
import { Group as Group2 } from "@visx/group";
import { Bar as Bar3 } from "@visx/shape";
import { useTheme as useTheme9, useThemeRawValues as useThemeRawValues8 } from "@leagueplatform/genesis-core";
function RangeBar({
  accessors,
  datum,
  shape
}) {
  const { xScale, yScale, yMax } = useChart();
  const shapeTheme = useShapeTheme({ shape });
  const theme = useTheme9();
  const rawTheme = useThemeRawValues8();
  const xValue = accessors.xAccessor(datum);
  const yValue = accessors.yAccessor(datum);
  const xPoint = xScale(xValue);
  const barX = xPoint;
  const barWidth = getScaleBandwidth(xScale);
  const barCenterPoint = barX + barWidth / 2;
  const radius = barWidth / 2;
  if (Array.isArray(yValue)) {
    const yPointMin = yScale(yValue[0]);
    const yPointMax = yScale(yValue[1]);
    const barTop = yMax - yPointMax;
    const barBottom = yMax - yPointMin;
    const barHeight = barTop - barBottom;
    const barY = yMax - barTop;
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      /* @__PURE__ */ React22.createElement(Group2, { style: { pointerEvents: "none" } }, /* @__PURE__ */ React22.createElement(
        Bar3,
        {
          x: barX != null ? barX : 0,
          y: barY + radius,
          width: barWidth,
          height: barHeight - radius * 2,
          fill: shapeTheme.light
        }
      ), /* @__PURE__ */ React22.createElement(
        Shape,
        {
          shape,
          x: barCenterPoint,
          y: barY + radius,
          radius,
          fill: shapeTheme.dark,
          strokeWidth: rawTheme.space.quarter,
          strokeColor: theme.colors.surfaceBackgroundPrimary
        }
      ), /* @__PURE__ */ React22.createElement(
        Shape,
        {
          shape,
          x: barCenterPoint,
          y: barY + barHeight - radius,
          radius,
          fill: shapeTheme.dark,
          strokeWidth: rawTheme.space.quarter,
          strokeColor: theme.colors.surfaceBackgroundPrimary
        }
      ))
    );
  }
  const yPoint = yScale(yValue);
  return /* @__PURE__ */ React22.createElement(
    Shape,
    {
      shape,
      x: barCenterPoint,
      y: yPoint,
      radius,
      fill: shapeTheme.dark,
      strokeWidth: rawTheme.space.quarter,
      strokeColor: theme.colors.surfaceBackgroundPrimary
    }
  );
}

// src/components/charts/core/range-graph/tooltip-marker.tsx
import * as React23 from "react";
import { Line } from "@visx/shape";
var compose2 = (scale, accessor) => (d) => scale(accessor(d));
function TooltipMarker({
  data,
  accessors,
  ariaLabel
}) {
  const { xScale, yMax } = useChart();
  const tooltip = useTooltip();
  const xPoint = compose2(xScale, accessors.xAccessor);
  const barX = xPoint(data[0]);
  const barWidth = getScaleBandwidth(xScale);
  const barCenterPoint = barX + barWidth / 2;
  const showTooltip = () => {
    tooltip.showTooltip({
      tooltipData: data,
      tooltipLeft: barCenterPoint,
      tooltipTop: yMax
    });
  };
  const hideTooltip = () => {
    tooltip.hideTooltip();
  };
  return /* @__PURE__ */ React23.createElement(
    Line,
    {
      "aria-label": ariaLabel,
      tabIndex: 0,
      x1: barCenterPoint,
      y1: 0,
      x2: barCenterPoint,
      y2: yMax,
      stroke: "transparent",
      strokeWidth: 30,
      onFocus: showTooltip,
      onMouseEnter: showTooltip,
      onMouseLeave: hideTooltip,
      onBlur: hideTooltip,
      style: {
        outline: "none"
      }
    }
  );
}

// src/components/charts/core/range-graph/masonry-range-graph.tsx
var NUM_Y_TICKS = 5;
function MasonryRangeGraph({
  data,
  accessors,
  title,
  description,
  axisLeftLabel,
  ariaDatumLabel,
  axisBottomLabel,
  renderTooltip,
  barPadding,
  getDatumSymbol,
  yAxisMax,
  xAxisTicks,
  xAxisTickFormat
}) {
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation5();
  const yAxisLabelOffset = useGetLeftAxisLabelOffset(yAxisMax);
  const [leftMargin, setLeftMargin] = React24.useState(0);
  const [bottomMargin, setBottomMargin] = React24.useState(0);
  const groupedByDate = groupByKey(
    (datum) => formatDateWithUserProfileLocation(accessors.xAccessor(datum), __spreadValues({}, NUMERIC_YEAR_MONTH_DAY2)),
    data
  );
  return /* @__PURE__ */ React24.createElement(
    XYChart,
    {
      title,
      desc: description,
      data,
      accessors,
      margin: {
        left: leftMargin,
        bottom: bottomMargin
      },
      xScale: {
        type: "band",
        paddingInner: barPadding,
        paddingOuter: barPadding / 2
      },
      yScale: {
        type: "linear",
        domain: [0, yAxisMax]
      }
    },
    /* @__PURE__ */ React24.createElement(
      Grid2,
      {
        numTicksRows: NUM_Y_TICKS,
        columnTickValues: xAxisTicks,
        centerColumns: true
      }
    ),
    /* @__PURE__ */ React24.createElement(
      AxisLeft2,
      {
        label: axisLeftLabel,
        labelOffset: yAxisLabelOffset,
        numTicks: NUM_Y_TICKS,
        hideTicks: true,
        onWidthChange: (width) => setLeftMargin(width)
      }
    ),
    /* @__PURE__ */ React24.createElement(
      AxisBottom2,
      {
        label: axisBottomLabel,
        tickValues: xAxisTicks,
        tickFormat: xAxisTickFormat,
        onHeightChange: (height) => setBottomMargin(height)
      }
    ),
    Object.values(groupedByDate).filter(
      (datums) => datums.filter((datum) => accessors.yAccessor(datum) !== null).length > 0
    ).map((datums) => /* @__PURE__ */ React24.createElement(
      TooltipMarker,
      {
        data: datums,
        accessors,
        ariaLabel: ariaDatumLabel(datums)
      }
    )),
    data.filter((datum) => accessors.yAccessor(datum) !== null).map((datum) => {
      const shape = getDatumSymbol(datum);
      return /* @__PURE__ */ React24.createElement(
        RangeBar,
        {
          key: `bar-${accessors.xAccessor(datum)}:${accessors.yAccessor(
            datum
          )}`,
          datum,
          shape,
          accessors
        }
      );
    }),
    /* @__PURE__ */ React24.createElement(Tooltip, { snapToDatum: false }, renderTooltip)
  );
}

// src/components/charts/core/range-graph/masonry-range-graph-interval-selector.tsx
function MasonryRangeGraphIntervalSelector(_a) {
  var _b = _a, {
    interval
  } = _b, props = __objRest(_b, [
    "interval"
  ]);
  const defaultTimezone = useGetDefaultTimezone();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation6();
  if (interval === "weekly") {
    return /* @__PURE__ */ React25.createElement(
      MasonryRangeGraph,
      __spreadValues({
        xAxisTickFormat: (timestamp) => formatDateWithUserProfileLocation(timestamp, {
          weekday: "short"
        }),
        barPadding: 0.85
      }, props)
    );
  }
  if (interval === "monthly") {
    return /* @__PURE__ */ React25.createElement(
      MasonryRangeGraph,
      __spreadValues({
        xAxisTicks: getMonthlyXAxisTicks(
          props.data.map(props.accessors.xAccessor),
          defaultTimezone
        ),
        xAxisTickFormat: formatMonthlyTick(
          formatDateWithUserProfileLocation,
          defaultTimezone
        ),
        barPadding: 0.5
      }, props)
    );
  }
  if (interval === "yearly") {
    return /* @__PURE__ */ React25.createElement(
      MasonryRangeGraph,
      __spreadValues({
        xAxisTickFormat: (timestamp) => formatDateWithUserProfileLocation(timestamp, {
          month: "narrow"
        }),
        barPadding: 0.8
      }, props)
    );
  }
  if (interval === "5-yearly") {
    return /* @__PURE__ */ React25.createElement(
      MasonryRangeGraph,
      __spreadValues({
        xAxisTickFormat: (timestamp) => formatDateWithUserProfileLocation(timestamp, {
          year: "numeric"
        }),
        barPadding: 0.9
      }, props)
    );
  }
  return null;
}

// src/components/charts/core/line-graph/masonry-line-graph-interval-selector.tsx
import * as React32 from "react";
import { useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation7 } from "@leagueplatform/web-common";

// src/components/charts/core/line-graph/masonry-line-graph.tsx
import * as React31 from "react";

// src/components/charts/core/xychart/components/line-path.tsx
import * as React27 from "react";

// src/components/charts/core/xychart/primitives/LinePath.tsx
import * as React26 from "react";
import { LinePath as VisxLinePath } from "@visx/shape";
import { curveLinear } from "@visx/curve";
import { useTheme as useTheme10, useThemeRawValues as useThemeRawValues9 } from "@leagueplatform/genesis-core";
function LinePath(props) {
  var _a;
  const theme = useTheme10();
  const rawTheme = useThemeRawValues9();
  return /* @__PURE__ */ React26.createElement(
    VisxLinePath,
    __spreadValues({
      stroke: (_a = theme.colors.dataVizSingleColorBrand) != null ? _a : theme.colors.decorativeBrandPrimaryDark,
      strokeWidth: rawTheme.space.quarter,
      curve: curveLinear
    }, props)
  );
}

// src/components/charts/core/xychart/components/line-path.tsx
var compose3 = (scale, accessor) => (d) => scale(accessor(d));
function LinePath2(_a) {
  var _b = _a, {
    accessors,
    data
  } = _b, props = __objRest(_b, [
    "accessors",
    "data"
  ]);
  const { xScale, yScale } = useChart();
  const xPoint = compose3(xScale, accessors.xAccessor);
  const yPoint = compose3(yScale, accessors.yAccessor);
  return /* @__PURE__ */ React27.createElement(
    LinePath,
    __spreadValues({
      x: (d) => xPoint(d),
      y: (d) => yPoint(d),
      data: data == null ? void 0 : data.filter((d) => yPoint(d) !== void 0)
    }, props)
  );
}

// src/components/charts/core/xychart/components/circles.tsx
import * as React30 from "react";

// src/components/charts/core/xychart/components/circle.tsx
import * as React29 from "react";

// src/components/charts/core/xychart/primitives/Circle.tsx
import * as React28 from "react";
import { Circle as VisxCircle } from "@visx/shape";
import { useTheme as useTheme11, useThemeRawValues as useThemeRawValues10 } from "@leagueplatform/genesis-core";
function Circle2(props) {
  var _a;
  const theme = useTheme11();
  const rawTheme = useThemeRawValues10();
  const strokeWidth = rawTheme.space.quarter;
  const radii = (rawTheme.space.one + strokeWidth) / 2;
  return /* @__PURE__ */ React28.createElement(
    VisxCircle,
    __spreadValues({
      tabIndex: 0,
      fill: (_a = theme.colors.dataVizSingleColorBrand) != null ? _a : theme.colors.decorativeBrandPrimaryDark,
      stroke: theme.colors.surfaceBackgroundPrimary,
      strokeWidth,
      r: radii,
      style: {
        // Adds radius to the outline when focused.
        borderRadius: radii
      }
    }, props)
  );
}

// src/components/charts/core/xychart/components/circle.tsx
var compose4 = (scale, accessor) => (d) => scale(accessor(d));
function Circle3(_a) {
  var _b = _a, {
    accessors,
    datum
  } = _b, props = __objRest(_b, [
    "accessors",
    "datum"
  ]);
  const { xScale, yScale } = useChart();
  const { showTooltip, hideTooltip } = useTooltip();
  const xPoint = compose4(xScale, accessors.xAccessor);
  const yPoint = compose4(yScale, accessors.yAccessor);
  const x = xPoint(datum);
  const y = yPoint(datum);
  const handleShowTooltip = () => {
    showTooltip({
      tooltipData: datum,
      tooltipLeft: x,
      tooltipTop: y
    });
  };
  const handleHideTooltip = () => {
    hideTooltip();
  };
  return /* @__PURE__ */ React29.createElement(
    Circle2,
    __spreadValues({
      cx: x,
      cy: y,
      onFocus: handleShowTooltip,
      onMouseEnter: handleShowTooltip,
      onMouseLeave: handleHideTooltip,
      onBlur: handleHideTooltip
    }, props)
  );
}

// src/components/charts/core/xychart/components/circles.tsx
function Circles({
  accessors,
  data,
  ariaDatumLabel
}) {
  return /* @__PURE__ */ React30.createElement(React30.Fragment, null, data.filter((datum) => accessors.yAccessor(datum) != null).map((datum) => /* @__PURE__ */ React30.createElement(
    Circle3,
    {
      key: `circle-${accessors.xAccessor(datum)}:${accessors.yAccessor(
        datum
      )}`,
      datum,
      accessors,
      "aria-label": ariaDatumLabel(datum)
    }
  )));
}

// src/components/charts/core/line-graph/masonry-line-graph.tsx
var NUM_Y_TICKS2 = 5;
function MasonryLineGraph({
  data,
  accessors,
  title,
  description,
  axisLeftLabel,
  ariaDatumLabel,
  axisBottomLabel,
  renderTooltip,
  pointPadding,
  yAxisMax,
  xAxisTicks,
  xAxisTickFormat
}) {
  const yAxisLabelOffset = useGetLeftAxisLabelOffset(yAxisMax);
  const [leftMargin, setLeftMargin] = React31.useState(0);
  const [bottomMargin, setBottomMargin] = React31.useState(0);
  return /* @__PURE__ */ React31.createElement(
    XYChart,
    {
      title,
      desc: description,
      data,
      accessors,
      margin: {
        left: leftMargin,
        bottom: bottomMargin
      },
      xScale: {
        type: "point",
        padding: pointPadding
      },
      yScale: {
        type: "linear",
        domain: [0, yAxisMax]
      }
    },
    /* @__PURE__ */ React31.createElement(
      Grid2,
      {
        numTicksRows: NUM_Y_TICKS2,
        columnTickValues: xAxisTicks,
        centerColumns: true
      }
    ),
    /* @__PURE__ */ React31.createElement(
      AxisLeft2,
      {
        label: axisLeftLabel,
        labelOffset: yAxisLabelOffset,
        numTicks: NUM_Y_TICKS2,
        hideTicks: true,
        onWidthChange: (width) => setLeftMargin(width)
      }
    ),
    /* @__PURE__ */ React31.createElement(
      AxisBottom2,
      {
        label: axisBottomLabel,
        tickValues: xAxisTicks,
        tickFormat: xAxisTickFormat,
        onHeightChange: (height) => setBottomMargin(height)
      }
    ),
    /* @__PURE__ */ React31.createElement(LinePath2, { accessors, data }),
    /* @__PURE__ */ React31.createElement(
      Circles,
      {
        ariaDatumLabel,
        accessors,
        data
      }
    ),
    /* @__PURE__ */ React31.createElement(Tooltip, { snapToDatum: true }, renderTooltip)
  );
}

// src/components/charts/core/line-graph/masonry-line-graph-interval-selector.tsx
function MasonryLineGraphIntervalSelector(_a) {
  var _b = _a, {
    interval
  } = _b, props = __objRest(_b, [
    "interval"
  ]);
  const defaultTimezone = useGetDefaultTimezone();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation7();
  if (interval === "weekly") {
    return /* @__PURE__ */ React32.createElement(
      MasonryLineGraph,
      __spreadValues({
        xAxisTickFormat: (timestamp) => formatDateWithUserProfileLocation(timestamp, {
          weekday: "short"
        }),
        pointPadding: 0.5
      }, props)
    );
  }
  if (interval === "monthly") {
    return /* @__PURE__ */ React32.createElement(
      MasonryLineGraph,
      __spreadValues({
        xAxisTicks: getMonthlyXAxisTicks(
          props.data.map(props.accessors.xAccessor),
          defaultTimezone
        ),
        xAxisTickFormat: formatMonthlyTick(
          formatDateWithUserProfileLocation,
          defaultTimezone
        ),
        pointPadding: 0.5
      }, props)
    );
  }
  if (interval === "yearly") {
    return /* @__PURE__ */ React32.createElement(
      MasonryLineGraph,
      __spreadValues({
        xAxisTickFormat: (timestamp) => formatDateWithUserProfileLocation(timestamp, {
          month: "narrow"
        }),
        pointPadding: 0.5
      }, props)
    );
  }
  if (interval === "5-yearly") {
    return /* @__PURE__ */ React32.createElement(
      MasonryLineGraph,
      __spreadValues({
        xAxisTickFormat: (timestamp) => formatDateWithUserProfileLocation(timestamp, {
          year: "numeric"
        }),
        pointPadding: 0.5
      }, props)
    );
  }
  return null;
}

// src/components/charts/core/chart-tooltip/v3/multiple-measurements-tooltipV3.tsx
import * as React35 from "react";
import {
  StackItem,
  StackLayout as StackLayout2,
  UtilityText as UtilityText2
} from "@leagueplatform/genesis-core";

// src/pages/details2/components/datum-legend.tsx
import * as React33 from "react";
import {
  StackLayout,
  HeadingText,
  UtilityText
} from "@leagueplatform/genesis-core";
function DatumValueWithUnit({
  size = "normal",
  value,
  unit
}) {
  return /* @__PURE__ */ React33.createElement("div", { style: { whiteSpace: "nowrap" } }, /* @__PURE__ */ React33.createElement(
    UtilityText,
    {
      css: { typography: size === "normal" ? "$headingOne" : "$headingTwo" }
    },
    value,
    " "
  ), /* @__PURE__ */ React33.createElement(UtilityText, { emphasis: "subtle", css: { typography: "$bodyOne" } }, unit));
}
function DatumLegend({
  size = "normal",
  shape,
  name,
  value,
  unit
}) {
  return /* @__PURE__ */ React33.createElement(React33.Fragment, null, /* @__PURE__ */ React33.createElement(
    StackLayout,
    {
      orientation: "horizontal",
      verticalAlignment: "center",
      spacing: "$quarter"
    },
    shape && /* @__PURE__ */ React33.createElement(ShapeIcon, { shape }),
    /* @__PURE__ */ React33.createElement(
      HeadingText,
      {
        level: "4",
        size: size === "normal" ? "md" : "xs",
        emphasis: "subtle"
      },
      name
    )
  ), /* @__PURE__ */ React33.createElement(DatumValueWithUnit, { size, value, unit }));
}

// src/components/charts/core/chart-tooltip/v3/multiple-measurements-tooltipV3.tsx
import { useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation8 } from "@leagueplatform/web-common";

// src/utils/get-health-metric-display-value.ts
function getHealthMetricDisplayValue({
  value,
  label
}) {
  const values = label != null ? label : value;
  if (Array.isArray(values)) {
    return values.join("-");
  }
  if (values === null) {
    return "-";
  }
  return values.toString();
}

// src/utils/get-health-metric-unit-display-value.ts
function getHealthMetricUnitDisplayValue(value, unit) {
  if (!unit) {
    return "";
  }
  const { symbol, namePlural, name } = unit;
  if (symbol) {
    return symbol;
  }
  if (namePlural && value != 1) {
    return namePlural;
  }
  return name;
}

// src/components/charts/core/chart-tooltip/chart-tooltip.tsx
import * as React34 from "react";
import { Box } from "@leagueplatform/genesis-core";
function ChartTooltip({ children }) {
  return /* @__PURE__ */ React34.createElement(
    Box,
    {
      css: {
        width: "fit-content",
        transform: "translateY(-100%)",
        marginInlineStart: "-50%",
        padding: "$half",
        borderRadius: "$small",
        borderWidth: "$thick",
        borderStyle: "solid",
        borderColor: "$decorativeBrandPrimaryDark",
        backgroundColor: "$interactiveBackgroundDefault",
        "&:after": {
          content: '""',
          borderBottom: "2px solid",
          borderInlineEnd: "2px solid",
          borderColor: "$decorativeBrandPrimaryDark",
          position: "absolute",
          insetInlineStart: "50%",
          insetInlineEnd: "0",
          bottom: "-9px",
          width: "15px",
          height: "15px",
          transform: "translateX(-50%) rotate(45deg)",
          backgroundColor: "$interactiveBackgroundDefault"
        }
      }
    },
    children
  );
}

// src/components/charts/core/chart-tooltip/v3/utils/interval-format-map.ts
var intervalDateFormatMap = {
  weekly: {
    year: "numeric",
    month: "long",
    day: "numeric"
  },
  monthly: {
    year: "numeric",
    month: "long",
    day: "numeric"
  },
  yearly: {
    year: "numeric",
    month: "long"
  },
  "5-yearly": {
    year: "numeric"
  }
};

// src/components/charts/core/chart-tooltip/v3/multiple-measurements-tooltipV3.tsx
function MultipleMeasurementsTooltipV3({
  data,
  interval
}) {
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation8();
  return /* @__PURE__ */ React35.createElement(ChartTooltip, null, /* @__PURE__ */ React35.createElement(StackLayout2, { spacing: "$half" }, data.map((datum) => {
    const shape = shapes[datum.metric.data.order];
    const value = getHealthMetricDisplayValue(datum);
    const unit = getHealthMetricUnitDisplayValue(
      value,
      datum.metric.data.unit
    );
    return /* @__PURE__ */ React35.createElement(StackItem, null, /* @__PURE__ */ React35.createElement(
      DatumLegend,
      {
        size: "small",
        shape: data.length > 1 ? shape : void 0,
        name: datum.metric.data.name.toUpperCase(),
        value,
        unit
      }
    ));
  }), /* @__PURE__ */ React35.createElement(UtilityText2, { size: "eyebrow" }, formatDateWithUserProfileLocation(
    data[0].timestamp,
    intervalDateFormatMap[interval]
  ))));
}

// src/components/charts/core/chart-tooltip/v3/single-measurement-tooltipV3.tsx
import * as React36 from "react";
import { useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation9 } from "@leagueplatform/web-common";
import {
  Box as Box2,
  StackLayout as StackLayout3,
  StatusBadge,
  UtilityText as UtilityText3
} from "@leagueplatform/genesis-core";

// src/utils/get-value-unit-display-label.ts
function getValueUnitDisplayLabel({
  unitOptions,
  value,
  label
}) {
  const displayValue = getHealthMetricDisplayValue({ value, label });
  const unit = getHealthMetricUnitDisplayValue(displayValue, unitOptions);
  if (displayValue.includes(";")) {
    const arrayOfSubUnits = displayValue == null ? void 0 : displayValue.split(";").map((str) => str.split("|"));
    return arrayOfSubUnits;
  }
  return [[displayValue, unit]];
}

// src/components/charts/core/chart-tooltip/v3/single-measurement-tooltipV3.tsx
function SingleMeasurementTooltipV3({
  datum,
  interval
}) {
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation9();
  return /* @__PURE__ */ React36.createElement(ChartTooltip, null, /* @__PURE__ */ React36.createElement(StackLayout3, { spacing: "$quarter" }, /* @__PURE__ */ React36.createElement(
    UtilityText3,
    {
      size: "xs",
      emphasis: "subtle",
      css: { typography: "$overline" }
    },
    datum.aggregationStrategyLabel ? datum.aggregationStrategyLabel : datum.metric.data.name
  ), /* @__PURE__ */ React36.createElement(StackLayout3, { orientation: "horizontal", spacing: "$half" }, getValueUnitDisplayLabel({
    value: datum.value,
    label: datum.label,
    unitOptions: datum.metric.data.unit
  }).map(([displayValue, displayUnit], index) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ React36.createElement(Box2, { key: `${index} + ${datum.type}` }, /* @__PURE__ */ React36.createElement(UtilityText3, { as: "span", css: { typography: "$headingOne" } }, displayValue), " ", /* @__PURE__ */ React36.createElement(UtilityText3, { emphasis: "subtle", css: { typography: "$bodyOne" } }, displayUnit))
  ))), datum.indicator ? /* @__PURE__ */ React36.createElement(
    StatusBadge,
    {
      showLight: false,
      label: datum.indicator.label,
      status: datum.indicator.style
    }
  ) : null, /* @__PURE__ */ React36.createElement(UtilityText3, { size: "eyebrow" }, formatDateWithUserProfileLocation(
    datum.timestamp,
    intervalDateFormatMap[interval]
  ))));
}

// src/pages/details3/hooks/use-datum-label.ts
import {
  DATE_FORMAT,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation10
} from "@leagueplatform/web-common";
var generateLabel = (singleDatum) => {
  if (singleDatum.value === null) {
    return "";
  }
  const metricName = singleDatum.metric.data.name;
  const value = Array.isArray(singleDatum.value) ? singleDatum.value.join("\u2013") : singleDatum.value;
  const unitName = getHealthMetricUnitDisplayValue(
    singleDatum.value,
    singleDatum.metric.data.unit
  );
  return `${metricName} ${value} ${unitName}`;
};
function useDatumLabel() {
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation10();
  return (datum) => {
    if (Array.isArray(datum)) {
      const label2 = datum.filter((d) => d.value !== null).map(generateLabel);
      const date2 = formatDateWithUserProfileLocation(
        new Date(datum[0].timestamp),
        DATE_FORMAT
      );
      if (label2.length === 0) {
        return "";
      }
      return `${date2}, ${label2.join(", ")}`;
    }
    if (datum.value === null) {
      return "";
    }
    const label = generateLabel(datum);
    const date = formatDateWithUserProfileLocation(
      new Date(datum.timestamp),
      DATE_FORMAT
    );
    return `${date}, ${label}`;
  };
}

// src/node-renderers/chart-renderer/utils/convert-masonry-chart-to-health-metric-data.ts
function convertMasonryChartToHealthMetricData(dataset, dataPointTypes) {
  const dataPointTypeMap = new Map(
    dataPointTypes.map((dataPointType) => [dataPointType.id, dataPointType])
  );
  const chartData = dataset.map((dataPoint) => {
    var _a, _b, _c;
    const metricComponent = dataPointTypeMap.get(dataPoint.dataPointType);
    const { unit } = metricComponent;
    return {
      timestamp: dataPoint.timestamp,
      value: (_a = dataPoint.value) != null ? _a : null,
      label: (_b = dataPoint.label) != null ? _b : "",
      aggregationStrategyLabel: dataPoint.aggregationStrategyLabel,
      indicator: dataPoint.indicator,
      metricComponent: {
        data: __spreadProps(__spreadValues({}, metricComponent), {
          unit: unit ? __spreadProps(__spreadValues({}, unit), {
            symbol: (_c = unit.symbol) != null ? _c : null
          }) : void 0
        })
      }
    };
  });
  return chartData;
}

// src/node-renderers/chart-renderer/chart.component.tsx
function Chart({
  chartType,
  interval,
  screenReaderTitle,
  screenReaderDescription,
  yAxisLabel,
  yAxisMax,
  xAxisLabel,
  dataset,
  dataPointTypes
}) {
  const generateDatumLabel = useDatumLabel();
  const chartData = React37.useMemo(
    () => convertMasonryChartToHealthMetricData(dataset, dataPointTypes),
    [dataset, dataPointTypes]
  );
  const data = useHealthMetricValuesV3(chartData);
  switch (chartType) {
    case "bar": {
      return /* @__PURE__ */ React37.createElement(
        MasonryBarGraphIntervalSelector,
        {
          interval,
          data,
          accessors: {
            xAccessor: (datum) => datum.timestamp,
            yAccessor: (datum) => datum.value
          },
          title: screenReaderTitle,
          description: screenReaderDescription,
          axisLeftLabel: yAxisLabel,
          axisBottomLabel: xAxisLabel,
          ariaDatumLabel: generateDatumLabel,
          renderTooltip: (datum) => /* @__PURE__ */ React37.createElement(SingleMeasurementTooltipV3, { datum, interval }),
          yAxisMax
        }
      );
    }
    case "line": {
      return /* @__PURE__ */ React37.createElement(
        MasonryLineGraphIntervalSelector,
        {
          interval,
          data,
          accessors: {
            xAccessor: (datum) => datum.timestamp,
            yAccessor: (datum) => datum.value
          },
          title: screenReaderTitle,
          description: screenReaderDescription,
          axisLeftLabel: yAxisLabel,
          axisBottomLabel: xAxisLabel,
          ariaDatumLabel: generateDatumLabel,
          renderTooltip: (datum) => /* @__PURE__ */ React37.createElement(SingleMeasurementTooltipV3, { datum, interval }),
          yAxisMax
        }
      );
    }
    case "range": {
      return /* @__PURE__ */ React37.createElement(
        MasonryRangeGraphIntervalSelector,
        {
          interval,
          data,
          accessors: {
            xAccessor: (datum) => datum.timestamp,
            yAccessor: (datum) => datum.value
          },
          title: screenReaderTitle,
          description: screenReaderDescription,
          axisLeftLabel: yAxisLabel,
          axisBottomLabel: xAxisLabel,
          ariaDatumLabel: generateDatumLabel,
          getDatumSymbol: (datum) => shapes[datum.metric.data.order],
          renderTooltip: (datum) => /* @__PURE__ */ React37.createElement(MultipleMeasurementsTooltipV3, { data: datum, interval }),
          yAxisMax
        }
      );
    }
    default:
      throw new Error(`Unsupported chart type ${chartType} was specified`);
  }
}

// src/node-renderers/chart-renderer/chart-renderer.tsx
function ChartRenderer({
  chartType,
  interval,
  screenReaderTitle,
  screenReaderDescription,
  yAxisLabel,
  yAxisMax,
  xAxisLabel,
  dataset,
  dataPointTypes,
  items
}) {
  return /* @__PURE__ */ React38.createElement(React38.Fragment, null, items, /* @__PURE__ */ React38.createElement(Box3, { css: { height: 500, width: "100%", marginBottom: "$twoAndHalf" } }, /* @__PURE__ */ React38.createElement(
    Chart,
    {
      chartType,
      interval,
      screenReaderTitle,
      screenReaderDescription,
      yAxisLabel,
      yAxisMax,
      xAxisLabel,
      dataset,
      dataPointTypes
    }
  )));
}

// src/node-renderers/infinite-pagination-renderer/infinite-pagination-renderer.tsx
import React41 from "react";

// src/node-renderers/infinite-pagination-renderer/use-pagination-action.ts
import React39 from "react";
import { useInvokeAction } from "@leagueplatform/masonry";
function usePaginationAction({
  from,
  nodeIds
}) {
  const invokeAction = useInvokeAction();
  const paginationAction = React39.useCallback(
    (event) => {
      invokeAction({
        event,
        type: "reload",
        namespace: "default",
        payload: {
          renderIntermediately: "self",
          nodeIds,
          queryParams: { from }
        }
      });
    },
    [invokeAction, nodeIds, from]
  );
  return paginationAction;
}

// src/node-renderers/infinite-pagination-renderer/infinite-pagination.component.tsx
import React40 from "react";
import { Button, HeadingText as HeadingText2, StackLayout as StackLayout4 } from "@leagueplatform/genesis-core";
function InfinitePagination({
  currentPageLabel,
  nextPageLabel,
  previousPageLabel,
  previousPageCursor,
  nextPageCursor,
  onNextPage,
  onPreviousPage,
  isLoading = false
}) {
  const [isPreviousPageLoading, setIsPrevousPageLoading] = React40.useState(false);
  const [isNextPageLoading, setIsNextPageLoading] = React40.useState(false);
  React40.useEffect(() => {
    if (!isLoading) {
      setIsNextPageLoading(false);
      setIsPrevousPageLoading(false);
    }
  }, [isLoading]);
  return /* @__PURE__ */ React40.createElement(
    StackLayout4,
    {
      orientation: "horizontal",
      verticalAlignment: "center",
      horizontalAlignment: "spaceBetween"
    },
    /* @__PURE__ */ React40.createElement(
      Button,
      {
        icon: "interfaceChevronLeft",
        priority: "secondary",
        quiet: true,
        hideLabel: true,
        disabled: !previousPageCursor,
        onClick: (event) => {
          setIsPrevousPageLoading(true);
          onPreviousPage == null ? void 0 : onPreviousPage(event);
        },
        loading: isPreviousPageLoading
      },
      previousPageLabel
    ),
    /* @__PURE__ */ React40.createElement(
      HeadingText2,
      {
        level: "2",
        size: {
          "@initial": "xxl",
          "@mobile": "sm"
        }
      },
      currentPageLabel
    ),
    /* @__PURE__ */ React40.createElement(
      Button,
      {
        icon: "interfaceChevronRight",
        priority: "secondary",
        quiet: true,
        hideLabel: true,
        disabled: !nextPageCursor,
        onClick: (event) => {
          setIsNextPageLoading(true);
          onNextPage == null ? void 0 : onNextPage(event);
        },
        loading: isNextPageLoading
      },
      nextPageLabel
    )
  );
}

// src/node-renderers/infinite-pagination-renderer/infinite-pagination-renderer.tsx
function InfinitePaginationNodeRenderer({
  previousPageCursor,
  nextPageCursor,
  currentPageLabel,
  nextPageLabel,
  previousPageLabel,
  nodeId,
  reloadNodeIds,
  isReloading
}) {
  const nodeIds = [nodeId, ...reloadNodeIds];
  const onPreviousPage = usePaginationAction({
    from: previousPageCursor,
    nodeIds
  });
  const onNextPage = usePaginationAction({
    from: nextPageCursor,
    nodeIds
  });
  return /* @__PURE__ */ React41.createElement(
    InfinitePagination,
    {
      currentPageLabel,
      previousPageLabel,
      previousPageCursor,
      onPreviousPage,
      nextPageLabel,
      nextPageCursor,
      onNextPage,
      isLoading: isReloading
    }
  );
}

// src/node-renderers/overview-panel-renderer/overview-panel-renderer.tsx
import React43 from "react";

// src/node-renderers/overview-panel-renderer/overview-panel.component.tsx
import React42 from "react";
import {
  Box as Box4,
  HeadingText as HeadingText3,
  StackItem as StackItem2,
  StackLayout as StackLayout5,
  UtilityText as UtilityText4
} from "@leagueplatform/genesis-core";
function OverviewPanel({ items }) {
  return /* @__PURE__ */ React42.createElement(
    StackLayout5,
    {
      orientation: "horizontal",
      horizontalAlignment: "center",
      spacing: "$three"
    },
    items.map(({ titleText, textBlocks, order }) => {
      const shape = order != null ? shapes[order] : null;
      return /* @__PURE__ */ React42.createElement(StackItem2, { horizontalAlignment: "center", key: titleText }, /* @__PURE__ */ React42.createElement(
        StackLayout5,
        {
          orientation: "horizontal",
          verticalAlignment: "center",
          spacing: "$quarter"
        },
        shape && /* @__PURE__ */ React42.createElement(ShapeIcon, { shape }),
        /* @__PURE__ */ React42.createElement(HeadingText3, { level: "4", size: "md", emphasis: "subtle" }, titleText.toLocaleUpperCase())
      ), /* @__PURE__ */ React42.createElement(StackLayout5, { orientation: "horizontal", spacing: "$half" }, textBlocks.map(({ heroText, subText }) => /* @__PURE__ */ React42.createElement(Box4, { css: { whiteSpace: "nowrap" } }, /* @__PURE__ */ React42.createElement(
        UtilityText4,
        {
          css: {
            typography: "$headingOne",
            marginInlineEnd: "$quarter"
          }
        },
        heroText
      ), subText ? /* @__PURE__ */ React42.createElement(
        UtilityText4,
        {
          emphasis: "subtle",
          css: {
            typography: "$bodyOne"
          }
        },
        subText
      ) : null))));
    })
  );
}

// src/node-renderers/overview-panel-renderer/overview-panel-renderer.tsx
function OverviewPanelRenderer({
  items
}) {
  return /* @__PURE__ */ React43.createElement(OverviewPanel, { items });
}

// src/node-renderers/paginated-chart-renderer/paginated-chart-renderer.tsx
import * as React44 from "react";
import { Box as Box5 } from "@leagueplatform/genesis-core";
function PaginatedChartRenderer({
  pagination,
  chart,
  nodeId,
  isReloading
}) {
  const onPreviousPage = usePaginationAction({
    from: pagination.previousPageCursor,
    nodeIds: [nodeId]
  });
  const onNextPage = usePaginationAction({
    from: pagination.nextPageCursor,
    nodeIds: [nodeId]
  });
  return /* @__PURE__ */ React44.createElement(React44.Fragment, null, /* @__PURE__ */ React44.createElement(
    InfinitePagination,
    {
      currentPageLabel: pagination.currentPageLabel,
      previousPageLabel: pagination.previousPageLabel,
      previousPageCursor: pagination.previousPageCursor,
      onPreviousPage,
      nextPageLabel: pagination.nextPageLabel,
      nextPageCursor: pagination.nextPageCursor,
      onNextPage,
      isLoading: isReloading
    }
  ), chart.items, /* @__PURE__ */ React44.createElement(Box5, { css: { height: 500, width: "100%", marginBottom: "$twoAndHalf" } }, /* @__PURE__ */ React44.createElement(
    Chart,
    {
      chartType: chart.chartType,
      interval: chart.interval,
      screenReaderTitle: chart.screenReaderTitle,
      screenReaderDescription: chart.screenReaderDescription,
      yAxisLabel: chart.yAxisLabel,
      yAxisMax: chart.yAxisMax,
      xAxisLabel: chart.xAxisLabel,
      dataset: chart.dataset,
      dataPointTypes: chart.dataPointTypes
    }
  )));
}

// src/node-handlers.ts
var DASHBOARD_MASONRY_HANDLERS = {
  DASHBOARD_METRIC_DETAILS_EMPTY_STATE_PRIMARY_CTA: "dashboard_metric_details_empty_state_primary_cta",
  DASHBOARD_METRIC_DETAILS_EMPTY_STATE_SECONDARY_CTA: "dashboard_metric_details_empty_state_secondary_cta"
};

// src/init-masonry-registry.ts
function initMasonryRegistry() {
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "default",
    "chart",
    ChartRenderer
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "default",
    "infinitePagination",
    InfinitePaginationNodeRenderer
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "default",
    "overviewPanel",
    OverviewPanelRenderer
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "default",
    "paginatedChart",
    PaginatedChartRenderer
  );
  MasonryDriverActionController.registerHandler(
    "deeplink",
    DASHBOARD_MASONRY_HANDLERS.DASHBOARD_METRIC_DETAILS_EMPTY_STATE_PRIMARY_CTA,
    ({ event }) => {
      event == null ? void 0 : event.preventDefault();
    }
  );
  MasonryDriverActionController.registerHandler(
    "deeplink",
    DASHBOARD_MASONRY_HANDLERS.DASHBOARD_METRIC_DETAILS_EMPTY_STATE_SECONDARY_CTA,
    ({ event }) => {
      event == null ? void 0 : event.preventDefault();
    }
  );
}

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import activityIcon from "./assets/activity-icon.svg";
import appleHealth from "./assets/apple-health.png";
import biotelcare from "./assets/bio-tel-care.png";
import bloodIcon from "./assets/blood-icon.svg";
import bodyIcon from "./assets/body-icon.svg";
import checkmarkIcon from "./assets/checkmark-icon.svg";
import checkmarkSuccessIcon from "./assets/checkmark-success-icon.svg";
import checkWithCircle from "./assets/check-with-circle.png";
import chevronRight from "./assets/chevron-right.svg";
import exclamationMarkIcon from "./assets/exclamation-mark-icon.svg";
import fitbit from "./assets/fitbit.png";
import garmin from "./assets/garmin.png";
import googleFit from "./assets/google-fit.png";
import heartIcon from "./assets/heart-icon.svg";
import iglucose from "./assets/i-glucose.png";
import iHealth from "./assets/i-health.png";
import loseIt from "./assets/lose-it.png";
import mindfulnessIcon from "./assets/mindfulness-icon.svg";
import misfit from "./assets/misfit.png";
import noData from "./assets/no-data.svg";
import noDataSource from "./assets/no_data_source_icon.png";
import distanceLiteracyPlaceholder from "./assets/distance-literacy.png";
import omron from "./assets/omron.png";
import polar from "./assets/polar.png";
import samsungHealth from "./assets/samsung.png";
import sleepIcon from "./assets/sleep-icon.svg";
import startTracking from "./assets/start-tracking.png";
import strava from "./assets/strava.png";
import underArmour from "./assets/under-armour.png";
import warningIcon from "./assets/warning-icon.svg";
import withings from "./assets/withings.png";
import healthPlan from "./assets/health-plan.png";
import xWithCircle from "./assets/x-with-circle.png";
import yoo from "./assets/yoo.png";
import androidHealthConnect from "./assets/android-health-connect.svg";
var DASHBOARD_ASSETS = {
  DASHBOARD_START_TRACKING_INSIGHTS: startTracking,
  DASHBOARD_NO_HEALTH_METRIC_DATA: noData,
  DASHBOARD_DISTANCE_LITERACY_PLACEHOLDER: distanceLiteracyPlaceholder,
  DASHBOARD_APPLE_HEALTH: appleHealth,
  DASHBOARD_FITBIT: fitbit,
  DASHBOARD_GARMIN: garmin,
  DASHBOARD_GOOGLE_FIT: googleFit,
  DASHBOARD_I_HEALTH: iHealth,
  DASHBOARD_OMRON: omron,
  DASHBOARD_POLAR: polar,
  DASHBOARD_SAMSUNG_HEALTH: samsungHealth,
  DASHBOARD_STRAVA: strava,
  DASHBOARD_WITHINGS: withings,
  DASHBOARD_HEALTH_PLAN: healthPlan,
  DASHBOARD_NO_DATA_SOURCE: noDataSource,
  // DASHBOARD_BLUETOOTH: bluetooth,
  // DASHBOARD_VITALSNAP: vitalSnap,
  DASHBOARD_I_GLUCOSE: iglucose,
  DASHBOARD_BIO_TEL_CARE: biotelcare,
  DASHBOARD_LOSE_IT: loseIt,
  DASHBOARD_MISFIT: misfit,
  DASHBOARD_UNDER_ARMOUR: underArmour,
  DASHBOARD_YOO: yoo,
  DASHBOARD_ACTIVITY_ICON: activityIcon,
  DASHBOARD_SLEEP_ICON: sleepIcon,
  DASHBOARD_HEART_ICON: heartIcon,
  DASHBOARD_BLOOD_ICON: bloodIcon,
  DASHBOARD_BODY_ICON: bodyIcon,
  DASHBOARD_MINDFULNESS_ICON: mindfulnessIcon,
  DASHBOARD_CHECKMARK_ICON: checkmarkIcon,
  DASHBOARD_CHECKMARK_SUCCESS_ICON: checkmarkSuccessIcon,
  DASHBOARD_CHEVRON_RIGHT: chevronRight,
  DASHBOARD_WARNING_ICON: warningIcon,
  DASHBOARD_EXCLAMATION_MARK_ICON: exclamationMarkIcon,
  DASHBOARD_CHECK_WITH_CIRCLE: checkWithCircle,
  DASHBOARD_X_WITH_CIRCLE: xWithCircle,
  DASHBOARD_ANDROID_HEALTH_CONNECT: androidHealthConnect
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(DASHBOARD_ASSETS);
};

// src/hooks/use-is-dashboard-enabled.ts
import { useFeatureFlagQuery } from "@leagueplatform/user-profile-api";
var useIsDashboardEnabled = () => {
  const ENABLE_DASHBOARD_WEB = "enable_dashboard_web";
  const ENABLE_DASHBOARD_BE = "enable_dashboard";
  const { isLoading: isWebLoading, data: isDashboardWebEnabled } = useFeatureFlagQuery(ENABLE_DASHBOARD_WEB);
  const { isLoading: isBeLoading, data: isDashboardBeEnabled } = useFeatureFlagQuery(ENABLE_DASHBOARD_BE);
  const isDashboardEnabled = isDashboardWebEnabled && isDashboardBeEnabled;
  const isLoading = isWebLoading || isBeLoading;
  return {
    isLoading,
    isDashboardEnabled
  };
};

// src/dashboard.routes.tsx
import React126 from "react";

// src/pages/insights-page/insights-page.tsx
import * as React57 from "react";
import { useIntl as useIntl10 } from "@leagueplatform/locales";
import {
  HealthProfilePageWrapper,
  MoreOptionsCard,
  AddAppsDevicesLink
} from "@leagueplatform/health-profile-common";
import { Sidebar } from "@leagueplatform/web-common-components";
import { RewardsSidebarCard } from "@leagueplatform/rewards-achievements";

// src/components/manage-units-modal/manage-units-modal.tsx
import React47 from "react";
import {
  genesisStyled as genesisStyled2,
  VisuallyHidden as VisuallyHidden2,
  HeadingThree,
  Flex as Flex3,
  Image as Image2,
  BodyTwo,
  Spinner
} from "@leagueplatform/genesis-commons";
import { Modal, StackLayout as StackLayout6, Box as Box8, Button as Button3 } from "@leagueplatform/genesis-core";
import { useQueryClient as useQueryClient2 } from "@tanstack/react-query";
import { GET_WIDGET_DATA } from "@leagueplatform/masonry-api";
import { Icon as Icon2, ICONS } from "@leagueplatform/ui-kit";
import { useIntl as useIntl4 } from "@leagueplatform/locales";
import {
  HighlightBanner,
  SkeletonBox
} from "@leagueplatform/web-common-components";

// src/components/unit-switcher/unit-switcher.tsx
import * as React45 from "react";
import {
  Flex,
  genesisStyled,
  css,
  Box as Box6,
  Overline,
  Label,
  VisuallyHidden,
  Radio
} from "@leagueplatform/genesis-commons";
import { Icon } from "@leagueplatform/genesis-core";
var RadioContainer = genesisStyled(Flex)`
  width: 100%;
  border: none;
  label:last-child {
    border-start-start-radius: 0;
    border-start-end-radius: 100px;
    border-end-end-radius: 100px;
    border-end-start-radius: 0;
  }
`;
var RadioLabel = genesisStyled(Label)(
  ({ isSelected }) => css({
    backgroundColor: isSelected ? "decorative.brand.primary.pastel" : "surface.background.primary",
    color: isSelected ? "onSurface.text.primary" : "onSurface.text.subdued",
    fontWeight: "600",
    borderStartStartRadius: "100px",
    borderStartEndRadius: "0",
    borderEndEndRadius: "0",
    borderEndStartRadius: "100px",
    paddingInlineStart: "one",
    paddingInlineEnd: "oneAndHalf",
    paddingY: "half",
    borderColor: isSelected ? "interactive.action.primary" : "onSurface.border.subdued",
    borderStyle: "solid",
    borderWidth: "thin",
    width: "100%",
    minHeight: "42px",
    "& > span": {
      position: "relative",
      paddingX: "oneAndHalf",
      lineHeight: "button2",
      fontSize: "button2"
    },
    "&:hover": {
      backgroundColor: "decorative.brand.primary.pastel",
      boxShadow: "focusOutline",
      zIndex: "9"
    },
    "&:focus-within": {
      backgroundColor: "decorative.brand.primary.pastel",
      boxShadow: "focusOutline",
      zIndex: "9"
    }
  })
);
var SelectedIcon = genesisStyled(Icon)(
  css({
    position: "absolute",
    insetInlineStart: "0",
    top: "50%",
    transform: "translateY(-50%)"
  })
);
function UnitSwitcher({
  selectedUnit,
  onChange,
  units,
  title
}) {
  return /* @__PURE__ */ React45.createElement(Box6, { as: "fieldset" }, /* @__PURE__ */ React45.createElement(Overline, { as: "legend", paddingBottom: "half", textTransform: "uppercase" }, title), /* @__PURE__ */ React45.createElement(RadioContainer, null, units.map((unit) => {
    const isSelected = unit === selectedUnit;
    const radioId = `${title}-${unit}-radio`.replace(/\s+/g, "").toLowerCase();
    return /* @__PURE__ */ React45.createElement(
      RadioLabel,
      {
        isSelected,
        key: unit,
        htmlFor: radioId,
        display: "flex",
        justifyContent: "center"
      },
      /* @__PURE__ */ React45.createElement("span", null, unit, isSelected && /* @__PURE__ */ React45.createElement(
        SelectedIcon,
        {
          icon: "interfaceCheckmark",
          tint: "$interactiveActionPrimary",
          size: "$one"
        }
      )),
      /* @__PURE__ */ React45.createElement(VisuallyHidden, null, /* @__PURE__ */ React45.createElement(
        Radio,
        {
          value: unit,
          id: radioId,
          name: `${title}-radio`,
          checked: isSelected,
          onChange: () => onChange(unit)
        }
      ))
    );
  })));
}

// src/components/manage-units-modal/manage-units-modal.tsx
import { MoreOptionsButton } from "@leagueplatform/health-profile-common";
import { handleStaticAsset as handleStaticAsset2 } from "@leagueplatform/asset-config";

// src/constants/use-data-type-config.ts
import { useIntl as useIntl2 } from "@leagueplatform/locales";
import { useMemo as useMemo2 } from "react";
var UNIT_METRIC_ICON = {
  distance: "DASHBOARD_ACTIVITY_ICON" /* DASHBOARD_ACTIVITY_ICON */,
  steps: "DASHBOARD_ACTIVITY_ICON" /* DASHBOARD_ACTIVITY_ICON */,
  active_duration: "DASHBOARD_ACTIVITY_ICON" /* DASHBOARD_ACTIVITY_ICON */,
  mindful_duration: "DASHBOARD_MINDFULNESS_ICON" /* DASHBOARD_MINDFULNESS_ICON */,
  floors_climbed: "DASHBOARD_ACTIVITY_ICON" /* DASHBOARD_ACTIVITY_ICON */,
  energy_burned: "DASHBOARD_ACTIVITY_ICON" /* DASHBOARD_ACTIVITY_ICON */,
  body_height: "DASHBOARD_BODY_ICON" /* DASHBOARD_BODY_ICON */,
  body_weight: "DASHBOARD_BODY_ICON" /* DASHBOARD_BODY_ICON */,
  waist_circumference: "DASHBOARD_BODY_ICON" /* DASHBOARD_BODY_ICON */
  // sleep_duration: DASHBOARD_ASSET_MAP.DASHBOARD_SLEEP_ICON,
  // heart_rate: DASHBOARD_ASSET_MAP.DASHBOARD_HEART_ICON,
  // blood_glucose: DASHBOARD_ASSET_MAP.DASHBOARD_BLOOD_ICON,
  // blood_pressure: DASHBOARD_ASSET_MAP.DASHBOARD_BLOOD_ICON,
  // blood_oxygen: DASHBOARD_ASSET_MAP.DASHBOARD_BLOOD_ICON,
  // body_temperature: DASHBOARD_ASSET_MAP.DASHBOARD_BODY_ICON,
};
var isSupportedUnitMetricType = (input) => input in UNIT_METRIC_ICON;
var useDataTypeConfigMap = () => {
  const { $tmap } = useIntl2();
  return useMemo2(() => {
    const metric = $tmap({
      distance: "INSIGHT_CARD_HEADER_DISTANCE",
      steps: "INSIGHT_CARD_HEADER_STEPS",
      active_duration: "INSIGHT_CARD_HEADER_ACTIVE_DURATION",
      mindful_duration: "INSIGHT_CARD_HEADER_MINDFUL_DURATION",
      floors_climbed: "INSIGHT_CARD_HEADER_FLOORS_CLIMBED",
      energy_burned: "INSIGHT_CARD_HEADER_ENERGY_BURNED",
      body_height: "INSIGHT_CARD_HEADER_HEIGHT",
      body_weight: "INSIGHT_CARD_HEADER_WEIGHT",
      waist_circumference: "INSIGHT_CARD_HEADER_WAIST_CIRCUMFERENCE"
      // sleep_duration: 'INSIGHT_CARD_HEADER_SLEEP_DURATION',
      // heart_rate: 'INSIGHT_CARD_HEADER_HEART_RATE',
      // blood_glucose: 'INSIGHT_CARD_HEADER_BLOOD_GLUCOSE',
      // blood_pressure: 'INSIGHT_CARD_HEADER_BLOOD_PRESSURE',
      // blood_oxygen: 'INSIGHT_CARD_HEADER_BLOOD_OXYGEN',
      // body_temperature: 'INSIGHT_CARD_HEADER_BODY_TEMPERATURE',
    });
    const unit = $tmap({
      steps: "INSIGHT_CARD_UNIT_STEPS",
      floors_climbed: "INSIGHT_CARD_UNIT_FLOORS_CLIMBED"
    });
    return {
      metric,
      unit,
      icon: (unitMetricType) => UNIT_METRIC_ICON[unitMetricType]
    };
  }, [$tmap]);
};
var CATEGORY_ICON = {
  activity: "DASHBOARD_ACTIVITY_ICON" /* DASHBOARD_ACTIVITY_ICON */,
  body: "DASHBOARD_BODY_ICON" /* DASHBOARD_BODY_ICON */
  // blood: DASHBOARD_ASSET_MAP.DASHBOARD_BLOOD_ICON,
};
var isSupportedDataCategory = (input) => input in CATEGORY_ICON;
var useDataTypeCategoryConfigMap = () => {
  const { $tmap } = useIntl2();
  return useMemo2(() => {
    const metric = $tmap({
      activity: "DATAPOINT_CATEGORY_ACTIVITY",
      body: "DATAPOINT_CATEGORY_BODY"
    });
    return {
      metric,
      icon: (dataCategory) => CATEGORY_ICON[dataCategory]
    };
  }, [$tmap]);
};

// src/hooks/use-get-dashboard-config.hook.ts
import { useQuery } from "@tanstack/react-query";
import { captureError } from "@leagueplatform/observability";
import {
  getDashboardConfig,
  DASHBOARD_CONFIG_PATH
} from "@leagueplatform/dashboard-api";
function useGetDashboardConfig() {
  return useQuery([DASHBOARD_CONFIG_PATH], () => getDashboardConfig(), {
    onError(error) {
      captureError(
        new Error(`Unable to fetch the dashboard user preferences: ${error}`)
      );
    }
  });
}

// src/hooks/use-patch-dashboard-config.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { captureError as captureError2 } from "@leagueplatform/observability";
import {
  patchDashboardConfig,
  DASHBOARD_CONFIG_PATH as DASHBOARD_CONFIG_PATH2,
  healthMetricsV3Path,
  healthMetricsV2Path,
  healthMetricsV1Path
} from "@leagueplatform/dashboard-api";
function usePatchDashboardConfig() {
  const queryClient = useQueryClient();
  const { data: dashboardConfigData } = useGetDashboardConfig();
  return useMutation(
    (units) => patchDashboardConfig(units, dashboardConfigData),
    {
      onMutate(units) {
        const previousData = queryClient.getQueryData([
          DASHBOARD_CONFIG_PATH2
        ]);
        const unitsFromTheCache = previousData.data.units.map(
          (unit) => {
            var _a;
            return (_a = units.find((u) => u.unitType === unit.unitType)) != null ? _a : unit;
          }
        );
        queryClient.setQueryData([DASHBOARD_CONFIG_PATH2], __spreadProps(__spreadValues({}, previousData), {
          data: __spreadProps(__spreadValues({}, previousData.data), {
            units: unitsFromTheCache
          })
        }));
        return previousData;
      },
      onError(error, unitPreferences, previousUnitPreferences) {
        captureError2(
          new Error(
            `Unable to change the dashboard unit preferences: ${error}`
          ),
          {
            context: {
              preferences: {
                changed: JSON.stringify(unitPreferences),
                previous: JSON.stringify(previousUnitPreferences)
              }
            }
          }
        );
        queryClient.setQueryData(
          [DASHBOARD_CONFIG_PATH2],
          previousUnitPreferences
        );
      },
      onSuccess() {
        queryClient.invalidateQueries({
          predicate: (query) => {
            const queryKey = query.queryKey[0];
            if (typeof queryKey !== "string") {
              return false;
            }
            return [
              healthMetricsV3Path,
              healthMetricsV2Path,
              healthMetricsV1Path
            ].includes(queryKey);
          }
        });
      }
    }
  );
}

// src/components/error-panel/error-panel.tsx
import * as React46 from "react";
import {
  BodyOne,
  Box as Box7,
  Flex as Flex2,
  Image,
  SubtitleOne
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
import {
  useDisplayIsImpersonatorError
} from "@leagueplatform/web-common-components";
import { handleStaticAsset } from "@leagueplatform/asset-config";
import { Button as Button2 } from "@leagueplatform/genesis-core";
var ErrorPanel = (_a) => {
  var _b = _a, {
    error,
    onRetry,
    marginTop = "three",
    isRefetching
  } = _b, props = __objRest(_b, [
    "error",
    "onRetry",
    "marginTop",
    "isRefetching"
  ]);
  const { formatMessage } = useIntl3();
  const connectedDeviceImage = handleStaticAsset(
    "DASHBOARD_NO_HEALTH_METRIC_DATA" /* DASHBOARD_NO_HEALTH_METRIC_DATA */
  );
  const showImpersonationError = useDisplayIsImpersonatorError({ error });
  const finalHeadingString = showImpersonationError ? formatMessage({ id: "AGENT_PERMISSION_ERROR" }) : formatMessage({ id: "TROUBLE_DISPLAYING_DATA" });
  return /* @__PURE__ */ React46.createElement(
    Flex2,
    __spreadValues({
      backgroundColor: "surface.background.secondary",
      borderWidth: "thin",
      borderColor: "onSurface.border.subdued",
      flexDirection: "column",
      alignItems: "center",
      marginTop
    }, props),
    /* @__PURE__ */ React46.createElement(Box7, { marginTop: "oneAndHalf", marginBottom: "one" }, /* @__PURE__ */ React46.createElement(Image, { width: 215, src: connectedDeviceImage, alt: "altTxt" })),
    /* @__PURE__ */ React46.createElement(Flex2, { flexDirection: "column", alignItems: "center" }, /* @__PURE__ */ React46.createElement(SubtitleOne, { marginBottom: "quarter", fontWeight: "semibold" }, formatMessage({
      id: "ERROR_STATE_TITLE"
    })), /* @__PURE__ */ React46.createElement(BodyOne, { textAlign: "center", marginBottom: "oneAndHalf" }, finalHeadingString), !showImpersonationError && /* @__PURE__ */ React46.createElement(
      Button2,
      {
        loading: isRefetching,
        priority: "secondary",
        onClick: onRetry,
        css: { marginBottom: "$oneAndHalf" }
      },
      formatMessage({ id: "RETRY" })
    ))
  );
};

// src/components/manage-units-modal/manage-units-modal.tsx
var UnitGroup = genesisStyled2(Flex3)`
  flex-direction: column;
  gap: ${({ theme }) => theme.space.oneAndHalf}px;
  margin-bottom: ${({ theme }) => theme.space.half}px;
`;
var CategoryHeader = genesisStyled2(Flex3)`
  align-items: center;
  gap: ${({ theme }) => theme.space.half}px;
`;
function SavingLabel() {
  const { formatMessage } = useIntl4();
  return /* @__PURE__ */ React47.createElement(React47.Fragment, null, /* @__PURE__ */ React47.createElement(Spinner, { isLoading: true, paddingX: "one", paddingY: "threeQuarters" }), /* @__PURE__ */ React47.createElement(BodyTwo, null, formatMessage({ id: "MANAGE_UNITS_APPLYING_CHANGES" })));
}
function SavedLabel({ lastUpdateDate }) {
  const { formatMessage, formatTime } = useIntl4();
  return /* @__PURE__ */ React47.createElement(React47.Fragment, null, /* @__PURE__ */ React47.createElement(
    Image2,
    {
      src: handleStaticAsset2(
        "DASHBOARD_CHECK_WITH_CIRCLE" /* DASHBOARD_CHECK_WITH_CIRCLE */
      ),
      width: "one",
      marginInlineEnd: "quarter",
      alt: ""
    }
  ), /* @__PURE__ */ React47.createElement(BodyTwo, null, formatMessage(
    {
      id: "MANAGE_UNITS_CHANGES_SAVED"
    },
    {
      time: formatTime(lastUpdateDate, {
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
      })
    }
  )));
}
function ErrorSaving() {
  const { formatMessage } = useIntl4();
  return /* @__PURE__ */ React47.createElement(StackLayout6, { orientation: "horizontal", verticalAlignment: "center" }, /* @__PURE__ */ React47.createElement(
    Image2,
    {
      src: handleStaticAsset2(
        "DASHBOARD_X_WITH_CIRCLE" /* DASHBOARD_X_WITH_CIRCLE */
      ),
      width: "one",
      marginInlineEnd: "quarter",
      alt: ""
    }
  ), /* @__PURE__ */ React47.createElement(BodyTwo, null, formatMessage({ id: "ERROR_SAVING_TRY_AGAIN" })));
}
function ManageUnitsSection({
  title,
  icon,
  children
}) {
  return /* @__PURE__ */ React47.createElement(React47.Fragment, null, /* @__PURE__ */ React47.createElement(CategoryHeader, null, /* @__PURE__ */ React47.createElement(Image2, { alt: "", width: "36px", src: icon }), /* @__PURE__ */ React47.createElement(HeadingThree, null, title)), /* @__PURE__ */ React47.createElement(UnitGroup, null, children));
}
var unitConfigSections = {
  distance: "activity",
  energy_burned: "activity",
  body_height: "body",
  body_weight: "body",
  waist_circumference: "body"
};
var orderedDataCategorySectionKeys = ["activity", "body"];
var ManageUnitsModalContent = () => {
  const {
    isLoading,
    isError: isDashboardConfigError,
    isRefetching,
    data: dashboardConfigData,
    refetch,
    error
  } = useGetDashboardConfig();
  const dashboardConfigMutation = usePatchDashboardConfig();
  const [lastUpdateDate, setLastUpdateDate] = React47.useState();
  React47.useEffect(() => {
    if (dashboardConfigMutation.isSuccess) {
      setLastUpdateDate(/* @__PURE__ */ new Date());
    }
  }, [dashboardConfigMutation.isSuccess]);
  const catergoryConfig = useDataTypeCategoryConfigMap();
  const metricConfig = useDataTypeConfigMap();
  if (isDashboardConfigError) {
    return /* @__PURE__ */ React47.createElement(
      ErrorPanel,
      {
        error,
        isRefetching,
        marginTop: "none",
        onRetry: refetch
      }
    );
  }
  if (isLoading) {
    return /* @__PURE__ */ React47.createElement(SkeletonBox, { "data-testid": "loading", height: "300px" });
  }
  const dashboardConfigDataMap = dashboardConfigData && dashboardConfigData.data.unitOptions.reduce(
    (acc, unitOption) => {
      var _a;
      const sectionKey = unitConfigSections[unitOption.unitType];
      return __spreadProps(__spreadValues({}, acc), {
        [sectionKey]: [...(_a = acc[sectionKey]) != null ? _a : [], unitOption]
      });
    },
    {
      activity: [],
      body: []
    }
  );
  return /* @__PURE__ */ React47.createElement(React47.Fragment, null, dashboardConfigDataMap && /* @__PURE__ */ React47.createElement(React47.Fragment, null, orderedDataCategorySectionKeys.map((sectionKey) => {
    const sectionData = dashboardConfigDataMap[sectionKey];
    if (!isSupportedDataCategory(sectionKey) || !sectionData.length) {
      return null;
    }
    return /* @__PURE__ */ React47.createElement(Modal.Description, null, /* @__PURE__ */ React47.createElement(
      ManageUnitsSection,
      {
        key: sectionKey,
        icon: handleStaticAsset2(
          catergoryConfig.icon(sectionKey)
        ),
        title: catergoryConfig.metric(sectionKey)
      },
      sectionData.map(({ options, unitType }) => {
        var _a;
        const selectedUnit = (_a = dashboardConfigData.data.units.find(
          (u) => u.unitType === unitType
        )) == null ? void 0 : _a.unit;
        if (!isSupportedUnitMetricType(unitType) || !selectedUnit) {
          return null;
        }
        return /* @__PURE__ */ React47.createElement(
          UnitSwitcher,
          {
            key: unitType,
            title: metricConfig.metric(unitType),
            units: options,
            selectedUnit,
            onChange: (unit) => {
              dashboardConfigMutation.mutate([
                {
                  unit,
                  unitType
                }
              ]);
            }
          }
        );
      })
    ));
  })), /* @__PURE__ */ React47.createElement(Flex3, { justifyContent: "flex-end", alignItems: "center", height: "one" }, dashboardConfigMutation.isLoading ? /* @__PURE__ */ React47.createElement(SavingLabel, null) : null, dashboardConfigMutation.isSuccess && lastUpdateDate ? /* @__PURE__ */ React47.createElement(SavedLabel, { lastUpdateDate }) : null, dashboardConfigMutation.isError && /* @__PURE__ */ React47.createElement(ErrorSaving, null)));
};
function ManageUnitsModal({
  onClose,
  "aria-labelledby": ariaLabelledBy
}) {
  const { formatMessage } = useIntl4();
  return /* @__PURE__ */ React47.createElement(Box8, { "aria-describedby": ariaLabelledBy }, /* @__PURE__ */ React47.createElement(Modal.Close, null, /* @__PURE__ */ React47.createElement(
    StackLayout6,
    {
      orientation: "horizontal",
      verticalAlignment: "center",
      horizontalAlignment: "end"
    },
    /* @__PURE__ */ React47.createElement(
      Button3,
      {
        priority: "tertiary",
        size: "medium",
        quiet: true,
        onClick: onClose,
        css: { margin: "$one" }
      },
      /* @__PURE__ */ React47.createElement(VisuallyHidden2, null, formatMessage({ id: "CLOSE" })),
      /* @__PURE__ */ React47.createElement(Icon2, { icon: ICONS.CLOSE, size: 16, "aria-hidden": "true" })
    )
  )), /* @__PURE__ */ React47.createElement(
    Box8,
    {
      css: {
        display: "grid",
        gridTemplateRows: "1fr",
        gap: "$oneAndHalf",
        padding: "0 $two $oneAndHalf"
      }
    },
    /* @__PURE__ */ React47.createElement(Modal.Title, null, /* @__PURE__ */ React47.createElement(
      HighlightBanner,
      {
        title: formatMessage({ id: "UPDATE_UNITS_OF_MEASURE_MODAL_TITLE" }),
        backgroundColor: "surface.background.tertiary",
        icon: handleStaticAsset2(
          "DASHBOARD_EXCLAMATION_MARK_ICON" /* DASHBOARD_EXCLAMATION_MARK_ICON */
        ),
        marginBottom: "none"
      },
      formatMessage({ id: "UPDATE_UNITS_OF_MEASURE_MODAL_DESCRIPTION" })
    )),
    /* @__PURE__ */ React47.createElement(ManageUnitsModalContent, null)
  ));
}
function ManageUnitsLink({
  onClick,
  modalScreenLoadedEvent
}) {
  const { formatMessage } = useIntl4();
  const { isDashboardEnabled } = useIsDashboardEnabled();
  const queryClient = useQueryClient2();
  if (!isDashboardEnabled) {
    return null;
  }
  return /* @__PURE__ */ React47.createElement(
    Modal.Root,
    {
      onOpenChange: (opened) => {
        if (opened) {
          modalScreenLoadedEvent == null ? void 0 : modalScreenLoadedEvent();
        }
      }
    },
    /* @__PURE__ */ React47.createElement(Modal.Trigger, null, /* @__PURE__ */ React47.createElement(
      MoreOptionsButton,
      {
        id: "manage-units-link",
        onClick: () => {
          onClick == null ? void 0 : onClick();
        }
      },
      formatMessage({ id: "MANAGE_UNITS" })
    )),
    /* @__PURE__ */ React47.createElement(Modal.Content, { showCloseButton: false, padding: 0, width: 458 }, /* @__PURE__ */ React47.createElement(
      ManageUnitsModal,
      {
        "aria-labelledby": "manage-units-link",
        onClose: () => {
          queryClient.invalidateQueries({
            queryKey: [GET_WIDGET_DATA]
          });
        }
      }
    ))
  );
}

// src/pages/insights-page/insights-page.tsx
import { usePageViewAnalytics } from "@leagueplatform/analytics";

// src/components/insights/all-insights/all-insights.tsx
import * as React56 from "react";
import { useLocationLegacy as useLocation2 } from "@leagueplatform/routing";
import {
  genesisStyled as genesisStyled4,
  HeadingTwo as HeadingTwo3
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl9 } from "@leagueplatform/locales";
import { SkeletonBox as SkeletonBox2 } from "@leagueplatform/web-common-components";
import {
  supportedMetrics
} from "@leagueplatform/dashboard-api";
import { useFeatureFlagQuery as useFeatureFlagQuery3 } from "@leagueplatform/user-profile-api";

// src/components/no-data-card/no-data-card.tsx
import * as React50 from "react";
import { SubtitleOne as SubtitleOne2 } from "@leagueplatform/genesis-commons";
import { Icon as Icon3 } from "@leagueplatform/genesis-core";

// src/components/list-item/list-item.tsx
import * as React48 from "react";
import { Flex as Flex4 } from "@leagueplatform/genesis-commons";
function ListItem(props) {
  return /* @__PURE__ */ React48.createElement(
    Flex4,
    __spreadValues({
      alignItems: "center",
      justifyContent: "space-between",
      borderBottomWidth: "thin",
      paddingTop: "one",
      paddingBottom: "one",
      paddingInlineStart: "quarter",
      paddingInlineEnd: "quarter"
    }, props)
  );
}

// src/components/list-item/list-item-link.tsx
import * as React49 from "react";
import { LinkLegacy as Link } from "@leagueplatform/routing";
function ListItemLink(_a) {
  var _b = _a, { to, children } = _b, props = __objRest(_b, ["to", "children"]);
  return /* @__PURE__ */ React49.createElement(
    ListItem,
    __spreadValues({
      as: Link,
      textDecoration: "none",
      focusStyle: {
        backgroundColor: "interactive.action.disabled"
      },
      hoverStyle: {
        backgroundColor: "interactive.background.disabled"
      },
      to
    }, props),
    children
  );
}

// src/components/no-data-card/no-data-card.tsx
function NoDataCard({ dataType, to }) {
  const dataTypeConfig = useDataTypeConfigMap();
  if (!isSupportedUnitMetricType(dataType))
    return null;
  const metric = dataTypeConfig.metric(dataType);
  return /* @__PURE__ */ React50.createElement(ListItemLink, { "data-testid": "unavailable-metric", to }, /* @__PURE__ */ React50.createElement(SubtitleOne2, null, metric), /* @__PURE__ */ React50.createElement(
    Icon3,
    {
      icon: "interfaceChevronForward",
      size: "$oneAndHalf",
      tint: "$onSurfaceTextSubdued",
      css: {
        transform: "translateX(8px)"
      }
    }
  ));
}

// src/components/insights/all-insights/all-insights.tsx
import isToday2 from "date-fns/isToday";
import differenceInCalendarDays3 from "date-fns/differenceInCalendarDays";

// src/hooks/use-get-health-metrics.hook.ts
import * as React51 from "react";
import { useQuery as useQuery2, useInfiniteQuery } from "@tanstack/react-query";
import sub from "date-fns/sub";
import isSameDay2 from "date-fns/isSameDay";
import { captureError as captureError3 } from "@leagueplatform/observability";
import {
  getHealthMetrics,
  healthMetricsV1Path as healthMetricsV1Path2
} from "@leagueplatform/dashboard-api";
function backfillChartData(backfillDataDefaults, data, from, targetSize) {
  const datumTemplate = __spreadProps(__spreadValues({}, backfillDataDefaults), {
    source: "backfilled",
    trend: 0,
    value: 0
  });
  const dataTemplate = Array.from(Array(targetSize)).map((_, index) => __spreadValues({
    timestamp: sub(from, { days: index }).toISOString()
  }, datumTemplate));
  data.forEach((datum) => {
    const index = dataTemplate.findIndex(
      (t) => isSameDay2(new Date(t.timestamp), new Date(datum.timestamp))
    );
    dataTemplate[index] = datum;
  });
  return dataTemplate;
}
function useGetHealthMetrics(params, {
  // When set to true, fill in any missing gaps within the returned data with empty placeholder values.
  backfill = false
} = {}) {
  const backfillDataDefaults = React51.useRef();
  return useQuery2(
    [healthMetricsV1Path2, params],
    () => getHealthMetrics(params),
    {
      keepPreviousData: true,
      select(healthMetrics) {
        var _a, _b;
        const dataLength = healthMetrics.data.length;
        let unit = (_a = healthMetrics.meta) == null ? void 0 : _a.health_metric_unit;
        let type = (_b = params.filter) == null ? void 0 : _b.type;
        if (dataLength > 0) {
          if (!unit) {
            unit = healthMetrics.data[0].unit;
          }
          if (!type) {
            type = healthMetrics.data[0].type;
          }
        }
        if (type && unit) {
          backfillDataDefaults.current = {
            /**
             * TODO `type` coming from `params` may be an `Array<MetricType`>,
             * but the backfillDataDefaults ref expects a single `MetricType`.
             * Should address the discrepancy.
             */
            // @ts-expect-error
            type,
            unit
          };
        }
        if (backfill && params.from && params.interval && backfillDataDefaults.current && // Only run the backfill function if there are missing datums.
        (params.interval === "weekly" && dataLength < 7 || params.interval === "monthly" && dataLength < 30)) {
          return __spreadProps(__spreadValues({}, healthMetrics), {
            data: backfillChartData(
              backfillDataDefaults.current,
              healthMetrics.data,
              new Date(params.from),
              params.interval === "weekly" ? 7 : 30
            )
          });
        }
        return healthMetrics;
      },
      onError(error) {
        captureError3(new Error(`Unable to fetch health metrics: ${error}`), {
          context: {
            parameters: {
              api: JSON.stringify(params),
              backfill
            }
          }
        });
      }
    }
  );
}
function useInfiniteHealthMetrics(params) {
  return useInfiniteQuery(
    [healthMetricsV1Path2, params],
    ({ pageParam = /* @__PURE__ */ new Date() }) => getHealthMetrics(__spreadProps(__spreadValues({}, params), {
      interval: "monthly",
      from: pageParam.toISOString()
    })),
    {
      getNextPageParam: (_lastPage, pages) => sub(/* @__PURE__ */ new Date(), { days: 30 * pages.length }),
      onError(error) {
        captureError3(
          new Error(`Unable to fetch paginated health metrics: ${error}`),
          {
            context: {
              parameters: {
                api: JSON.stringify(params)
              }
            }
          }
        );
      }
    }
  );
}

// src/constants/feature-flags.constants.ts
var DYNAMIC_DASHBOARD_ENABLED = "dynamic_dashboard_enabled";
var SELF_REPORTED_DATA_ENABLED = "self_reported_data_enabled";

// src/components/insights/all-insights/metric-group.tsx
import * as React54 from "react";
import {
  Box as Box10,
  genesisStyled as genesisStyled3,
  HeadingTwo as HeadingTwo2
} from "@leagueplatform/genesis-commons";
import { trackAnalyticsEvent as trackAnalyticsEvent2, EVENT_NAME as EVENT_NAME2 } from "@leagueplatform/analytics";

// src/components/insights/insights-card/insights-card.tsx
import * as React53 from "react";
import {
  useLocationLegacy as useLocation,
  LinkLegacy as Link2
} from "@leagueplatform/routing";
import isToday from "date-fns/isToday";
import isYesterday from "date-fns/isYesterday";
import differenceInCalendarDays2 from "date-fns/differenceInCalendarDays";
import isSameYear from "date-fns/isSameYear";
import {
  Caption,
  Flex as Flex5,
  HeadingTwo,
  SubtitleTwo,
  Image as Image3,
  useTheme as useTheme12
} from "@leagueplatform/genesis-commons";
import { Icon as Icon4 } from "@leagueplatform/genesis-core";
import { genesisFocus } from "@leagueplatform/ui-kit";
import {
  SHORT_MONTH_FORMAT as SHORT_MONTH_FORMAT2,
  LONG_WEEKDAY,
  SHORT_MONTH_YEAR,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation11
} from "@leagueplatform/web-common";
import { useIntl as useIntl8 } from "@leagueplatform/locales";
import { handleStaticAsset as handleStaticAsset3 } from "@leagueplatform/asset-config";

// src/hooks/use-metric-value-formatter.ts
import { useIntl as useIntl5 } from "@leagueplatform/locales";
var digits = {
  distance: 1,
  steps: 0,
  active_duration: 0,
  mindful_duration: 0,
  floors_climbed: 0,
  energy_burned: 0
};
function useLocaleMetricValueFormatter() {
  const { formatNumber } = useIntl5();
  function formatMetricValue(value, type) {
    const maximumFractionDigits = digits[type];
    if (value === null) {
      return null;
    }
    return formatNumber(value, { maximumFractionDigits });
  }
  return { formatMetricValue };
}

// src/hooks/use-locale-unit-formatter.ts
import { useIntl as useIntl6 } from "@leagueplatform/locales";
function useLocaleUnitFormatter() {
  const { $tmap } = useIntl6();
  const metricConfig = useDataTypeConfigMap();
  const unitMap = $tmap({
    count: "COUNT",
    s: "S",
    m: "M",
    min: "MIN",
    cal: "CAL",
    kcal: "KCAL",
    bmp: "BMP",
    km: "KM",
    "mg/dl": "MG/DL"
  });
  const formatUnit = (type, unit, value = 0) => type === "steps" || type === "floors_climbed" ? metricConfig.unit(type, { count: value }) : unitMap(unit);
  return { formatUnit };
}

// src/components/insights/insights-card/insight-trend.tsx
import * as React52 from "react";
import { useIntl as useIntl7 } from "@leagueplatform/locales";
import {
  Box as Box9,
  ParagraphText,
  VisuallyHidden as VisuallyHidden3
} from "@leagueplatform/genesis-core";
function InsightTrend({ trend }) {
  const { formatMessage, formatNumber } = useIntl7();
  return /* @__PURE__ */ React52.createElement(
    Box9,
    {
      css: {
        backgroundColor: "$surfaceBackgroundSecondary",
        padding: "$quarter",
        verticalAlign: "middle",
        borderRadius: "$small"
      }
    },
    trend !== void 0 && trend !== null ? /* @__PURE__ */ React52.createElement(React52.Fragment, null, /* @__PURE__ */ React52.createElement(
      ParagraphText,
      {
        css: {
          fontWeight: "bold",
          display: "inline"
        },
        size: "sm"
      },
      formatNumber(trend, {
        style: "percent",
        signDisplay: "exceptZero"
      })
    ), /* @__PURE__ */ React52.createElement(
      ParagraphText,
      {
        css: { display: "inline", color: "$onSurfaceTextSubdued" },
        size: "xs"
      },
      " ",
      formatMessage({ id: "SINCE_LAST_WEEK" })
    )) : /* @__PURE__ */ React52.createElement(VisuallyHidden3, null, formatMessage({ id: "NO_DATA_AVAILABLE" }))
  );
}

// src/components/insights/insights-card/insights-card.tsx
var useGetTimestamp = (timestamp) => {
  const { formatMessage, formatTime } = useIntl8();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation11();
  const convertedTimestamp = new Date(timestamp);
  switch (true) {
    case isToday(convertedTimestamp):
      return formatTime(convertedTimestamp);
    case isYesterday(convertedTimestamp):
      return formatMessage({ id: "YESTERDAY" });
    case differenceInCalendarDays2(/* @__PURE__ */ new Date(), convertedTimestamp) <= 6:
      return formatDateWithUserProfileLocation(
        convertedTimestamp,
        LONG_WEEKDAY
      );
    case (differenceInCalendarDays2(/* @__PURE__ */ new Date(), convertedTimestamp) >= 7 && isSameYear(/* @__PURE__ */ new Date(), convertedTimestamp)):
      return formatDateWithUserProfileLocation(
        convertedTimestamp,
        SHORT_MONTH_FORMAT2
      );
    default:
      return formatDateWithUserProfileLocation(
        convertedTimestamp,
        SHORT_MONTH_YEAR
      );
  }
};
var InsightCardIcon = ({ src }) => /* @__PURE__ */ React53.createElement(Image3, { alt: "", width: "36px", src });
function InsightsCard({
  type,
  trend,
  timestamp,
  onClick,
  unit,
  value,
  measurementSecondary,
  unitsSecondary,
  embedded = true
}) {
  const theme = useTheme12();
  const { pathname: path } = useLocation();
  const { formatNumber } = useIntl8();
  const { formatMetricValue } = useLocaleMetricValueFormatter();
  const { formatUnit } = useLocaleUnitFormatter();
  const formattedTimestamp = useGetTimestamp(timestamp);
  const metricConfig = useDataTypeConfigMap();
  const metric = metricConfig.metric(type);
  const icon = metricConfig.icon(type);
  if (!isSupportedUnitMetricType(type) || value === null) {
    return null;
  }
  return /* @__PURE__ */ React53.createElement(
    Flex5,
    {
      as: Link2,
      textDecoration: "none",
      alignItems: "center",
      padding: "one",
      borderRadius: "medium",
      boxShadow: "card",
      width: "100%",
      minWidth: "325px",
      focusStyle: genesisFocus,
      hoverStyle: {
        boxShadow: `0 0 0 ${theme.borderWidths.thin}px ${theme.colors.interactive.action.primary}`
      },
      activeStyle: {
        boxShadow: "focusOutline"
      },
      onClick,
      to: embedded ? `${path}/insights/${type}/details` : `${path}/${type}/details`
    },
    /* @__PURE__ */ React53.createElement(Flex5, { height: "100%", width: 1, justifyContent: "space-between" }, /* @__PURE__ */ React53.createElement(Flex5, { flexDirection: "column", alignItems: "baseline" }, /* @__PURE__ */ React53.createElement(SubtitleTwo, { paddingBottom: "threeQuarters" }, metric), /* @__PURE__ */ React53.createElement(Flex5, { alignItems: "center" }, /* @__PURE__ */ React53.createElement(InsightCardIcon, { src: handleStaticAsset3(icon) }), /* @__PURE__ */ React53.createElement(Flex5, { alignItems: "baseline" }, /* @__PURE__ */ React53.createElement(HeadingTwo, { paddingInlineStart: "half" }, formatMetricValue(value, type)), /* @__PURE__ */ React53.createElement(
      Caption,
      {
        paddingInlineStart: "quarter",
        color: "onSurface.text.subdued"
      },
      formatUnit(type, unit, value)
    ), unitsSecondary && measurementSecondary && // for now, secondary units will only exist if the metric is sleep
    /* @__PURE__ */ React53.createElement(React53.Fragment, null, /* @__PURE__ */ React53.createElement(HeadingTwo, { paddingInlineStart: "quarter" }, formatNumber(measurementSecondary)), " ", /* @__PURE__ */ React53.createElement(
      Caption,
      {
        paddingInlineStart: "quarter",
        color: "onSurface.text.subdued"
      },
      unitsSecondary
    ))))), /* @__PURE__ */ React53.createElement(
      Flex5,
      {
        height: "100%",
        flexDirection: "column",
        justifyContent: "space-between",
        paddingInlineEnd: "one",
        alignItems: "flex-end"
      },
      /* @__PURE__ */ React53.createElement(InsightTrend, { trend }),
      /* @__PURE__ */ React53.createElement(Caption, { color: "onSurface.text.subdued" }, formattedTimestamp)
    )),
    /* @__PURE__ */ React53.createElement(
      Icon4,
      {
        icon: "tinyDisclosureIndicator",
        size: "$oneAndHalf",
        tint: "$onSurfaceTextSubdued"
      }
    )
  );
}

// src/components/insights/all-insights/metric-group.tsx
var InsightCardContainer = genesisStyled3(Box10)`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto;
    grid-gap: ${({ theme }) => `${theme == null ? void 0 : theme.space.one}px`};
    padding-top: ${({ theme }) => `${theme == null ? void 0 : theme.space.one}px`};
    @media screen and (max-width: ${({ theme }) => theme == null ? void 0 : theme.breakpoints.tablet}) {
      grid-template-columns: 1fr;
    }
`;
function MetricGroup({
  embedded = true,
  title,
  metrics,
  dataTestId
}) {
  return /* @__PURE__ */ React54.createElement("div", { "data-testid": dataTestId }, /* @__PURE__ */ React54.createElement(HeadingTwo2, { marginTop: "twoAndHalf", marginBottom: "oneAndHalf" }, title), /* @__PURE__ */ React54.createElement(InsightCardContainer, null, metrics.map(({ type, trend, timestamp, unit, value }) => /* @__PURE__ */ React54.createElement(
    InsightsCard,
    {
      embedded,
      key: type,
      type,
      trend,
      timestamp,
      unit,
      value,
      onClick: () => {
        trackAnalyticsEvent2(EVENT_NAME2.BUTTON_CLICKED, {
          product_area: "dashboard" /* DASHBOARD */,
          screen_name: "all insights" /* ALL_INSIGHTS */,
          metric_type: type,
          detail: "click metric cards"
        });
      }
    }
  ))));
}

// src/components/insights/all-metric-cards.tsx
import * as React55 from "react";
import Masonry, { getMasonryDriver } from "@leagueplatform/masonry";
import { MasonryEngine } from "@leagueplatform/masonry-engine";

// src/hooks/use-is-metrics-improvements-enabled.ts
import { useFeatureFlagQuery as useFeatureFlagQuery2 } from "@leagueplatform/user-profile-api";
var ENABLE_METRICS_IMPROVEMENTS = "release_about-me_metrics-improvement";
var useIsMetricsImprovementsEnabled = () => {
  const { isLoading, data: isMetricsImprovementsEnabled } = useFeatureFlagQuery2(
    ENABLE_METRICS_IMPROVEMENTS
  );
  return {
    isLoading,
    isMetricsImprovementsEnabled
  };
};

// src/components/insights/all-metric-cards.tsx
var MasonryComposer = Masonry.init({
  appId: "dashboard-metrics",
  apiVersion: 2,
  analytics: {
    productArea: "dashboard" /* DASHBOARD */,
    screenName: "about me metrics" /* ABOUT_ME_METRICS */
  }
});
var MasonryMetricsDriver = getMasonryDriver({
  rootNodeId: "aboutMeMetrics$root"
});
function AllMetricCards() {
  const { isMetricsImprovementsEnabled } = useIsMetricsImprovementsEnabled();
  if (isMetricsImprovementsEnabled) {
    return /* @__PURE__ */ React55.createElement(MasonryEngine, { driver: MasonryMetricsDriver });
  }
  return /* @__PURE__ */ React55.createElement(MasonryComposer.Provider, null);
}

// src/components/insights/all-insights/all-insights.tsx
var CardContainer = genesisStyled4("div")`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(325px, 1fr));
  gap: ${({ theme }) => `0 ${theme == null ? void 0 : theme.space.oneAndHalf}px`};
`;
var daysDifference = (timestamp) => differenceInCalendarDays3(/* @__PURE__ */ new Date(), new Date(timestamp));
var getUnavailableMetrics = (healthMetricsData) => supportedMetrics.filter(
  (type) => !healthMetricsData.map((metric) => metric.type).includes(type)
);
function AllInsightsLegacy({ embedded }) {
  const { formatMessage } = useIntl9();
  const { pathname: path } = useLocation2();
  const {
    isLoading,
    isError,
    isRefetching,
    data: healthMetrics,
    refetch,
    error
  } = useGetHealthMetrics({
    interval: "instant",
    fields: {
      type: ["type", "source", "value", "unit", "trend", "timestamp"]
    }
  });
  if (isError) {
    return /* @__PURE__ */ React56.createElement(
      ErrorPanel,
      {
        error,
        isRefetching,
        onRetry: () => refetch()
      }
    );
  }
  if (isLoading) {
    return /* @__PURE__ */ React56.createElement(SkeletonBox2, { "data-testid": "loading", width: "100%", height: "250px" });
  }
  const unavailableMetrics = (healthMetrics == null ? void 0 : healthMetrics.data) ? getUnavailableMetrics(healthMetrics.data) : supportedMetrics;
  const metricsFromToday = healthMetrics == null ? void 0 : healthMetrics.data.filter(
    ({ timestamp }) => isToday2(new Date(timestamp))
  );
  const metricsFromPast7Days = healthMetrics == null ? void 0 : healthMetrics.data.filter(
    ({ timestamp }) => daysDifference(timestamp) > 0 && daysDifference(timestamp) <= 6
  );
  const metricsFromPast30Days = healthMetrics == null ? void 0 : healthMetrics.data.filter(
    ({ timestamp }) => daysDifference(timestamp) > 6 && daysDifference(timestamp) <= 30
  );
  const metricsFromOlderThan30Days = healthMetrics == null ? void 0 : healthMetrics.data.filter(
    ({ timestamp }) => daysDifference(timestamp) > 30
  );
  return /* @__PURE__ */ React56.createElement(React56.Fragment, null, (metricsFromToday == null ? void 0 : metricsFromToday.length) ? /* @__PURE__ */ React56.createElement(
    MetricGroup,
    {
      embedded,
      title: formatMessage({
        id: "TODAY"
      }),
      metrics: metricsFromToday,
      dataTestId: "today"
    }
  ) : null, (metricsFromPast7Days == null ? void 0 : metricsFromPast7Days.length) ? /* @__PURE__ */ React56.createElement(
    MetricGroup,
    {
      embedded,
      title: formatMessage({
        id: "LAST_7_DAYS"
      }),
      metrics: metricsFromPast7Days,
      dataTestId: "past7Days"
    }
  ) : null, (metricsFromPast30Days == null ? void 0 : metricsFromPast30Days.length) ? /* @__PURE__ */ React56.createElement(
    MetricGroup,
    {
      embedded,
      title: formatMessage({
        id: "LAST_30_DAYS"
      }),
      metrics: metricsFromPast30Days,
      dataTestId: "past30Days"
    }
  ) : null, (metricsFromOlderThan30Days == null ? void 0 : metricsFromOlderThan30Days.length) ? /* @__PURE__ */ React56.createElement(
    MetricGroup,
    {
      embedded,
      title: formatMessage({
        id: "OLDER"
      }),
      metrics: metricsFromOlderThan30Days,
      dataTestId: "older"
    }
  ) : null, unavailableMetrics.length > 0 && /* @__PURE__ */ React56.createElement(React56.Fragment, null, /* @__PURE__ */ React56.createElement(HeadingTwo3, { marginTop: "four", marginBottom: "oneAndHalf" }, formatMessage({
    id: "NO_DATA_AVAILABLE"
  })), /* @__PURE__ */ React56.createElement(CardContainer, { "data-testid": "unavailable-metrics-container" }, unavailableMetrics.map((type) => /* @__PURE__ */ React56.createElement(
    NoDataCard,
    {
      key: type,
      dataType: type,
      to: embedded ? `${path}/insights/${type}/details` : `${path}/${type}/details`
    }
  )))));
}
function AllInsights({ embedded = true }) {
  const { data: isDynamicDashboardEnabled } = useFeatureFlagQuery3(
    DYNAMIC_DASHBOARD_ENABLED
  );
  return isDynamicDashboardEnabled ? /* @__PURE__ */ React56.createElement(AllMetricCards, null) : /* @__PURE__ */ React56.createElement(AllInsightsLegacy, { embedded });
}

// src/pages/insights-page/insights-page.tsx
import { useDocumentTitle } from "@leagueplatform/web-common";
function InsightsPage() {
  const { formatMessage } = useIntl10();
  const pageTitle = formatMessage({
    id: "APP_AND_DEVICE_METRICS"
  });
  usePageViewAnalytics({
    product_area: "dashboard" /* DASHBOARD */,
    screen_name: "all insights" /* ALL_INSIGHTS */
  });
  useDocumentTitle(pageTitle);
  return /* @__PURE__ */ React57.createElement(
    HealthProfilePageWrapper,
    {
      title: pageTitle,
      sidebar: /* @__PURE__ */ React57.createElement(Sidebar, null, /* @__PURE__ */ React57.createElement(RewardsSidebarCard, null), /* @__PURE__ */ React57.createElement(MoreOptionsCard, null, /* @__PURE__ */ React57.createElement(AddAppsDevicesLink, null), /* @__PURE__ */ React57.createElement(ManageUnitsLink, null)))
    },
    /* @__PURE__ */ React57.createElement(AllInsights, { embedded: false })
  );
}

// src/dashboard.routes.tsx
import { Routes, Route } from "@leagueplatform/routing";
import { useFeatureFlagQuery as useFeatureFlagQuery5 } from "@leagueplatform/user-profile-api";

// src/pages/all-recorded-data/all-recorded-data.tsx
import * as React58 from "react";
import {
  HealthProfilePageWrapper as HealthProfilePageWrapper2,
  MoreOptionsCard as MoreOptionsCard2,
  MoreOptionsLink
} from "@leagueplatform/health-profile-common";
import {
  Caption as Caption2,
  Flex as Flex6,
  HeadingOne,
  SecondaryButton,
  SubtitleOne as SubtitleOne3
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl11 } from "@leagueplatform/locales";
import {
  LoadingIndicator,
  Sidebar as Sidebar2
} from "@leagueplatform/web-common-components";
import {
  DATE_FORMAT as DATE_FORMAT2,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation12
} from "@leagueplatform/web-common";

// src/hooks/use-health-metric-document-title.ts
import { useDocumentTitle as useDocumentTitle2 } from "@leagueplatform/web-common";
function useHealthMetricDocumentTitle(pageName, metricDisplayName) {
  let pageTitle = pageName;
  if (metricDisplayName) {
    pageTitle = `${metricDisplayName} | ${pageTitle}`;
  }
  useDocumentTitle2(pageTitle);
}

// src/pages/all-recorded-data/all-recorded-data.tsx
import { useParamsLegacy as useParams2 } from "@leagueplatform/routing";
var AllRecordedData = () => {
  const { dataType } = useParams2();
  const { formatMessage, $tmap } = useIntl11();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation12();
  const { formatUnit } = useLocaleUnitFormatter();
  const { formatMetricValue } = useLocaleMetricValueFormatter();
  const metric = useDataTypeConfigMap().metric(dataType);
  const {
    isFetching: isLoadingHealthMetrics,
    isError: isErrorHealthMetrics,
    data: healthMetrics,
    isRefetching: isRefetchingHealthMetrics,
    fetchNextPage,
    isFetchingNextPage,
    refetch,
    error
  } = useInfiniteHealthMetrics({
    filter: {
      type: dataType
    },
    fields: { type: ["type", "value", "source", "unit", "timestamp"] }
  });
  const getMetricSourceMessage = $tmap({
    apple_health: "APPLE_HEALTH",
    bluetooth: "BLUETOOTH",
    fitbit: "FITBIT",
    garmin: "GARMIN",
    google_fit_sdk: "GOOGLE_FIT_SDK",
    ihealth: "IHEALTH",
    omron: "OMRON",
    polar: "POLAR",
    samsung_health: "SAMSUNG_HEALTH",
    strava: "STRAVA",
    vital_snap: "VITAL_SNAP",
    withings: "WITHINGS",
    health_plan: "HEALTH_PLAN",
    no_source_data: "NO_SOURCE_DATA",
    unavailable: "UNAVAILABLE",
    backfilled: "BACKFILLED",
    android_health_connect: "ANDROID_HEALTH_CONNECT"
  });
  useHealthMetricDocumentTitle(
    formatMessage({
      id: "ALL_RECORDED_DATA"
    }),
    metric
  );
  if (isLoadingHealthMetrics && !healthMetrics) {
    return /* @__PURE__ */ React58.createElement(LoadingIndicator, null);
  }
  if (!isSupportedUnitMetricType(dataType)) {
    return null;
  }
  return /* @__PURE__ */ React58.createElement(
    HealthProfilePageWrapper2,
    {
      title: formatMessage({
        id: "ALL_RECORDED_DATA"
      }),
      sidebar: /* @__PURE__ */ React58.createElement(Sidebar2, null, /* @__PURE__ */ React58.createElement(MoreOptionsCard2, null, /* @__PURE__ */ React58.createElement(MoreOptionsLink, { to: "data-sources" }, formatMessage({ id: "VIEW_DATA_SOURCES" }))))
    },
    /* @__PURE__ */ React58.createElement(HeadingOne, { as: "h2", paddingBottom: "twoAndHalf", paddingTop: "oneAndHalf" }, metric),
    isErrorHealthMetrics ? /* @__PURE__ */ React58.createElement(
      ErrorPanel,
      {
        error,
        isRefetching: isRefetchingHealthMetrics,
        onRetry: refetch
      }
    ) : /* @__PURE__ */ React58.createElement(React58.Fragment, null, healthMetrics == null ? void 0 : healthMetrics.pages.map(
      (page) => page.data.map((dataMetric) => {
        const { unit, value, source, timestamp, type } = dataMetric;
        const date = formatDateWithUserProfileLocation(
          timestamp,
          DATE_FORMAT2
        );
        if (value === null) {
          return null;
        }
        return /* @__PURE__ */ React58.createElement(ListItem, { key: timestamp }, /* @__PURE__ */ React58.createElement(Flex6, { flexDirection: "column" }, /* @__PURE__ */ React58.createElement(SubtitleOne3, null, formatMetricValue(value, type), " ", formatUnit(type, unit, value)), /* @__PURE__ */ React58.createElement(Caption2, { color: "onSurface.text.subdued" }, getMetricSourceMessage(source))), /* @__PURE__ */ React58.createElement(
          SubtitleOne3,
          {
            paddingTop: "half",
            paddingBottom: "half",
            color: "onSurface.text.subdued",
            fontWeight: "regular"
          },
          date
        ));
      })
    ), /* @__PURE__ */ React58.createElement(Flex6, { justifyContent: "center", mt: "twoAndHalf" }, /* @__PURE__ */ React58.createElement(
      SecondaryButton,
      {
        disabled: isFetchingNextPage,
        onClick: () => {
          fetchNextPage();
        }
      },
      formatMessage({ id: "LOAD_MORE" }).toLocaleUpperCase()
    )))
  );
};

// src/pages/all-recorded-data2/all-recorded-data.tsx
import * as React63 from "react";
import {
  HealthProfilePageWrapper as HealthProfilePageWrapper3,
  MoreOptionsCard as MoreOptionsCard3,
  MoreOptionsLink as MoreOptionsLink2
} from "@leagueplatform/health-profile-common";
import {
  StackLayout as StackLayout7,
  Button as Button5,
  HeadingText as HeadingText4,
  UtilityText as UtilityText5,
  Box as Box14
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl14 } from "@leagueplatform/locales";
import {
  LoadingIndicator as LoadingIndicator2,
  Sidebar as Sidebar3
} from "@leagueplatform/web-common-components";
import {
  DATE_FORMAT as DATE_FORMAT3,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation13
} from "@leagueplatform/web-common";
import { trackAnalyticsEvent as trackAnalyticsEvent5, EVENT_NAME as EVENT_NAME5 } from "@leagueplatform/analytics";

// src/hooks/use-get-health-metrics-v2.hook.ts
import { useInfiniteQuery as useInfiniteQuery2, useQuery as useQuery3 } from "@tanstack/react-query";
import {
  getHealthMetricsV2,
  getHealthMetricsByPaginationLink,
  healthMetricsV2Path as healthMetricsV2Path2
} from "@leagueplatform/dashboard-api";
function useGetHealthMetricsV2(params) {
  return useQuery3(
    [healthMetricsV2Path2, params],
    () => getHealthMetricsV2(params),
    {
      keepPreviousData: true,
      staleTime: Infinity
    }
  );
}
function useInfiniteHealthMetricsV2(params) {
  return useInfiniteQuery2(
    [healthMetricsV2Path2, params],
    ({ pageParam }) => {
      if (pageParam) {
        return getHealthMetricsByPaginationLink(pageParam);
      }
      return getHealthMetricsV2(__spreadProps(__spreadValues({}, params), {
        interval: "all"
      }));
    },
    {
      getNextPageParam(lastPage) {
        var _a;
        if (!((_a = lastPage == null ? void 0 : lastPage.links) == null ? void 0 : _a.next)) {
          return void 0;
        }
        const { next } = lastPage.links;
        return next.slice(next.indexOf("/v2/"));
      }
    }
  );
}

// src/pages/details2/components/health-programs.tsx
import * as React59 from "react";
import {
  HealthProgramCarousels,
  useHealthProgramsCategory
} from "@leagueplatform/health-programs";
import { Box as Box11 } from "@leagueplatform/genesis-core";
function HealthPrograms({ metric }) {
  const healthProgramsCategory = useHealthProgramsCategory({
    categoryId: metric
  });
  return /* @__PURE__ */ React59.createElement(Box11, { css: { width: "100%" } }, /* @__PURE__ */ React59.createElement(
    HealthProgramCarousels,
    {
      hideLoadingSkeleton: true,
      isLoading: healthProgramsCategory.isLoading,
      carousels: [
        {
          title: healthProgramsCategory.name,
          programs: healthProgramsCategory.programs,
          analyticsProps: { metricType: metric }
        }
      ],
      carouselsCategory: "dashboard metrics screen" /* DASHBOARD_METRIC_SCREEN */
    }
  ));
}

// src/components/health-literacy/health-literacy-content.tsx
import * as React61 from "react";
import {
  css as css3,
  genesisStyled as genesisStyled6,
  HeadingTwo as HeadingTwo4,
  Flex as Flex7,
  Image as Image4,
  HeadingFour,
  BodyOne as BodyOne2,
  QuietButton as QuietButton2,
  HeadingThree as HeadingThree2
} from "@leagueplatform/genesis-commons";
import { HtmlToReact } from "@leagueplatform/web-common";
import { trackAnalyticsEvent as trackAnalyticsEvent4, EVENT_NAME as EVENT_NAME4 } from "@leagueplatform/analytics";

// src/hooks/use-get-health-literacy.hook.ts
import { useQuery as useQuery4 } from "@tanstack/react-query";
import { captureError as captureError4 } from "@leagueplatform/observability";
import { getHealthLiteracy } from "@leagueplatform/dashboard-api";
var HEALTH_LITERACY_QUERY_KEY = "health-literacy";
function useGetHealthLiteracy(dataType) {
  return useQuery4(
    [HEALTH_LITERACY_QUERY_KEY, dataType],
    () => getHealthLiteracy(dataType),
    {
      onError(error) {
        captureError4(new Error(`Unable to fetch health literacy: ${error}`));
      }
    }
  );
}

// src/components/health-literacy/health-literacy-content.tsx
import { Box as Box13 } from "@leagueplatform/genesis-core";

// src/components/health-literacy/health-literacy-modal.tsx
import { trackAnalyticsEvent as trackAnalyticsEvent3, EVENT_NAME as EVENT_NAME3 } from "@leagueplatform/analytics";
import {
  Box as Box12,
  css as css2,
  genesisStyled as genesisStyled5,
  QuietButton,
  VisuallyHidden as VisuallyHidden4
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl12 } from "@leagueplatform/locales";
import { Icon as Icon5, ICONS as ICONS2, Modal as Modal2 } from "@leagueplatform/ui-kit";
import * as React60 from "react";
var StyledModalContainer = genesisStyled5(Modal2.Container)(
  css2({
    position: "relative",
    maxWidth: 620,
    borderRadius: "medium",
    overflow: "auto"
  })
);
var StyledModalBody = genesisStyled5(Modal2.Body)(
  css2({
    padding: "oneAndHalf",
    paddingTop: "half"
  })
);
var HealthLiteracyModal = ({
  ariaLabelledBy,
  onClose,
  children,
  metric
}) => {
  const { formatMessage } = useIntl12();
  React60.useEffect(() => {
    if (metric) {
      trackAnalyticsEvent3(EVENT_NAME3.SCREEN_LOADED, {
        product_area: "dashboard" /* DASHBOARD */,
        screen_name: "datatype content screen" /* DATATYPE_CONTENT_SCREEN */,
        metric_type: metric
      });
    }
  }, [metric]);
  return /* @__PURE__ */ React60.createElement(Modal2.Wrapper, { onClose, options: null }, /* @__PURE__ */ React60.createElement(StyledModalContainer, { "aria-labelledby": ariaLabelledBy }, /* @__PURE__ */ React60.createElement(Box12, { position: "absolute", insetInlineEnd: "5px", top: "5px" }, /* @__PURE__ */ React60.createElement(QuietButton, { onClick: onClose }, /* @__PURE__ */ React60.createElement(VisuallyHidden4, null, formatMessage({ id: "CLOSE" })), /* @__PURE__ */ React60.createElement(Icon5, { icon: ICONS2.CLOSE, size: 16, "aria-hidden": "true" }))), /* @__PURE__ */ React60.createElement(StyledModalBody, null, children)));
};

// src/components/health-literacy/health-literacy-content.tsx
var LiteracyCard = genesisStyled6(Flex7)(
  css3({
    "&:active, &:focus": {
      borderColor: "transparent",
      backgroundColor: "transparent",
      "&:before": { borderRadius: "large" }
    },
    "&:not(:focus):not(:active):hover": {
      borderColor: "onSurface.border.subdued"
    },
    "&:hover": {
      backgroundColor: "transparent"
    }
  })
);
var StyledImage = genesisStyled6(Image4)(
  css3({
    borderEndStartRadius: "none",
    borderEndEndRadius: "none"
  })
);
var HealthLiteracyHtmlToReactOptions = {
  h4: {
    component: HeadingFour,
    props: { marginBottom: "one", marginTop: "twoAndHalf" }
  },
  p: {
    component: BodyOne2,
    props: {
      marginBottom: "one"
    }
  },
  h2: {
    component: HeadingThree2,
    props: { marginBottom: "one", marginTop: "twoAndHalf" }
  },
  h3: {
    component: HeadingThree2,
    props: { marginBottom: "one", marginTop: "twoAndHalf" }
  }
};
var displayHealthLiteracyContent = (healthLiteracyData) => {
  const { cardDescription, cardImage, cardTitle, healthLiteracyDescription } = healthLiteracyData.data;
  if (cardTitle && cardDescription && cardImage && healthLiteracyDescription) {
    return true;
  }
  return false;
};
var HealthLiteracyContent = ({ metric }) => {
  const [showHealthLiteracyModal, setShowHealthLiteracyModal] = React61.useState(false);
  const {
    isLoading,
    isError,
    data: healthLiteracyData
  } = useGetHealthLiteracy(metric);
  if (isLoading) {
    return null;
  }
  if (isError || !(healthLiteracyData == null ? void 0 : healthLiteracyData.data)) {
    return null;
  }
  const {
    cardDescription,
    cardImage,
    cardTitle,
    description,
    healthLiteracyDescription,
    title
  } = healthLiteracyData.data;
  return /* @__PURE__ */ React61.createElement(Box13, { css: { width: "100%" } }, /* @__PURE__ */ React61.createElement(HeadingTwo4, { marginBottom: "one" }, title), /* @__PURE__ */ React61.createElement(HtmlToReact, { htmlString: description }), displayHealthLiteracyContent(healthLiteracyData) ? /* @__PURE__ */ React61.createElement(React61.Fragment, null, /* @__PURE__ */ React61.createElement(
    LiteracyCard,
    {
      as: QuietButton2,
      marginTop: "oneAndHalf",
      marginBottom: "five",
      borderRadius: "medium",
      border: "solid",
      borderWidth: "thin",
      borderColor: "onSurface.border.subdued",
      boxShadow: "card",
      flexDirection: "column",
      justifyContent: "center",
      maxWidth: "388px",
      onClick: () => {
        setShowHealthLiteracyModal(true);
        trackAnalyticsEvent4(EVENT_NAME4.BUTTON_CLICKED, {
          product_area: "dashboard" /* DASHBOARD */,
          screen_name: "dashboard metrics screen" /* DASHBOARD_METRIC_SCREEN */,
          metric_type: metric,
          detail: "click datatype literacy content"
        });
      }
    },
    /* @__PURE__ */ React61.createElement(
      StyledImage,
      {
        src: cardImage,
        width: "100%",
        maxWidth: "100%",
        role: "presentation",
        borderRadius: "medium"
      }
    ),
    /* @__PURE__ */ React61.createElement(Flex7, { textAlign: "start", flexDirection: "column", padding: "oneAndHalf" }, /* @__PURE__ */ React61.createElement(HeadingFour, { marginBottom: "one" }, cardTitle), /* @__PURE__ */ React61.createElement(HtmlToReact, { htmlString: cardDescription }))
  ), showHealthLiteracyModal ? /* @__PURE__ */ React61.createElement(
    HealthLiteracyModal,
    {
      ariaLabelledBy: "about-metric",
      onClose: () => setShowHealthLiteracyModal(false),
      metric
    },
    /* @__PURE__ */ React61.createElement(
      HeadingTwo4,
      {
        marginBottom: "two",
        id: "about-metric",
        fontSize: "subtitle1",
        textAlign: "center"
      },
      title
    ),
    /* @__PURE__ */ React61.createElement(HeadingThree2, { marginBottom: "one" }, cardTitle),
    /* @__PURE__ */ React61.createElement(
      HtmlToReact,
      {
        options: HealthLiteracyHtmlToReactOptions,
        htmlString: healthLiteracyDescription
      }
    )
  ) : null) : null);
};

// src/hooks/use-is-self-reported-data-enabled.hook.ts
import { useFeatureFlagQuery as useFeatureFlagQuery4 } from "@leagueplatform/user-profile-api";
var useIsSelfReportedDataEnabled = () => {
  const { isLoading, data: isSelfReportedDataEnabled } = useFeatureFlagQuery4(
    SELF_REPORTED_DATA_ENABLED
  );
  return {
    isLoading,
    isSelfReportedDataEnabled
  };
};

// src/pages/details2/components/add-metric-data-button.tsx
import * as React62 from "react";
import { Button as Button4 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl13 } from "@leagueplatform/locales";
function AddMetricDataButton({ onClick }) {
  const { formatMessage } = useIntl13();
  return /* @__PURE__ */ React62.createElement(Button4, { onClick, width: "fillContainer" }, formatMessage({
    id: "ADD_DATA"
  }));
}

// src/pages/all-recorded-data2/all-recorded-data.tsx
import { useParamsLegacy as useParams3 } from "@leagueplatform/routing";
var handleAnalytics = (eventName, metricType, detail) => trackAnalyticsEvent5(eventName, __spreadValues({
  product_area: "dashboard" /* DASHBOARD */,
  screen_name: "all recorded data" /* ALL_RECORDED_DATA */,
  metric_type: metricType
}, detail && { detail }));
var AllRecordedData2 = () => {
  const { dataType } = useParams3();
  const { formatMessage } = useIntl14();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation13();
  const { isSelfReportedDataEnabled } = useIsSelfReportedDataEnabled();
  const {
    isLoading: isLoadingHealthMetrics,
    isError: isErrorHealthMetrics,
    isRefetching: isRefetchingHealthMetrics,
    data: healthMetrics,
    fetchNextPage,
    isFetchingNextPage,
    refetch,
    hasNextPage,
    error
  } = useInfiniteHealthMetricsV2({
    filter: {
      type: dataType
    },
    fields: { type: ["type", "value", "source", "unit", "timestamp"] }
  });
  const metricDisplayName = healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].metricDisplayName;
  useHealthMetricDocumentTitle(
    formatMessage({
      id: "ALL_RECORDED_DATA"
    }),
    metricDisplayName
  );
  React63.useEffect(() => {
    handleAnalytics(EVENT_NAME5.SCREEN_LOADED, dataType);
  }, [dataType]);
  if (isLoadingHealthMetrics && !healthMetrics) {
    return /* @__PURE__ */ React63.createElement(LoadingIndicator2, null);
  }
  const allMetricConfigs = healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].configs.data;
  const firstConfigName = allMetricConfigs == null ? void 0 : allMetricConfigs[0].name;
  const displayConfigName = Boolean(allMetricConfigs == null ? void 0 : allMetricConfigs.length) && !(allMetricConfigs == null ? void 0 : allMetricConfigs.every(
    (metricConfig) => metricConfig.name === firstConfigName
  ));
  const handleEditClick = () => {
    handleAnalytics(EVENT_NAME5.BUTTON_CLICKED, dataType, "edit reading");
  };
  const showHealthLiteracyOnAllRecordedDataScreen = healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].showHealthLiteracyOnAllRecordedDataScreen;
  const showAddDataButton = (healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].addDataUrl) && isSelfReportedDataEnabled;
  return /* @__PURE__ */ React63.createElement(
    HealthProfilePageWrapper3,
    {
      title: formatMessage({
        id: "ALL_RECORDED_DATA"
      }),
      sidebar: /* @__PURE__ */ React63.createElement(Sidebar3, null, /* @__PURE__ */ React63.createElement(MoreOptionsCard3, null, /* @__PURE__ */ React63.createElement(
        MoreOptionsLink2,
        {
          to: "data-sources",
          onClick: () => handleAnalytics(
            EVENT_NAME5.BUTTON_CLICKED,
            dataType,
            "view data sources"
          )
        },
        formatMessage({ id: "VIEW_DATA_SOURCES" })
      )), showAddDataButton ? /* @__PURE__ */ React63.createElement(AddMetricDataButton, null) : null)
    },
    /* @__PURE__ */ React63.createElement(
      HeadingText4,
      {
        size: "xxl",
        level: "2",
        css: { paddingTop: "$oneAndHalf", paddingBottom: "$twoAndHalf" }
      },
      metricDisplayName
    ),
    /* @__PURE__ */ React63.createElement(StackLayout7, { spacing: "$oneAndHalf" }, isErrorHealthMetrics ? /* @__PURE__ */ React63.createElement(
      ErrorPanel,
      {
        error,
        isRefetching: isRefetchingHealthMetrics,
        onRetry: refetch
      }
    ) : /* @__PURE__ */ React63.createElement(Box14, { as: "ul", css: { width: "100%" } }, healthMetrics == null ? void 0 : healthMetrics.pages.map(
      (page) => page.data[0].values.data.map((dataMetric) => {
        const { id, source, timestamp, config } = dataMetric;
        const isSelfReported = config.data.source === "self_reported";
        const date = formatDateWithUserProfileLocation(
          timestamp,
          DATE_FORMAT3
        );
        return /* @__PURE__ */ React63.createElement(ListItem, { as: "li", key: id }, /* @__PURE__ */ React63.createElement(StackLayout7, null, /* @__PURE__ */ React63.createElement(UtilityText5, { as: "p", emphasis: "emphasized" }, getValueUnitDisplayLabel({
          value: dataMetric.value,
          label: dataMetric.label,
          unitOptions: dataMetric.config.data.unit
        }).map(([displayValue, displayUnit], index) => (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ React63.createElement("span", { key: `${index} + ${dataMetric.type}` }, displayValue, " ", displayUnit, " ", displayConfigName ? ` (${config.data.name.toLocaleLowerCase()})` : null)
        ))), /* @__PURE__ */ React63.createElement(UtilityText5, { emphasis: "subtle" }, source)), /* @__PURE__ */ React63.createElement(
          StackLayout7,
          {
            orientation: "horizontal",
            horizontalAlignment: "end",
            verticalAlignment: "center",
            spacing: "$half"
          },
          /* @__PURE__ */ React63.createElement(
            UtilityText5,
            {
              as: "p",
              emphasis: "subtle",
              css: { paddingTop: "$half", paddingBottom: "$half" }
            },
            date
          ),
          isSelfReported && isSelfReportedDataEnabled && /* @__PURE__ */ React63.createElement(
            Button5,
            {
              onClick: handleEditClick,
              priority: "secondary",
              quiet: true,
              icon: "descriptiveCompose",
              hideLabel: true
            },
            formatMessage(
              { id: "EDIT_METRIC_DATA" },
              {
                metric: metricDisplayName
              }
            )
          )
        ));
      })
    ), hasNextPage && /* @__PURE__ */ React63.createElement(
      StackLayout7,
      {
        horizontalAlignment: "center",
        css: { marginTop: "$twoAndHalf" }
      },
      /* @__PURE__ */ React63.createElement(
        Button5,
        {
          priority: "secondary",
          disabled: isFetchingNextPage,
          onClick: () => {
            fetchNextPage();
          }
        },
        formatMessage({ id: "LOAD_MORE" }).toLocaleUpperCase()
      )
    )), showHealthLiteracyOnAllRecordedDataScreen ? /* @__PURE__ */ React63.createElement(React63.Fragment, null, /* @__PURE__ */ React63.createElement(HealthPrograms, { metric: dataType }), /* @__PURE__ */ React63.createElement(HealthLiteracyContent, { metric: dataType })) : null)
  );
};

// src/pages/all-recorded-data3/all-recorded-data.tsx
import * as React74 from "react";
import {
  HealthProfilePageWrapper as HealthProfilePageWrapper4,
  MoreOptionsCard as MoreOptionsCard4,
  MoreOptionsLink as MoreOptionsLink3
} from "@leagueplatform/health-profile-common";
import {
  StackLayout as StackLayout15,
  Button as Button10,
  HeadingText as HeadingText7,
  UtilityText as UtilityText8,
  Box as Box18,
  StatusBadge as StatusBadge2
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl21 } from "@leagueplatform/locales";
import {
  LoadingIndicator as LoadingIndicator3,
  Sidebar as Sidebar4
} from "@leagueplatform/web-common-components";
import {
  DATE_FORMAT as DATE_FORMAT4,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation14
} from "@leagueplatform/web-common";
import { trackAnalyticsEvent as trackAnalyticsEvent10, EVENT_NAME as EVENT_NAME10 } from "@leagueplatform/analytics";

// src/hooks/use-get-health-metrics-v3.hook.ts
import { useInfiniteQuery as useInfiniteQuery3, useQuery as useQuery5 } from "@tanstack/react-query";
import {
  getHealthMetricsV3,
  getHealthMetricsByPaginationLinkV3,
  healthMetricsV3Path as healthMetricsV3Path2
} from "@leagueplatform/dashboard-api";
function useGetHealthMetricsV3(params) {
  return useQuery5(
    [healthMetricsV3Path2, params],
    () => getHealthMetricsV3(params),
    {
      keepPreviousData: true,
      staleTime: Infinity
    }
  );
}
function useInfiniteHealthMetricsV3(params) {
  return useInfiniteQuery3(
    [healthMetricsV3Path2, params],
    ({ pageParam }) => {
      if (pageParam) {
        return getHealthMetricsByPaginationLinkV3(pageParam);
      }
      return getHealthMetricsV3(__spreadProps(__spreadValues({}, params), {
        interval: "all"
      }));
    },
    {
      getNextPageParam(lastPage) {
        var _a;
        if (!((_a = lastPage == null ? void 0 : lastPage.links) == null ? void 0 : _a.next)) {
          return void 0;
        }
        const { next } = lastPage.links;
        return next.slice(next.indexOf("/v3/"));
      }
    }
  );
}

// src/components/add-edit-data/add-edit-data-modal.tsx
import React71, { useState as useState9 } from "react";
import { Modal as Modal4 } from "@leagueplatform/genesis-core";
import { trackAnalyticsEvent as trackAnalyticsEvent8, EVENT_NAME as EVENT_NAME8 } from "@leagueplatform/analytics";

// src/components/add-edit-data/add-edit-data-modal-content.tsx
import * as React70 from "react";
import {
  HeadingText as HeadingText5,
  Modal as Modal3,
  StackLayout as StackLayout13,
  ParagraphText as ParagraphText3
} from "@leagueplatform/genesis-core";
import { Badge } from "@leagueplatform/web-common-components";
import { isNil } from "lodash";

// src/components/metric-form/metric-form-post.tsx
import { FieldType } from "@leagueplatform/dashboard-api";
import { Button as Button6, StackLayout as StackLayout10 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl17 } from "@leagueplatform/locales";

// src/components/inputs/integer-input.tsx
import * as React64 from "react";
import {
  ControlledFormField
} from "@leagueplatform/web-common";
import { Box as Box15, InputHint, TextInput } from "@leagueplatform/genesis-core";
import { useIntl as useIntl15 } from "@leagueplatform/locales";
function IntegerInput({
  id,
  label,
  maxValue,
  minValue,
  name,
  placeholder,
  unit,
  value,
  validationMessage,
  hint,
  defaultValue
}) {
  const { formatMessage, formatNumber } = useIntl15();
  const inputRules = __spreadValues({
    valueAsNumber: true,
    required: {
      value: true,
      message: validationMessage
    },
    min: {
      value: minValue || 0,
      message: formatMessage(
        { id: "MIN_VALUE_ERROR_MESSAGE" },
        {
          min: formatNumber(minValue || 0)
        }
      )
    }
  }, maxValue && {
    max: {
      value: maxValue,
      message: formatMessage(
        { id: "MAX_VALUE_ERROR_MESSAGE" },
        {
          max: formatNumber(maxValue)
        }
      )
    }
  });
  return /* @__PURE__ */ React64.createElement(Box15, null, /* @__PURE__ */ React64.createElement(
    ControlledFormField,
    {
      id,
      label,
      name,
      inputOptions: inputRules
    },
    /* @__PURE__ */ React64.createElement(
      TextInput,
      {
        type: "number",
        step: "0.1",
        addOnEnd: unit || null,
        placeholder,
        defaultValue,
        value
      }
    )
  ), hint && /* @__PURE__ */ React64.createElement(
    InputHint,
    {
      css: {
        marginTop: "$half"
      }
    },
    hint
  ));
}

// src/components/inputs/radio-input.tsx
import React65 from "react";
import { useFormContext, useInput } from "@leagueplatform/web-common";
import {
  Card,
  Fieldset,
  InputHint as InputHint2,
  Radio as Radio2,
  StackLayout as StackLayout8,
  ParagraphText as ParagraphText2
} from "@leagueplatform/genesis-core";
import { Controller } from "react-hook-form";
function RadioInput({
  id,
  options,
  altText,
  validationMessage,
  defaultValue,
  fieldLabel,
  hint
}) {
  const { watch } = useFormContext();
  const currentValue = watch(id);
  const { inputValidationState } = useInput(id);
  options.sort((a, b) => b.value - a.value);
  return /* @__PURE__ */ React65.createElement(StackLayout8, { horizontalAlignment: "stretch" }, /* @__PURE__ */ React65.createElement(
    Controller,
    {
      name: id,
      defaultValue,
      rules: {
        required: {
          value: true,
          message: validationMessage
        }
      },
      render: ({ field }) => /* @__PURE__ */ React65.createElement(
        Fieldset,
        __spreadProps(__spreadValues({}, inputValidationState), {
          legend: altText,
          hideLegend: true,
          id,
          css: {
            ".GDS-input-status-message-wrapper": {
              marginTop: "$one"
            }
          }
        }),
        /* @__PURE__ */ React65.createElement(StackLayout8, { spacing: "$one", horizontalAlignment: "stretch" }, fieldLabel && /* @__PURE__ */ React65.createElement(ParagraphText2, null, fieldLabel), options.map(({ label, value }) => /* @__PURE__ */ React65.createElement(
          Card.Elevated,
          {
            css: {
              borderColor: (
                // eslint-disable-next-line eqeqeq
                currentValue == value ? "$interactiveActionPrimary" : "$onSurfaceBorderSubdued"
              ),
              borderWidth: "$thin",
              borderStyle: "solid",
              borderRadius: "$medium"
            }
          },
          /* @__PURE__ */ React65.createElement(
            Radio2,
            __spreadProps(__spreadValues({}, field), {
              id: label,
              name: id,
              checked: value === field.value,
              value,
              label,
              layout: "row",
              css: {
                ".GDS-radio-label-hint": {
                  padding: "$one",
                  minHeight: "100px"
                }
              },
              onChange: () => {
                field.onChange(value);
              }
            })
          )
        )), hint && /* @__PURE__ */ React65.createElement(InputHint2, null, hint))
      )
    }
  ));
}

// src/components/inputs/date-time-input.tsx
import * as React66 from "react";
import {
  FormField,
  InputHint as InputHint3,
  StackLayout as StackLayout9
} from "@leagueplatform/genesis-core";
import { DatePicker } from "@leagueplatform/web-common-components";
import { parseAbsoluteToLocal } from "@internationalized/date";
import { Controller as Controller2 } from "react-hook-form";
import { useIntl as useIntl16 } from "@leagueplatform/locales";
function DateTimeInput({
  id,
  defaultValue,
  label,
  validationMessage,
  isReadOnly,
  required = false,
  triggerValidation,
  validations,
  hint
}) {
  const { formatMessage } = useIntl16();
  const inputOptions = {
    required: {
      value: required,
      message: validationMessage
    },
    validate: __spreadValues({
      noFutureDate: (date) => {
        const inputDate = parseAbsoluteToLocal(date);
        const currentDate = parseAbsoluteToLocal((/* @__PURE__ */ new Date()).toISOString());
        const check = inputDate.compare(currentDate);
        if (check > 0) {
          return formatMessage({
            id: "NO_FUTURE_DATES"
          });
        }
        return void 0;
      }
    }, validations)
  };
  return /* @__PURE__ */ React66.createElement(
    Controller2,
    {
      name: id,
      rules: inputOptions,
      defaultValue: defaultValue || (/* @__PURE__ */ new Date()).toISOString(),
      render: ({ field, fieldState }) => {
        var _a;
        return /* @__PURE__ */ React66.createElement(StackLayout9, { horizontalAlignment: "stretch" }, /* @__PURE__ */ React66.createElement(
          FormField,
          {
            name: id,
            id,
            label,
            statusMessage: (_a = fieldState.error) == null ? void 0 : _a.message,
            inputStatus: fieldState.error ? "error" : void 0
          },
          /* @__PURE__ */ React66.createElement(
            DatePicker,
            {
              isReadOnly,
              granularity: "minute",
              value: field.value && parseAbsoluteToLocal(field.value),
              hideTimeZone: true,
              onChange: (value) => {
                field.onChange(
                  new Date(value.toDate()).toISOString()
                );
                if (triggerValidation)
                  triggerValidation();
              },
              maxValue: parseAbsoluteToLocal((/* @__PURE__ */ new Date()).toISOString()),
              errorMessage: ""
            }
          ),
          hint && /* @__PURE__ */ React66.createElement(
            InputHint3,
            {
              css: {
                marginTop: "$half"
              }
            },
            hint
          )
        ));
      }
    }
  );
}

// src/components/metric-form/metric-form-post.tsx
import { useForm } from "react-hook-form";
import React67 from "react";
import { FormProvider } from "@leagueplatform/web-common";

// src/hooks/use-post-health-metrics.hook.ts
import { useMutation as useMutation2, useQueryClient as useQueryClient3 } from "@tanstack/react-query";
import {
  createHealthMetrics,
  healthMetricsV3Path as healthMetricsV3Path3
} from "@leagueplatform/dashboard-api";
var usePostHealthMetrics = () => {
  const queryClient = useQueryClient3();
  const mutation = useMutation2(createHealthMetrics, {
    onSuccess: () => {
      queryClient.invalidateQueries([healthMetricsV3Path3]);
    }
  });
  return mutation;
};

// src/utils/format-metric-post-data.util.ts
function formatMetricPostData(formData, metricInputs, metricConfigId) {
  return metricInputs.map((metricInput, index) => {
    const metricFormData = {
      metricConfigId,
      metricComponentId: metricInput.metricComponentId,
      value: {}
    };
    if (formData.effectiveDateTime) {
      metricFormData.effectiveDateTime = formData.effectiveDateTime;
    }
    metricInput.valueFields.forEach((valueField) => {
      if (formData[`${index}-${valueField.fieldKeyName}`] !== void 0) {
        metricFormData.value.type = metricInput.inputType;
        metricFormData.value[valueField.fieldKeyName] = formData[`${index}-${valueField.fieldKeyName}`];
      }
    });
    return metricFormData;
  });
}

// src/components/metric-form/metric-form-post.tsx
import { parseAbsoluteToLocal as parseAbsoluteToLocal2 } from "@internationalized/date";
import { parseISO } from "date-fns";
import { EVENT_NAME as EVENT_NAME6, trackAnalyticsEvent as trackAnalyticsEvent6 } from "@leagueplatform/analytics";
function MetricFormPost({
  onSuccessSubmit,
  showDateTimePicker = false,
  metricInputs,
  metricConfigId
}) {
  const { formatMessage } = useIntl17();
  const [failedComponentIds, setFailedComponentIds] = React67.useState(
    []
  );
  const formMethods = useForm({ mode: "onChange" });
  const mutation = usePostHealthMetrics();
  const handleSubmit = (formData) => __async(this, null, function* () {
    const metricsToPost = formatMetricPostData(
      formData,
      metricInputs,
      metricConfigId
    );
    const mutationPromises = metricsToPost.filter(
      (m) => failedComponentIds.length === 0 || failedComponentIds.includes(m.metricComponentId)
    ).map((metric) => mutation.mutateAsync(metric));
    const result = yield Promise.allSettled(mutationPromises);
    const failedComponents = [];
    let successComponentTimestamp;
    result.forEach((r, index) => {
      if (r.status === "rejected") {
        failedComponents.push(metricsToPost[index].metricComponentId);
      } else if (r.status === "fulfilled" && successComponentTimestamp === void 0) {
        successComponentTimestamp = r.value.data.timestamp;
      }
    });
    setFailedComponentIds(failedComponents);
    if (onSuccessSubmit && successComponentTimestamp) {
      onSuccessSubmit(new Date(parseISO(successComponentTimestamp)));
    }
    trackAnalyticsEvent6(EVENT_NAME6.BUTTON_CLICKED, {
      product_area: "dashboard" /* DASHBOARD */,
      screen_name: "add metric data" /* ADD_METRIC_DATA */,
      metric_type: metricConfigId,
      detail: "submit"
    });
  });
  return /* @__PURE__ */ React67.createElement(FormProvider, { formMethods, onSubmit: handleSubmit }, /* @__PURE__ */ React67.createElement(StackLayout10, { spacing: "$one", horizontalAlignment: "stretch" }, showDateTimePicker && /* @__PURE__ */ React67.createElement(
    DateTimeInput,
    {
      id: "effectiveDateTime",
      validationMessage: "validationMessage",
      label: formatMessage({ id: "DATE_AND_TIME" })
    }
  ), metricInputs.map(
    (healthMetricInputs, index) => healthMetricInputs.valueFields.map((valueField) => {
      if (valueField.options) {
        return /* @__PURE__ */ React67.createElement(
          RadioInput,
          {
            id: `${index}-${valueField.fieldKeyName}`,
            fieldLabel: valueField.fieldLabel,
            options: valueField.options,
            validationMessage: formatMessage({
              id: "NO_VALUE_SELECTED_ERROR_MESSAGE"
            }),
            hint: valueField.hint
          }
        );
      }
      switch (valueField.fieldType) {
        case FieldType.DATETIME:
          return /* @__PURE__ */ React67.createElement(
            DateTimeInput,
            {
              id: `${index}-${valueField.fieldKeyName}`,
              label: valueField.fieldLabel,
              validationMessage: formatMessage({
                id: "TOOLBOX_VALIDATION_REQUIRED_FIELD"
              }),
              triggerValidation: () => formMethods.trigger(),
              hint: valueField.hint,
              validations: {
                endDateMustBeAfterStart: (fieldValue, fieldValues) => {
                  const startDate = parseAbsoluteToLocal2(
                    fieldValues[`${index}-start`]
                  );
                  const endDate = parseAbsoluteToLocal2(
                    fieldValues[`${index}-end`]
                  );
                  if (fieldValue === fieldValues[`${index}-start`]) {
                    return void 0;
                  }
                  const check = startDate.compare(endDate);
                  if (check >= -6e4) {
                    return formatMessage({
                      id: "START_DATE_MUST_BE_EARLIER_ERROR_MESSAGE"
                    });
                  }
                  return void 0;
                },
                notMoreThan24HoursDifference: (fieldValue, fieldValues) => {
                  const startDate = parseAbsoluteToLocal2(
                    fieldValues[`${index}-start`]
                  );
                  const endDate = parseAbsoluteToLocal2(
                    fieldValues[`${index}-end`]
                  );
                  const check = startDate.add({ days: 1 }).compare(endDate);
                  if (fieldValue === fieldValues[`${index}-start`]) {
                    return void 0;
                  }
                  if (check < 0) {
                    return formatMessage({
                      id: "DURATION_EXCEEDS_24_HOURS_ERROR_MESSAGE"
                    });
                  }
                  return void 0;
                }
              }
            }
          );
        case FieldType.QUANTITY:
          return /* @__PURE__ */ React67.createElement(
            IntegerInput,
            {
              validationMessage: formatMessage({
                id: "TOOLBOX_VALIDATION_REQUIRED_FIELD"
              }),
              id: `input-${valueField.fieldKeyName}`,
              unit: valueField.unit,
              placeholder: valueField.placeholderCopy,
              minValue: valueField.min,
              maxValue: valueField.max,
              name: `${index}-${valueField.fieldKeyName}`,
              label: valueField.fieldLabel,
              hint: valueField.hint
            }
          );
        default:
          return null;
      }
    })
  ), failedComponentIds.length > 0 ? /* @__PURE__ */ React67.createElement(ErrorSaving, null) : null), /* @__PURE__ */ React67.createElement(
    Button6,
    {
      loading: mutation.isLoading,
      icon: "interfaceCheckmark",
      hideLabel: true,
      type: "submit",
      css: {
        position: "absolute",
        bottom: "$minusFive",
        insetInlineEnd: "$none",
        "@mobile": {
          bottom: "$two",
          insetInlineEnd: "$two"
        }
      }
    },
    formatMessage({ id: "SAVE" })
  ));
}

// src/components/metric-form/metric-form-patch.tsx
import {
  FieldType as FieldType2
} from "@leagueplatform/dashboard-api";
import { Button as Button7, StackLayout as StackLayout11 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl18 } from "@leagueplatform/locales";
import { useForm as useForm2 } from "react-hook-form";
import React68 from "react";
import { FormProvider as FormProvider2 } from "@leagueplatform/web-common";

// src/utils/format-metric-patch-data.util.ts
function formatMetricPatchData(formData, metricInput, metricConfigId) {
  const metricFormData = {
    metricConfigId,
    metricComponentId: metricInput.metricComponentId,
    value: {}
  };
  if (formData.effectiveDateTime) {
    metricFormData.effectiveDateTime = formData.effectiveDateTime;
  }
  metricInput.valueFields.forEach((valueField) => {
    if (formData[valueField.fieldKeyName] !== void 0) {
      metricFormData.value.type = metricInput.inputType;
      metricFormData.value[valueField.fieldKeyName] = formData[valueField.fieldKeyName];
    }
  });
  return metricFormData;
}

// src/hooks/use-patch-health-metrics.hook.ts
import { useMutation as useMutation3, useQueryClient as useQueryClient4 } from "@tanstack/react-query";
import {
  updateHealthMetrics,
  healthMetricsV3Path as healthMetricsV3Path4
} from "@leagueplatform/dashboard-api";

// src/constants/request.constants.ts
var PATCH_HEALTH_METRIC_MESSAGE_TYPE = "patch_health_metric";

// src/hooks/use-patch-health-metrics.hook.ts
var usePatchHealthMetrics = (closeModal) => {
  const queryClient = useQueryClient4();
  const mutation = useMutation3(
    (_0) => __async(void 0, [_0], function* ({ data, observationId }) {
      return updateHealthMetrics({ data, observationId });
    }),
    {
      mutationKey: [PATCH_HEALTH_METRIC_MESSAGE_TYPE],
      onSuccess: () => {
        queryClient.invalidateQueries([healthMetricsV3Path4]);
        if (closeModal) {
          closeModal();
        }
      }
    }
  );
  return mutation;
};

// src/components/metric-form/metric-form-patch.tsx
import { parseAbsoluteToLocal as parseAbsoluteToLocal3 } from "@internationalized/date";
import { EVENT_NAME as EVENT_NAME7, trackAnalyticsEvent as trackAnalyticsEvent7 } from "@leagueplatform/analytics";
function MetricFormPatch({
  onSuccessSubmit,
  metricInput,
  observationId,
  value,
  timeStamp,
  effectiveDateTime,
  metricConfigId,
  showDateTimePicker
}) {
  const { formatMessage } = useIntl18();
  const formMethods = useForm2({
    mode: "onChange"
  });
  const mutation = usePatchHealthMetrics(onSuccessSubmit);
  const handleSubmit = (data) => {
    if (mutation.isLoading)
      return;
    if (mutation.isSuccess && !mutation.error)
      return;
    mutation.mutate({
      data: formatMetricPatchData(data, metricInput, metricConfigId),
      observationId
    });
    trackAnalyticsEvent7(EVENT_NAME7.BUTTON_CLICKED, {
      product_area: "dashboard" /* DASHBOARD */,
      screen_name: "add metric data" /* ADD_METRIC_DATA */,
      metric_type: metricConfigId,
      detail: "submit"
    });
  };
  return /* @__PURE__ */ React68.createElement(FormProvider2, { formMethods, onSubmit: handleSubmit }, /* @__PURE__ */ React68.createElement(StackLayout11, { spacing: "$one", horizontalAlignment: "stretch" }, showDateTimePicker && /* @__PURE__ */ React68.createElement(
    DateTimeInput,
    {
      id: "effectiveDateTime",
      validationMessage: "validationMessage",
      label: formatMessage({ id: "DATE_AND_TIME" }),
      defaultValue: timeStamp,
      isReadOnly: true
    }
  ), metricInput.valueFields.map((valueField) => {
    if (valueField.options) {
      return /* @__PURE__ */ React68.createElement(
        RadioInput,
        {
          id: valueField.fieldKeyName,
          options: valueField.options,
          defaultValue: value[valueField.fieldKeyName],
          validationMessage: formatMessage({
            id: "NO_VALUE_SELECTED_ERROR_MESSAGE"
          }),
          hint: valueField.hint
        }
      );
    }
    switch (valueField.fieldType) {
      case FieldType2.DATETIME:
        return /* @__PURE__ */ React68.createElement(
          DateTimeInput,
          {
            id: valueField.fieldKeyName,
            label: valueField.fieldLabel,
            validationMessage: formatMessage({
              id: "TOOLBOX_VALIDATION_REQUIRED_FIELD"
            }),
            defaultValue: effectiveDateTime == null ? void 0 : effectiveDateTime[valueField.fieldKeyName],
            required: true,
            hint: valueField.hint,
            validations: {
              endDateMustBeAfterStart: (fieldValue, fieldValues) => {
                const startDate = parseAbsoluteToLocal3(fieldValues.start);
                const endDate = parseAbsoluteToLocal3(fieldValues.end);
                if (fieldValue === fieldValues.start) {
                  return void 0;
                }
                const check = startDate.compare(endDate);
                if (check >= -6e4) {
                  return formatMessage({
                    id: "START_DATE_MUST_BE_EARLIER_ERROR_MESSAGE"
                  });
                }
                return void 0;
              },
              notMoreThan24HoursDifference: (fieldValue, fieldValues) => {
                const startDate = parseAbsoluteToLocal3(fieldValues.start);
                const endDate = parseAbsoluteToLocal3(fieldValues.end);
                const check = startDate.add({ days: 1 }).compare(endDate);
                if (fieldValue === fieldValues.start) {
                  return void 0;
                }
                if (check < 0) {
                  return formatMessage({
                    id: "DURATION_EXCEEDS_24_HOURS_ERROR_MESSAGE"
                  });
                }
                return void 0;
              }
            }
          }
        );
      case FieldType2.QUANTITY: {
        const defaultValue = metricInput.valueFields.length === 1 ? value[valueField.fieldKeyName] : value[valueField.unit];
        return /* @__PURE__ */ React68.createElement(
          IntegerInput,
          {
            validationMessage: formatMessage({
              id: "TOOLBOX_VALIDATION_REQUIRED_FIELD"
            }),
            id: valueField.fieldKeyName,
            unit: valueField.unit,
            placeholder: valueField.placeholderCopy,
            minValue: valueField.min,
            maxValue: valueField.max,
            name: valueField.fieldKeyName,
            label: valueField.fieldLabel,
            hint: valueField.hint,
            defaultValue
          }
        );
      }
      default:
        return null;
    }
  }), mutation.error && /* @__PURE__ */ React68.createElement(ErrorSaving, null)), /* @__PURE__ */ React68.createElement(
    Button7,
    {
      loading: mutation.isLoading,
      icon: "interfaceCheckmark",
      hideLabel: true,
      type: "submit",
      css: {
        position: "absolute",
        bottom: "$minusFive",
        insetInlineEnd: "$none",
        "@mobile": {
          bottom: "$two",
          insetInlineEnd: "$two"
        }
      }
    },
    formatMessage({ id: "SAVE" })
  ));
}

// src/components/information-banner/information-banner.tsx
import * as React69 from "react";
import { StackLayout as StackLayout12, Box as Box16, UtilityText as UtilityText6 } from "@leagueplatform/genesis-core";
function InformationBanner({
  heading,
  iconURL,
  body
}) {
  return /* @__PURE__ */ React69.createElement(Box16, null, /* @__PURE__ */ React69.createElement(
    StackLayout12,
    {
      horizontalAlignment: "start",
      css: {
        backgroundColor: "$surfaceBackgroundSecondary",
        borderRadius: "$medium",
        padding: "$one"
      }
    },
    /* @__PURE__ */ React69.createElement(
      StackLayout12,
      {
        orientation: "horizontal",
        verticalAlignment: "center",
        horizontalAlignment: "start",
        spacing: "$one",
        css: {
          paddingBottom: "$one"
        }
      },
      /* @__PURE__ */ React69.createElement(
        Box16,
        {
          as: "img",
          alt: "",
          src: iconURL,
          css: { width: "$one", height: "$one" }
        }
      ),
      /* @__PURE__ */ React69.createElement(UtilityText6, { size: "eyebrow" }, heading)
    ),
    /* @__PURE__ */ React69.createElement(UtilityText6, { emphasis: "subtle", size: "xs" }, body)
  ));
}

// src/utils/parse-value-for-input.util.ts
function ParseValueForInput(value, label) {
  let valueOrLabel = value;
  if (label == null ? void 0 : label.includes(";")) {
    valueOrLabel = label;
  }
  const valueObject = {};
  if (typeof valueOrLabel === "string") {
    valueOrLabel.split(";").forEach((unitValuePair) => {
      const unitValuePairArray = unitValuePair.split("|");
      const [formattedValue, formattedUnit] = unitValuePairArray;
      if (formattedValue !== void 0 && formattedUnit !== void 0) {
        valueObject[formattedUnit] = parseInt(
          formattedValue,
          10
        );
      }
    });
  } else {
    valueObject.value = valueOrLabel;
  }
  return valueObject;
}

// src/components/add-edit-data/add-edit-data-modal-content.tsx
var MODAL_WIDTH = "476px";
var MODAL_PROPORTIONAL_HEIGHT = "77vh";
function AddEditDataModalContent({
  inputConfig,
  metricConfigId,
  observationId,
  value,
  label,
  timestamp,
  effectiveDateTime,
  onSuccessSubmit,
  onAddData
}) {
  const {
    badge,
    heading,
    description,
    healthMetricInputs,
    showEffectiveDateTimePicker,
    informationBanner
  } = inputConfig;
  const showPatchForm = healthMetricInputs && metricConfigId && observationId && !isNil(value);
  return /* @__PURE__ */ React70.createElement(
    Modal3.Content,
    {
      padding: "$twoAndHalf $two",
      width: { "@initial": MODAL_WIDTH, "@mobile": "100vw" },
      css: {
        ".GDS-modal": {
          height: MODAL_PROPORTIONAL_HEIGHT,
          overflow: "visible",
          "@mobile": {
            height: "100vh"
          }
        },
        ".GDS-modal-close-button": {
          color: "$onSurfaceIconPrimary",
          position: "absolute",
          top: "$none",
          insetInlineStart: "calc(100% + 15vw)",
          "@mobile": {
            insetInlineStart: "unset",
            top: "$half"
          },
          "@mobileLandscape": {
            insetInlineStart: "calc(100% + 5vw)"
          },
          "@tablet": {
            insetInlineStart: "calc(100% + 10vw)"
          }
        },
        ".GDS-modal-overlay": {
          backgroundColor: "$interactiveBackgroundHovered"
        }
      }
    },
    /* @__PURE__ */ React70.createElement(
      StackLayout13,
      {
        horizontalAlignment: "stretch",
        spacing: "$one",
        css: {
          maxHeight: `calc(${MODAL_PROPORTIONAL_HEIGHT} - $five)`,
          overflow: "auto"
        }
      },
      /* @__PURE__ */ React70.createElement(
        StackLayout13,
        {
          horizontalAlignment: "center",
          css: { paddingBottom: "$two" },
          spacing: "$one"
        },
        /* @__PURE__ */ React70.createElement(
          Badge,
          {
            css: {
              backgroundColor: "$surfaceBackgroundSecondary",
              borderRadius: "$small",
              color: "$onSurfaceTextSubdued"
            }
          },
          badge
        ),
        /* @__PURE__ */ React70.createElement(Modal3.Title, null, /* @__PURE__ */ React70.createElement(HeadingText5, { level: "2", size: "xl", css: { textAlign: "center" } }, heading)),
        description && /* @__PURE__ */ React70.createElement(ParagraphText3, { css: { textAlign: "center" } }, description)
      ),
      /* @__PURE__ */ React70.createElement(StackLayout13, { horizontalAlignment: "stretch", spacing: "$two" }, healthMetricInputs && metricConfigId && !observationId && /* @__PURE__ */ React70.createElement(
        MetricFormPost,
        {
          metricConfigId,
          onSuccessSubmit: (date) => {
            onSuccessSubmit();
            if (onAddData) {
              onAddData(date);
            }
          },
          showDateTimePicker: showEffectiveDateTimePicker,
          metricInputs: healthMetricInputs
        }
      ), showPatchForm && /* @__PURE__ */ React70.createElement(
        MetricFormPatch,
        {
          metricConfigId,
          observationId,
          onSuccessSubmit,
          metricInput: healthMetricInputs[0],
          value: ParseValueForInput(value, label),
          timeStamp: timestamp,
          effectiveDateTime,
          showDateTimePicker: showEffectiveDateTimePicker
        }
      ), informationBanner && !!informationBanner.body && /* @__PURE__ */ React70.createElement(
        InformationBanner,
        {
          body: informationBanner.body,
          heading: informationBanner.heading,
          iconURL: informationBanner.icon
        }
      ))
    )
  );
}

// src/components/add-edit-data/add-edit-data-modal.tsx
function AddEditDataModal({
  modalTrigger,
  inputConfig,
  metricConfigId,
  observationId,
  value,
  label,
  timestamp,
  effectiveDateTime,
  onAddData
}) {
  const [modalOpen, setModalOpen] = useState9(false);
  React71.useEffect(() => {
    if (modalOpen) {
      trackAnalyticsEvent8(EVENT_NAME8.SCREEN_LOADED, {
        product_area: "dashboard" /* DASHBOARD */,
        screen_name: "add metric data" /* ADD_METRIC_DATA */,
        metric_type: metricConfigId
      });
    }
  }, [metricConfigId, modalOpen]);
  return /* @__PURE__ */ React71.createElement(
    Modal4.Root,
    {
      open: modalOpen,
      onOpenChange: () => {
        setModalOpen((previous) => !previous);
      }
    },
    /* @__PURE__ */ React71.createElement(Modal4.Trigger, null, modalTrigger),
    /* @__PURE__ */ React71.createElement(
      AddEditDataModalContent,
      {
        inputConfig,
        metricConfigId,
        observationId,
        value,
        label,
        timestamp,
        effectiveDateTime,
        onSuccessSubmit: () => {
          setModalOpen(false);
        },
        onAddData
      }
    )
  );
}

// src/pages/details3/components/no-data-available.tsx
import { Image as Image5 } from "@leagueplatform/genesis-commons";
import {
  Button as Button9,
  StackLayout as StackLayout14,
  Box as Box17,
  HeadingText as HeadingText6,
  UtilityText as UtilityText7
} from "@leagueplatform/genesis-core";
import { useParamsLegacy as useParams4 } from "@leagueplatform/routing";
import { useIntl as useIntl20 } from "@leagueplatform/locales";
import { trackAnalyticsEvent as trackAnalyticsEvent9, EVENT_NAME as EVENT_NAME9 } from "@leagueplatform/analytics";
import * as React73 from "react";
import { handleStaticAsset as handleStaticAsset4 } from "@leagueplatform/asset-config";
import { UnavailableDeviceConnectModal } from "@leagueplatform/health-programs";

// src/pages/details3/components/add-metric-data-button.tsx
import * as React72 from "react";
import { Button as Button8 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl19 } from "@leagueplatform/locales";
function AddMetricDataButton2({ onClick }) {
  const { formatMessage } = useIntl19();
  return /* @__PURE__ */ React72.createElement(Button8, { onClick, width: "fillContainer" }, formatMessage({
    id: "ADD_DATA"
  }));
}

// src/pages/details3/components/no-data-available.tsx
var NoDataAvailable = ({
  metric,
  canSelfRecordData,
  canConnectDevice,
  inputConfig,
  metricConfigId
}) => {
  const { formatMessage } = useIntl20();
  const { isSelfReportedDataEnabled } = useIsSelfReportedDataEnabled();
  const { dataType } = useParams4();
  const connectedDeviceImage = handleStaticAsset4(
    "DASHBOARD_NO_HEALTH_METRIC_DATA" /* DASHBOARD_NO_HEALTH_METRIC_DATA */
  );
  const [displayUnavailableOnWebModal, setDisplayUnavailableOnWebModal] = React73.useState(false);
  const showAddDataButton = canSelfRecordData && isSelfReportedDataEnabled;
  return /* @__PURE__ */ React73.createElement(
    Box17,
    {
      css: {
        marginTop: "$twoAndHalf",
        marginBottom: "$five"
      }
    },
    /* @__PURE__ */ React73.createElement(
      StackLayout14,
      {
        horizontalAlignment: "center",
        verticalAlignment: "center",
        spacing: "$one",
        css: {
          paddingTop: "$two",
          paddingBottom: "$two",
          backgroundColor: "$surfaceBackgroundTertiary",
          borderColor: "$onSurfaceBorderSubdued",
          borderWidth: "$thin",
          borderRadius: "$small",
          borderStyle: "solid"
        }
      },
      /* @__PURE__ */ React73.createElement(Box17, null, /* @__PURE__ */ React73.createElement(Image5, { width: 215, src: connectedDeviceImage, alt: "altTxt" })),
      /* @__PURE__ */ React73.createElement(StackLayout14, { verticalAlignment: "center", horizontalAlignment: "center" }, /* @__PURE__ */ React73.createElement(
        HeadingText6,
        {
          size: "md",
          level: "2",
          css: { typography: "$subtitleOne", marginBottom: "$quarter" }
        },
        formatMessage({
          id: "NO_DATA_AVAILABLE"
        })
      ), /* @__PURE__ */ React73.createElement(UtilityText7, { as: "p", css: { marginBottom: "$oneAndHalf" } }, formatMessage(
        { id: "CURRENTLY_NOT_SHARING_DATA" },
        {
          metric
        }
      )), /* @__PURE__ */ React73.createElement(StackLayout14, { css: { maxWidth: 295, width: "100%" }, spacing: "$half" }, showAddDataButton && inputConfig ? /* @__PURE__ */ React73.createElement(
        AddEditDataModal,
        {
          metricConfigId,
          inputConfig,
          modalTrigger: /* @__PURE__ */ React73.createElement(AddMetricDataButton2, null)
        }
      ) : null, canConnectDevice ? /* @__PURE__ */ React73.createElement(
        Button9,
        {
          width: "fillContainer",
          priority: "secondary",
          onClick: () => {
            setDisplayUnavailableOnWebModal(true);
            trackAnalyticsEvent9(EVENT_NAME9.BUTTON_CLICKED, {
              product_area: "dashboard" /* DASHBOARD */,
              screen_name: "dashboard metrics screen" /* DASHBOARD_METRIC_SCREEN */,
              metric_type: dataType,
              detail: "connect a device"
            });
          }
        },
        formatMessage({ id: "CONNECT_A_DEVICE" })
      ) : null))
    ),
    displayUnavailableOnWebModal ? /* @__PURE__ */ React73.createElement(
      UnavailableDeviceConnectModal,
      {
        onClose: () => setDisplayUnavailableOnWebModal(false)
      }
    ) : null
  );
};

// src/pages/all-recorded-data3/all-recorded-data.tsx
import { useParamsLegacy as useParams5 } from "@leagueplatform/routing";

// src/dashboard.config.ts
import { useConfigProperty } from "@leagueplatform/core";
var defaultConfig = {
  showFullTimeStamp: false
};
var useDashboardConfig = () => useConfigProperty("dashboard", defaultConfig);

// src/pages/all-recorded-data3/all-recorded-data.tsx
var handleAnalytics2 = (eventName, metricType, detail) => trackAnalyticsEvent10(eventName, __spreadValues({
  product_area: "dashboard" /* DASHBOARD */,
  screen_name: "all recorded data" /* ALL_RECORDED_DATA */,
  metric_type: metricType
}, detail && { detail }));
var AllRecordedData3 = () => {
  const { dataType } = useParams5();
  const { formatMessage } = useIntl21();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation14();
  const { isSelfReportedDataEnabled } = useIsSelfReportedDataEnabled();
  const {
    isLoading: isLoadingHealthMetrics,
    isError: isErrorHealthMetrics,
    isRefetching: isRefetchingHealthMetrics,
    data: healthMetrics,
    fetchNextPage,
    isFetchingNextPage,
    refetch,
    hasNextPage,
    error
  } = useInfiniteHealthMetricsV3({
    filter: {
      type: dataType
    },
    fields: { type: ["type", "value", "source", "unit", "timestamp"] }
  });
  const { showFullTimeStamp } = useDashboardConfig();
  const metricDisplayName = healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].metricDisplayName;
  useHealthMetricDocumentTitle(
    formatMessage({
      id: "ALL_RECORDED_DATA"
    }),
    metricDisplayName
  );
  React74.useEffect(() => {
    handleAnalytics2(EVENT_NAME10.SCREEN_LOADED, dataType);
  }, [dataType]);
  if (isLoadingHealthMetrics && !healthMetrics) {
    return /* @__PURE__ */ React74.createElement(LoadingIndicator3, null);
  }
  const allMetricConfigs = healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].metricComponents.data;
  const firstConfigName = allMetricConfigs == null ? void 0 : allMetricConfigs[0].name;
  const displayConfigName = Boolean(allMetricConfigs == null ? void 0 : allMetricConfigs.length) && !(allMetricConfigs == null ? void 0 : allMetricConfigs.every(
    (metricConfig) => metricConfig.name === firstConfigName
  ));
  const showHealthLiteracyOnAllRecordedDataScreen = healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].showHealthLiteracyOnAllRecordedDataScreen;
  const showAddDataButton = (healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].metricComponents.data.some(
    (metricConfig) => metricConfig.sourceType === "self_reported" || metricConfig.sourceType === "self_reported_no_input"
  )) && isSelfReportedDataEnabled;
  const canConnectDevice = healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].metricComponents.data.some(
    (config) => config.sourceType === "device"
  );
  const canSelfReport = healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].metricComponents.data.some(
    (config) => config.sourceType === "self_reported"
  );
  const showEmptyState = (healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].values.data.length) === 0;
  return /* @__PURE__ */ React74.createElement(
    HealthProfilePageWrapper4,
    {
      title: formatMessage({
        id: "ALL_RECORDED_DATA"
      }),
      sidebar: /* @__PURE__ */ React74.createElement(Sidebar4, null, /* @__PURE__ */ React74.createElement(MoreOptionsCard4, null, /* @__PURE__ */ React74.createElement(
        MoreOptionsLink3,
        {
          to: "data-sources",
          onClick: () => handleAnalytics2(
            EVENT_NAME10.BUTTON_CLICKED,
            dataType,
            "view data sources"
          )
        },
        formatMessage({ id: "VIEW_DATA_SOURCES" })
      )), showAddDataButton && healthMetrics ? /* @__PURE__ */ React74.createElement(
        AddEditDataModal,
        {
          metricConfigId: healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].id,
          inputConfig: healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].addInputConfig.data,
          modalTrigger: /* @__PURE__ */ React74.createElement(
            AddMetricDataButton,
            {
              onClick: () => handleAnalytics2(
                EVENT_NAME10.BUTTON_CLICKED,
                dataType,
                "add data"
              )
            }
          )
        }
      ) : null)
    },
    /* @__PURE__ */ React74.createElement(
      HeadingText7,
      {
        size: "xxl",
        level: "2",
        css: { paddingTop: "$oneAndHalf", paddingBottom: "$twoAndHalf" }
      },
      metricDisplayName
    ),
    /* @__PURE__ */ React74.createElement(StackLayout15, { spacing: "$oneAndHalf", horizontalAlignment: "stretch" }, isErrorHealthMetrics ? /* @__PURE__ */ React74.createElement(
      ErrorPanel,
      {
        error,
        isRefetching: isRefetchingHealthMetrics,
        onRetry: refetch
      }
    ) : null, showEmptyState ? /* @__PURE__ */ React74.createElement(
      NoDataAvailable,
      {
        metric: healthMetrics.pages[0].data[0].metricDisplayName,
        canSelfRecordData: canSelfReport,
        canConnectDevice,
        metricConfigId: healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].id,
        inputConfig: healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].addInputConfig.data
      }
    ) : null, !isErrorHealthMetrics && !showEmptyState ? /* @__PURE__ */ React74.createElement(Box18, { as: "ul", css: { width: "100%" } }, healthMetrics == null ? void 0 : healthMetrics.pages.map(
      (page) => page.data[0].values.data.map((dataMetric) => {
        const {
          id,
          sourceDisplayName,
          timestamp,
          metricComponent,
          riskIndicator
        } = dataMetric;
        const isSelfReported = metricComponent.data.sourceType === "self_reported";
        const date = formatDateWithUserProfileLocation(
          timestamp,
          DATE_FORMAT4
        );
        const displayTimestamp = formatDateWithUserProfileLocation(
          timestamp,
          { hour: "numeric", minute: "numeric" }
        );
        const { referenceRange } = dataMetric.metricComponent.data;
        return /* @__PURE__ */ React74.createElement(ListItem, { as: "li", key: id }, /* @__PURE__ */ React74.createElement(StackLayout15, null, riskIndicator && /* @__PURE__ */ React74.createElement(
          StatusBadge2,
          {
            status: riskIndicator == null ? void 0 : riskIndicator.style,
            label: riskIndicator == null ? void 0 : riskIndicator.label,
            showLight: false
          }
        ), /* @__PURE__ */ React74.createElement(UtilityText8, { as: "p", emphasis: "emphasized" }, getValueUnitDisplayLabel({
          value: dataMetric.value,
          label: dataMetric.label,
          unitOptions: dataMetric.metricComponent.data.unit
        }).map(([displayValue, displayUnit], index) => (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ React74.createElement("span", { key: `${index} + ${dataMetric.type}` }, displayValue, " ", displayUnit, " ", displayConfigName ? ` (${metricComponent.data.name.toLocaleLowerCase()})` : null)
        ))), referenceRange && /* @__PURE__ */ React74.createElement(
          UtilityText8,
          {
            emphasis: "subtle",
            css: { typography: "$caption" }
          },
          referenceRange
        ), /* @__PURE__ */ React74.createElement(
          UtilityText8,
          {
            emphasis: "subtle",
            css: { typography: "$caption" }
          },
          sourceDisplayName
        )), /* @__PURE__ */ React74.createElement(
          StackLayout15,
          {
            orientation: "horizontal",
            horizontalAlignment: "end",
            verticalAlignment: "center",
            spacing: "$half"
          },
          /* @__PURE__ */ React74.createElement(
            StackLayout15,
            {
              horizontalAlignment: "end",
              verticalAlignment: "center"
            },
            /* @__PURE__ */ React74.createElement(
              UtilityText8,
              {
                css: {
                  paddingTop: "$half"
                }
              },
              date
            ),
            showFullTimeStamp && /* @__PURE__ */ React74.createElement(
              UtilityText8,
              {
                as: "p",
                emphasis: "subtle",
                css: { typography: "$caption" }
              },
              displayTimestamp
            )
          ),
          isSelfReported && isSelfReportedDataEnabled && /* @__PURE__ */ React74.createElement(
            AddEditDataModal,
            {
              metricConfigId: page.data[0].id,
              observationId: dataMetric.id,
              inputConfig: dataMetric.editInputConfig.data,
              label: dataMetric.label,
              value: dataMetric.value,
              timestamp: dataMetric.timestamp,
              effectiveDateTime: dataMetric.effectiveTime,
              modalTrigger: /* @__PURE__ */ React74.createElement(
                Button10,
                {
                  priority: "secondary",
                  quiet: true,
                  icon: "descriptiveCompose",
                  hideLabel: true
                },
                formatMessage(
                  { id: "EDIT_METRIC_DATA" },
                  {
                    metric: metricDisplayName
                  }
                )
              )
            }
          )
        ));
      })
    ), hasNextPage && /* @__PURE__ */ React74.createElement(
      Box18,
      {
        css: {
          display: "flex",
          justifyContent: "center",
          marginTop: "$twoAndHalf"
        }
      },
      /* @__PURE__ */ React74.createElement(
        Button10,
        {
          priority: "secondary",
          disabled: isFetchingNextPage,
          onClick: () => {
            fetchNextPage();
          }
        },
        formatMessage({ id: "LOAD_MORE" }).toLocaleUpperCase()
      )
    )) : null, showHealthLiteracyOnAllRecordedDataScreen ? /* @__PURE__ */ React74.createElement(React74.Fragment, null, /* @__PURE__ */ React74.createElement(HealthPrograms, { metric: dataType }), /* @__PURE__ */ React74.createElement(HealthLiteracyContent, { metric: dataType })) : null)
  );
};

// src/pages/data-sources/data-sources.tsx
import * as React76 from "react";
import { HealthProfilePageWrapper as HealthProfilePageWrapper5 } from "@leagueplatform/health-profile-common";
import {
  css as css4,
  Flex as Flex9,
  genesisStyled as genesisStyled7,
  HeadingOne as HeadingOne2,
  Text
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl23 } from "@leagueplatform/locales";

// src/hooks/use-get-health-sources.hook.ts
import { useQuery as useQuery6 } from "@tanstack/react-query";
import { captureError as captureError5 } from "@leagueplatform/observability";
import {
  getHealthSources
} from "@leagueplatform/dashboard-api";
function useHealthSources(params) {
  return useQuery6(["health-sources", params], () => getHealthSources(params), {
    onError(error) {
      captureError5(new Error(`Unable to fetch health sources: ${error}`));
    }
  });
}

// src/pages/data-sources/data-sources.tsx
import {
  LoadingIndicator as LoadingIndicator4
} from "@leagueplatform/web-common-components";
import { usePageViewAnalytics as usePageViewAnalytics2 } from "@leagueplatform/analytics";
import { useParamsLegacy as useParams6 } from "@leagueplatform/routing";

// src/pages/data-sources/data-source-item.tsx
import * as React75 from "react";
import { SubtitleOne as SubtitleOne4, Image as Image6, Flex as Flex8 } from "@leagueplatform/genesis-commons";
import { handleStaticAsset as handleStaticAsset5 } from "@leagueplatform/asset-config";

// src/constants/use-data-source-config.ts
import { useMemo as useMemo3 } from "react";
import { useIntl as useIntl22 } from "@leagueplatform/locales";
var SUPPORTED_SOURCES = [
  "apple_health",
  "fitbit",
  "garmin",
  "google_fit_sdk",
  "ihealth",
  "omron",
  "polar",
  "samsung_health",
  "strava",
  "withings",
  "health_plan",
  "no_source_data",
  "android_health_connect"
];
var isSupportedHealthDevice = (healthDevice) => SUPPORTED_SOURCES.includes(healthDevice);
var ICONS3 = {
  apple_health: "DASHBOARD_APPLE_HEALTH" /* DASHBOARD_APPLE_HEALTH */,
  fitbit: "DASHBOARD_FITBIT" /* DASHBOARD_FITBIT */,
  garmin: "DASHBOARD_GARMIN" /* DASHBOARD_GARMIN */,
  google_fit_sdk: "DASHBOARD_GOOGLE_FIT" /* DASHBOARD_GOOGLE_FIT */,
  ihealth: "DASHBOARD_I_HEALTH" /* DASHBOARD_I_HEALTH */,
  omron: "DASHBOARD_OMRON" /* DASHBOARD_OMRON */,
  polar: "DASHBOARD_POLAR" /* DASHBOARD_POLAR */,
  samsung_health: "DASHBOARD_SAMSUNG_HEALTH" /* DASHBOARD_SAMSUNG_HEALTH */,
  strava: "DASHBOARD_STRAVA" /* DASHBOARD_STRAVA */,
  withings: "DASHBOARD_WITHINGS" /* DASHBOARD_WITHINGS */,
  health_plan: "DASHBOARD_HEALTH_PLAN" /* DASHBOARD_HEALTH_PLAN */,
  no_source_data: "DASHBOARD_NO_DATA_SOURCE" /* DASHBOARD_NO_DATA_SOURCE */,
  android_health_connect: "DASHBOARD_ANDROID_HEALTH_CONNECT" /* DASHBOARD_ANDROID_HEALTH_CONNECT */
  // bluetooth: DASHBOARD_ASSET_MAP.DASHBOARD_BLUETOOTH,
  // vital_snap: DASHBOARD_ASSET_MAP.DASHBOARD_VITAL_SNAP,
  // biotel_care: DASHBOARD_ASSET_MAP.DASHBOARD_BIO_TEL_CAR,
  // iglucose: DASHBOARD_ASSET_MAP.DASHBOARD_I_GLUCOSE,
  // lose_it: DASHBOARD_ASSET_MAP.DASHBOARD_LOSE_IT,
  // misfit: DASHBOARD_ASSET_MAP.DASHBOARD_MISFIT,
  // underarmour: DASHBOARD_ASSET_MAP.DASHBOARD_UNDER_ARMOUR,
  // yoo_fitness: DASHBOARD_ASSET_MAP.DASHBOARD_YOO,
};
var useDataSourceConfigMap = () => {
  const { $tmap } = useIntl22();
  return useMemo3(() => {
    const source = $tmap({
      apple_health: "APPLE_HEALTH",
      fitbit: "FITBIT",
      garmin: "GARMIN",
      google_fit_sdk: "GOOGLE_FIT",
      ihealth: "IHEALTH",
      omron: "OMRON",
      polar: "POLAR",
      samsung_health: "SAMSUNG_HEALTH",
      strava: "STRAVA",
      withings: "WITHINGS",
      health_plan: "HEALTH_PLAN",
      no_source_data: "NO_DATA_SOURCES",
      android_health_connect: "ANDROID_HEALTH_CONNECT"
      // bluetooth: 'BLUETOOTH'
      // vital_snap: 'VITAL_SNAP',
      // biotel_care: 'BIOTEL_CARE',
      // iglucose: 'IGLUCOSE',
      // lose_it: 'LOSE_IT',
      // misfit: 'MISFIT',
      // underarmour: 'UNDERARMOUR'
      // yoo_fitness: 'YOO_FITNESS',
    });
    return {
      source,
      icon: (dataSource) => ICONS3[dataSource]
    };
  }, [$tmap]);
};

// src/pages/data-sources/data-source-item.tsx
var SourceLogoIcon = ({ src }) => /* @__PURE__ */ React75.createElement(Image6, { alt: "", width: "36px", src });
var DataSourceItem = ({ dataSource }) => {
  const dataSourceConfig = useDataSourceConfigMap();
  if (!isSupportedHealthDevice(dataSource.device)) {
    return null;
  }
  const source = dataSourceConfig.source(dataSource.device);
  const icon = dataSourceConfig.icon(dataSource.device);
  return /* @__PURE__ */ React75.createElement(
    Flex8,
    {
      justifyContent: "start",
      alignItems: "center",
      paddingY: "one",
      borderBottomWidth: "thin",
      borderColor: "onSurface.border.subdued"
    },
    /* @__PURE__ */ React75.createElement(SourceLogoIcon, { src: handleStaticAsset5(icon) }),
    /* @__PURE__ */ React75.createElement(SubtitleOne4, { paddingInlineStart: "one" }, source)
  );
};

// src/pages/data-sources/data-sources.tsx
var DataSourcesWidth = "486px";
var DataTypeText = genesisStyled7("span")(
  css4({
    fontWeight: "bold"
  })
);
function DataSourcesItems({
  children,
  isError,
  refetch,
  isRefetching,
  error
}) {
  if (isError) {
    return /* @__PURE__ */ React76.createElement(ErrorPanel, { error, isRefetching, onRetry: refetch });
  }
  return /* @__PURE__ */ React76.createElement(React76.Fragment, null, children);
}
function DataSourcesPageWrapper({ children }) {
  const { formatMessage } = useIntl23();
  return /* @__PURE__ */ React76.createElement(
    HealthProfilePageWrapper5,
    {
      title: formatMessage({
        id: "DATA_SOURCES"
      })
    },
    children
  );
}
function DataSources() {
  var _a, _b;
  const { dataType } = useParams6();
  const { formatMessage } = useIntl23();
  usePageViewAnalytics2({
    product_area: "dashboard" /* DASHBOARD */,
    screen_name: "view data sources" /* VIEW_DATA_SOURCES */,
    metric_type: dataType
  });
  const {
    isLoading,
    isRefetching,
    isError: isHealthSourcesError,
    data: healthSources,
    refetch,
    error: healthSourcesError
  } = useHealthSources({
    filter: { type: dataType }
  });
  const {
    isLoading: isLoadingHealthMetrics,
    isError: isErrorHealthMetrics,
    data: healthMetrics,
    error: healthMetricsError
  } = useInfiniteHealthMetricsV2({
    filter: {
      type: dataType
    },
    fields: { type: ["type", "value", "source", "unit", "timestamp"] }
  });
  const isHealthPlanIncluded = (_a = healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].configs) == null ? void 0 : _a.data.some(
    (metricConfig) => metricConfig.source === "health_plan"
  );
  const isSelfReportedIncluded = (_b = healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].configs) == null ? void 0 : _b.data.some(
    (metricConfig) => metricConfig.source === "self_reported" || metricConfig.source === "self_reported_no_input"
  );
  const noSourceData = !isHealthPlanIncluded && !(healthSources == null ? void 0 : healthSources.data.length);
  const isOnlySelfReported = isSelfReportedIncluded && noSourceData;
  const metricDisplayName = healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].metricDisplayName;
  const isError = isHealthSourcesError && isErrorHealthMetrics && !isHealthPlanIncluded;
  useHealthMetricDocumentTitle(
    formatMessage({
      id: "DATA_SOURCES"
    }),
    metricDisplayName
  );
  if (isLoading || isLoadingHealthMetrics) {
    return /* @__PURE__ */ React76.createElement(LoadingIndicator4, null);
  }
  const errors = [healthSourcesError, healthMetricsError];
  if (isError || isErrorHealthMetrics) {
    return /* @__PURE__ */ React76.createElement(DataSourcesPageWrapper, null, /* @__PURE__ */ React76.createElement(
      ErrorPanel,
      {
        error: errors,
        isRefetching,
        onRetry: refetch
      }
    ));
  }
  return /* @__PURE__ */ React76.createElement(DataSourcesPageWrapper, null, /* @__PURE__ */ React76.createElement(Flex9, { flexDirection: "column", maxWidth: DataSourcesWidth }, /* @__PURE__ */ React76.createElement(HeadingOne2, { as: "h2", paddingBottom: "oneAndHalf", paddingTop: "oneAndHalf" }, metricDisplayName), /* @__PURE__ */ React76.createElement(Text, { paddingBottom: "oneAndHalf" }, formatMessage({
    id: "SOURCES_CAN_UPDATE"
  }), " ", /* @__PURE__ */ React76.createElement(DataTypeText, null, metricDisplayName), "."), /* @__PURE__ */ React76.createElement(Text, { paddingBottom: "oneAndHalf" }, formatMessage({
    id: "WHEN_MULTIPLE_SOURCES_AVAILABLE"
  })), /* @__PURE__ */ React76.createElement(
    DataSourcesItems,
    {
      isError,
      refetch,
      isRefetching,
      error: errors
    },
    isOnlySelfReported ? /* @__PURE__ */ React76.createElement(
      DataSourceItem,
      {
        dataSource: {
          type: dataType,
          device: "no_source_data"
        }
      }
    ) : /* @__PURE__ */ React76.createElement(React76.Fragment, null, healthSources == null ? void 0 : healthSources.data.map((healthSource) => /* @__PURE__ */ React76.createElement(DataSourceItem, { dataSource: healthSource })), isHealthPlanIncluded && /* @__PURE__ */ React76.createElement(
      DataSourceItem,
      {
        dataSource: {
          type: dataType,
          device: "health_plan"
        }
      }
    ))
  )));
}

// src/pages/data-sources3/data-sources.tsx
import * as React78 from "react";
import { HealthProfilePageWrapper as HealthProfilePageWrapper6 } from "@leagueplatform/health-profile-common";
import {
  css as css5,
  Flex as Flex11,
  genesisStyled as genesisStyled8,
  HeadingOne as HeadingOne3,
  Text as Text2
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl24 } from "@leagueplatform/locales";
import {
  LoadingIndicator as LoadingIndicator5
} from "@leagueplatform/web-common-components";
import { usePageViewAnalytics as usePageViewAnalytics3 } from "@leagueplatform/analytics";
import { useParamsLegacy as useParams7 } from "@leagueplatform/routing";

// src/pages/data-sources3/data-source.item.tsx
import * as React77 from "react";
import { SubtitleOne as SubtitleOne5, Image as Image7, Flex as Flex10 } from "@leagueplatform/genesis-commons";
import { handleStaticAsset as handleStaticAsset6 } from "@leagueplatform/asset-config";
var SourceLogoIcon2 = ({ src }) => /* @__PURE__ */ React77.createElement(Image7, { alt: "", width: "36px", src });
var DataSourceItem2 = ({ dataSource }) => {
  const dataSourceConfig = useDataSourceConfigMap();
  if (!isSupportedHealthDevice(dataSource.device)) {
    return null;
  }
  const source = dataSourceConfig.source(dataSource.device);
  const icon = dataSourceConfig.icon(dataSource.device);
  return /* @__PURE__ */ React77.createElement(
    Flex10,
    {
      justifyContent: "start",
      alignItems: "center",
      paddingY: "one",
      borderBottomWidth: "thin",
      borderColor: "onSurface.border.subdued"
    },
    /* @__PURE__ */ React77.createElement(SourceLogoIcon2, { src: handleStaticAsset6(icon) }),
    /* @__PURE__ */ React77.createElement(SubtitleOne5, { paddingInlineStart: "one" }, source)
  );
};

// src/pages/data-sources3/data-sources.tsx
var DataSourcesWidth2 = "486px";
var DataTypeText2 = genesisStyled8("span")(
  css5({
    fontWeight: "bold"
  })
);
function DataSourcesItems2({
  children,
  isError,
  refetch,
  isRefetching,
  error
}) {
  if (isError) {
    return /* @__PURE__ */ React78.createElement(ErrorPanel, { error, isRefetching, onRetry: refetch });
  }
  return children;
}
function DataSourcesPageWrapper2({ children }) {
  const { formatMessage } = useIntl24();
  return /* @__PURE__ */ React78.createElement(
    HealthProfilePageWrapper6,
    {
      title: formatMessage({
        id: "DATA_SOURCES"
      })
    },
    children
  );
}
function DataSourcesV3() {
  var _a, _b;
  const { dataType } = useParams7();
  const { formatMessage } = useIntl24();
  usePageViewAnalytics3({
    product_area: "dashboard" /* DASHBOARD */,
    screen_name: "view data sources" /* VIEW_DATA_SOURCES */,
    metric_type: dataType
  });
  const {
    isLoading: isLoadingHealthSources,
    isRefetching: isRefetchingHealthSources,
    isError: isErrorHealthSources,
    data: healthSources,
    refetch: refetchHealthSources,
    error: healthSourcesError
  } = useHealthSources({
    filter: { type: dataType }
  });
  const {
    isLoading: isLoadingHealthMetrics,
    isRefetching: isRefetchingHealthMetrics,
    isError: isErrorHealthMetrics,
    data: healthMetrics,
    refetch: refetchHealthMetics,
    error: healthMetricsError
  } = useInfiniteHealthMetricsV3({
    filter: {
      type: dataType
    },
    fields: { type: ["type", "value", "source", "unit", "timestamp"] }
  });
  const isRefetching = isRefetchingHealthSources || isRefetchingHealthMetrics;
  const isHealthPlanIncluded = (_a = healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].metricComponents) == null ? void 0 : _a.data.some(
    (metricComponent) => metricComponent.sourceType === "health_plan"
  );
  const isSelfReportedIncluded = (_b = healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].metricComponents) == null ? void 0 : _b.data.some(
    (metricComponent) => metricComponent.sourceType === "self_reported" || metricComponent.sourceType === "self_reported_no_input"
  );
  const noSourceData = !isHealthPlanIncluded && !(healthSources == null ? void 0 : healthSources.data.length);
  const isOnlySelfReported = isSelfReportedIncluded && noSourceData;
  const metricDisplayName = healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].metricDisplayName;
  useHealthMetricDocumentTitle(
    formatMessage({
      id: "DATA_SOURCES"
    }),
    metricDisplayName
  );
  if (isLoadingHealthSources || isLoadingHealthMetrics) {
    return /* @__PURE__ */ React78.createElement(LoadingIndicator5, null);
  }
  const isError = isErrorHealthSources && !isHealthPlanIncluded && !isSelfReportedIncluded || isErrorHealthMetrics;
  if (isError) {
    return /* @__PURE__ */ React78.createElement(DataSourcesPageWrapper2, null, /* @__PURE__ */ React78.createElement(
      ErrorPanel,
      {
        isRefetching,
        onRetry: () => {
          refetchHealthSources();
          refetchHealthMetics();
        },
        error: [healthSourcesError, healthMetricsError]
      }
    ));
  }
  return /* @__PURE__ */ React78.createElement(DataSourcesPageWrapper2, null, /* @__PURE__ */ React78.createElement(Flex11, { flexDirection: "column", maxWidth: DataSourcesWidth2 }, /* @__PURE__ */ React78.createElement(HeadingOne3, { as: "h2", paddingBottom: "oneAndHalf", paddingTop: "oneAndHalf" }, metricDisplayName), /* @__PURE__ */ React78.createElement(Text2, { paddingBottom: "oneAndHalf" }, formatMessage({
    id: "SOURCES_CAN_UPDATE"
  }), " ", /* @__PURE__ */ React78.createElement(DataTypeText2, null, metricDisplayName), "."), /* @__PURE__ */ React78.createElement(Text2, { paddingBottom: "oneAndHalf" }, formatMessage({
    id: "WHEN_MULTIPLE_SOURCES_AVAILABLE"
  })), /* @__PURE__ */ React78.createElement(
    DataSourcesItems2,
    {
      isError,
      refetch: () => {
        refetchHealthSources();
        refetchHealthMetics();
      },
      isRefetching,
      error: [healthSourcesError, healthMetricsError]
    },
    isOnlySelfReported ? /* @__PURE__ */ React78.createElement(
      DataSourceItem2,
      {
        dataSource: {
          type: dataType,
          device: "no_source_data"
        }
      }
    ) : /* @__PURE__ */ React78.createElement(React78.Fragment, null, healthSources == null ? void 0 : healthSources.data.map((healthSource) => /* @__PURE__ */ React78.createElement(
      DataSourceItem2,
      {
        key: healthSource.id,
        dataSource: healthSource
      }
    )), isHealthPlanIncluded && /* @__PURE__ */ React78.createElement(
      DataSourceItem2,
      {
        dataSource: {
          type: dataType,
          device: "health_plan"
        }
      }
    ))
  )));
}

// src/pages/details/details.tsx
import * as React97 from "react";
import sub2 from "date-fns/sub";
import add from "date-fns/add";
import isFuture from "date-fns/isFuture";
import isToday5 from "date-fns/isToday";
import {
  HealthProfilePageWrapper as HealthProfilePageWrapper7,
  MoreOptionsCard as MoreOptionsCard5,
  MoreOptionsLink as MoreOptionsLink4
} from "@leagueplatform/health-profile-common";
import { useIntl as useIntl38 } from "@leagueplatform/locales";
import { Sidebar as Sidebar5, SkeletonBox as SkeletonBox3 } from "@leagueplatform/web-common-components";
import { usePageViewAnalytics as usePageViewAnalytics4 } from "@leagueplatform/analytics";
import { useParamsLegacy as useParams8 } from "@leagueplatform/routing";

// src/pages/details/hooks/use-chart-data.ts
function useChartData({ chartView, metric, from }) {
  const useGetHealthMetricsQuery = useGetHealthMetrics(
    {
      interval: chartView === CHART_VIEWS.WEEKLY ? "weekly" : "monthly",
      filter: { type: metric },
      fields: { type: ["type", "value", "unit", "timestamp"] },
      from: from.toISOString()
    },
    {
      // We only need to backfill legacy charts. Dynamic dashboard will contain all days.
      backfill: true
    }
  );
  return useGetHealthMetricsQuery;
}

// src/pages/details/components/health-programs.tsx
import * as React79 from "react";
import {
  HealthProgramCarousels as HealthProgramCarousels2,
  useHealthProgramsCategory as useHealthProgramsCategory2
} from "@leagueplatform/health-programs";
function HealthPrograms2({ metric }) {
  const healthProgramsCategory = useHealthProgramsCategory2({
    categoryId: metric
  });
  return /* @__PURE__ */ React79.createElement(
    HealthProgramCarousels2,
    {
      isLoading: healthProgramsCategory.isLoading,
      carousels: [
        {
          title: healthProgramsCategory.name,
          programs: healthProgramsCategory.programs
        }
      ],
      carouselsCategory: "dashboard metrics screen" /* DASHBOARD_METRIC_SCREEN */
    }
  );
}

// src/pages/details/components/health-metrics-chart.tsx
import * as React95 from "react";
import { Flex as Flex16 } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl36 } from "@leagueplatform/locales";
import {
  SHORT_DATE_FORMAT as SHORT_DATE_FORMAT2,
  SHORT_MONTH_FORMAT as SHORT_MONTH_FORMAT3,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation23
} from "@leagueplatform/web-common";

// src/pages/details/hooks/health-metrics-chart.hooks.ts
import * as React80 from "react";
import isToday3 from "date-fns/isToday";
function useIsSwitchingView({
  isPreviousData,
  chartView
}) {
  const [previousView, setPreviousView] = React80.useState(chartView);
  React80.useEffect(() => {
    if (!isPreviousData && chartView !== previousView) {
      setPreviousView(chartView);
    }
  }, [previousView, chartView, isPreviousData]);
  const isSwitchingView = previousView !== chartView;
  return isSwitchingView;
}
function useTodaysValue(data) {
  const [todaysValue, setTodaysValue] = React80.useState();
  React80.useEffect(() => {
    if ((data == null ? void 0 : data.length) && isToday3(new Date(data[0].timestamp)) && !todaysValue && data[0].value !== null) {
      setTodaysValue(data[0].value);
    }
  }, [data, todaysValue]);
  return todaysValue;
}
function useLastUpdatedValue(healthMetrics) {
  const [lastUpdated, setLastUpdated] = React80.useState();
  React80.useEffect(() => {
    if (healthMetrics.length && !lastUpdated) {
      for (let i = 0; i < healthMetrics.length; i += 1) {
        if (healthMetrics[i].source !== "backfilled") {
          setLastUpdated(healthMetrics[i].timestamp);
          break;
        }
      }
    }
  }, [healthMetrics, lastUpdated]);
  return lastUpdated;
}
function getAverageValue(healthMetrics) {
  let average2 = 0;
  if (healthMetrics.length > 0)
    average2 = healthMetrics.reduce(
      (sum, healthMetric) => healthMetric.value ? sum + healthMetric.value : sum,
      0
    ) / healthMetrics.length;
  return average2;
}
function useMeasurementType(metric, unit, healthMetrics) {
  const { formatUnit } = useLocaleUnitFormatter();
  const measurementType = formatUnit(
    metric,
    unit,
    healthMetrics.length > 0 && healthMetrics[0].value ? healthMetrics[0].value : 0
  ).toLocaleLowerCase();
  return measurementType;
}
function useAverageMeasurement(metric, unit, healthMetrics) {
  var _a;
  const { formatMetricValue } = useLocaleMetricValueFormatter();
  const measurementType = useMeasurementType(metric, unit, healthMetrics);
  const averageValue = getAverageValue(healthMetrics);
  const averageMeasurement = {
    type: measurementType,
    value: (_a = formatMetricValue(averageValue, metric)) != null ? _a : ""
  };
  return averageMeasurement;
}
function useTodaysMeasurement(metric, unit, healthMetrics) {
  var _a;
  const { formatMetricValue } = useLocaleMetricValueFormatter();
  const measurementType = useMeasurementType(metric, unit, healthMetrics);
  const todaysValue = useTodaysValue(healthMetrics);
  const todaysMeasurement = {
    type: measurementType,
    value: todaysValue ? (_a = formatMetricValue(todaysValue, metric)) != null ? _a : "" : void 0
  };
  return todaysMeasurement;
}
function useGroomedHealthMetrics({
  healthMetrics,
  metric,
  unit,
  metricsFrom,
  chartView,
  hasPreviousPage
}) {
  const isSwitchingView = useIsSwitchingView({
    isPreviousData: hasPreviousPage,
    chartView
  });
  const groomedHealthMetrics = isSwitchingView ? (
    /* If the chart data has already been loaded and the user is switching views,
     * we back fill the data for the targeted view until data from the back-end returns.
     * this allows us to paint the chart with empty data and estimate
     * the axis values causing less shifting.
     */
    backfillChartData(
      { type: metric, unit },
      [],
      metricsFrom,
      chartView === CHART_VIEWS.WEEKLY ? 7 : 30
    ).reverse()
  ) : (
    // Shallow copy and reverse since chart data is returned by the API in ascending chronological order.
    [...healthMetrics].reverse()
  );
  return groomedHealthMetrics;
}

// src/pages/details/components/week-month-view-switch.tsx
import * as React81 from "react";
import { Flex as Flex12, genesisStyled as genesisStyled9, css as css6 } from "@leagueplatform/genesis-commons";
import { Box as Box19 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl25 } from "@leagueplatform/locales";
import {
  PillTabs,
  PillTabList,
  PillTab
} from "@leagueplatform/web-common-components";
var ViewSwitcherContainer = genesisStyled9(Flex12)(
  css6({
    marginTop: "-30px"
  })
);
function WeekMonthViewSwitch({ onChange }) {
  const { formatMessage } = useIntl25();
  return /* @__PURE__ */ React81.createElement(ViewSwitcherContainer, null, /* @__PURE__ */ React81.createElement(PillTabs, { onValueChange: onChange, defaultValue: CHART_VIEWS.WEEKLY }, /* @__PURE__ */ React81.createElement(Box19, { css: { width: "fit-content" } }, /* @__PURE__ */ React81.createElement(PillTabList, null, /* @__PURE__ */ React81.createElement(PillTab, { value: CHART_VIEWS.WEEKLY }, formatMessage({
    id: "LAST_7_DAYS"
  })), /* @__PURE__ */ React81.createElement(PillTab, { value: CHART_VIEWS.MONTHLY }, formatMessage({
    id: "LAST_30_DAYS"
  }))))));
}

// src/pages/details/components/pagination-controls.tsx
import * as React83 from "react";
import { Flex as Flex13, HeadingOne as HeadingOne4, Box as Box21 } from "@leagueplatform/genesis-commons";

// src/components/arrow-button/ArrowButton.tsx
import {
  Box as Box20,
  css as css7,
  genesisStyled as genesisStyled10,
  SubtleButton
} from "@leagueplatform/genesis-commons";
import { Icon as Icon6, ICONS as ICONS4 } from "@leagueplatform/ui-kit";
import * as React82 from "react";
var StyledArrowButton = genesisStyled10(SubtleButton)(
  css7({
    borderRadius: "circle",
    height: "two",
    paddingInlineStart: "0",
    paddingInlineEnd: "0",
    width: "two"
  })
);
var ArrowContainer = genesisStyled10(Box20)(
  css7({
    as: "span",
    display: "block",
    marginTop: "-0.225em"
  })
);
var ArrowButton = ({
  ariaLabel,
  direction,
  onClick,
  disabled
}) => {
  const arrowIcon = direction === "back" ? ICONS4.BACK_CHEVRON : ICONS4.FORWARD_CHEVRON;
  return /* @__PURE__ */ React82.createElement(Box20, null, /* @__PURE__ */ React82.createElement(
    StyledArrowButton,
    {
      "aria-label": ariaLabel,
      disabled,
      onClick
    },
    /* @__PURE__ */ React82.createElement(ArrowContainer, null, /* @__PURE__ */ React82.createElement(Icon6, { size: 16, icon: arrowIcon }))
  ));
};

// src/pages/details/components/pagination-controls.tsx
function PaginationControls({
  title,
  previous,
  next
}) {
  return /* @__PURE__ */ React83.createElement(Flex13, { paddingBottom: "twoAndHalf", paddingTop: "five", alignItems: "flex-end" }, /* @__PURE__ */ React83.createElement(Box21, { marginBottom: "quarter" }, /* @__PURE__ */ React83.createElement(
    ArrowButton,
    {
      ariaLabel: previous.label,
      disabled: previous.enabled,
      onClick: previous.onClick,
      direction: "back"
    }
  )), /* @__PURE__ */ React83.createElement(
    HeadingOne4,
    {
      textAlign: "center",
      as: "h2",
      paddingInlineStart: "oneAndHalf",
      paddingInlineEnd: "oneAndHalf"
    },
    title
  ), /* @__PURE__ */ React83.createElement(Box21, { marginBottom: "quarter" }, /* @__PURE__ */ React83.createElement(
    ArrowButton,
    {
      ariaLabel: next.label,
      disabled: next.enabled,
      onClick: next.onClick,
      direction: "forward"
    }
  )));
}

// src/pages/details/components/average-value-panel.tsx
import * as React84 from "react";
import {
  Flex as Flex14,
  HeadingOne as HeadingOne5,
  HeadingFour as HeadingFour2,
  Caption as Caption3
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl26 } from "@leagueplatform/locales";
function AverageValuePanel({ measurement }) {
  const { formatMessage } = useIntl26();
  return /* @__PURE__ */ React84.createElement(React84.Fragment, null, /* @__PURE__ */ React84.createElement(HeadingFour2, { color: "onSurface.text.subdued" }, formatMessage({
    id: "AVERAGE"
  }).toUpperCase()), /* @__PURE__ */ React84.createElement(Flex14, { alignItems: "baseline" }, /* @__PURE__ */ React84.createElement(HeadingOne5, { textAlign: "center", as: "span" }, measurement.value), /* @__PURE__ */ React84.createElement(
    Caption3,
    {
      as: "span",
      paddingInlineStart: "quarter",
      color: "onSurface.text.subdued"
    },
    measurement.type
  )));
}

// src/pages/details/components/todays-measurement-panel.tsx
import * as React85 from "react";
import isToday4 from "date-fns/isToday";
import { useIntl as useIntl27 } from "@leagueplatform/locales";
import {
  useTheme as useTheme13,
  HeadingOne as HeadingOne6,
  HeadingTwo as HeadingTwo5,
  Flex as Flex15,
  Caption as Caption4
} from "@leagueplatform/genesis-commons";
import { useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation15 } from "@leagueplatform/web-common";
function TodaysMeasurementPanel({
  lastUpdated,
  measurement
}) {
  const { formatMessage, formatList } = useIntl27();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation15();
  const theme = useTheme13();
  const wasLastUpdateToday = !!lastUpdated && isToday4(new Date(lastUpdated));
  return /* @__PURE__ */ React85.createElement(React85.Fragment, null, /* @__PURE__ */ React85.createElement(
    Flex15,
    {
      alignItems: "baseline",
      justifyContent: "space-between",
      paddingInlineStart: "oneAndHalf",
      paddingInlineEnd: "oneAndHalf",
      paddingTop: "one",
      marginInlineEnd: "two",
      paddingBottom: "one",
      backgroundColor: "surface.background.secondary",
      width: `calc(100% - ${theme.space.two}px)`
    },
    /* @__PURE__ */ React85.createElement(HeadingTwo5, null, formatMessage({
      id: "TODAY"
    })),
    /* @__PURE__ */ React85.createElement(Flex15, { alignItems: "baseline" }, measurement.value !== void 0 ? /* @__PURE__ */ React85.createElement(React85.Fragment, null, /* @__PURE__ */ React85.createElement(HeadingOne6, { as: "span" }, measurement.value), /* @__PURE__ */ React85.createElement(
      Caption4,
      {
        as: "span",
        paddingInlineStart: "quarter",
        color: "onSurface.text.subdued"
      },
      measurement.type
    )) : /* @__PURE__ */ React85.createElement(HeadingOne6, { as: "span" }, "--"))
  ), wasLastUpdateToday ? /* @__PURE__ */ React85.createElement(
    Flex15,
    {
      width: `calc(100% - ${theme.space.two}px)`,
      paddingTop: "half",
      paddingBottom: "quarter",
      justifyContent: "flex-end",
      marginInlineEnd: "two"
    },
    /* @__PURE__ */ React85.createElement(
      Caption4,
      {
        as: "span",
        paddingInlineStart: "quarter",
        color: "onSurface.text.subdued",
        fontWeight: "bold"
      },
      formatMessage({
        id: "LAST_UPDATED"
      }),
      ":"
    ),
    /* @__PURE__ */ React85.createElement(
      Caption4,
      {
        as: "span",
        paddingInlineStart: "quarter",
        color: "onSurface.text.subdued",
        minWidth: theme.space.five
      },
      formatList(
        [
          formatMessage({
            id: "TODAY"
          }),
          formatDateWithUserProfileLocation(lastUpdated, {
            hour: "numeric",
            minute: "numeric"
          })
        ],
        { type: "conjunction", style: "narrow" }
      )
    )
  ) : null);
}

// src/pages/details/components/legacy-chart.tsx
import * as React94 from "react";

// src/components/charts/metrics/active_duration/active-duration-bar-chart.tsx
import * as React88 from "react";

// src/components/charts/core/chart-tooltip/single-measurement-tooltip.tsx
import * as React86 from "react";
import { BodyOne as BodyOne3, HeadingOne as HeadingOne7, Overline as Overline2 } from "@leagueplatform/genesis-commons";
import {
  SHORT_DATE_FORMAT,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation16
} from "@leagueplatform/web-common";
import { useIntl as useIntl28 } from "@leagueplatform/locales";
function SingleMeasurementTooltip({
  title,
  type,
  value,
  timestamp,
  unit
}) {
  const { formatMessage } = useIntl28();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation16();
  const { formatMetricValue } = useLocaleMetricValueFormatter();
  const { formatUnit } = useLocaleUnitFormatter();
  if (!isSupportedUnitMetricType(type)) {
    throw new Error(`Missing '${type}' metric configuration`);
  }
  if (value === null) {
    return null;
  }
  return /* @__PURE__ */ React86.createElement(ChartTooltip, null, /* @__PURE__ */ React86.createElement(Overline2, { color: "onSurface.text.subdued", paddingBottom: "quarter" }, `${formatMessage({ id: "TOTAL" })} ${title}`), /* @__PURE__ */ React86.createElement(HeadingOne7, { as: "span" }, formatMetricValue(value, type)), " ", /* @__PURE__ */ React86.createElement(BodyOne3, { as: "span", color: "onSurface.text.subdued" }, formatUnit(type, unit, value)), /* @__PURE__ */ React86.createElement(Overline2, { paddingTop: "quarter", as: "p", color: "onSurface.text.subdued" }, formatDateWithUserProfileLocation(
    new Date(timestamp),
    SHORT_DATE_FORMAT
  )));
}

// src/components/charts/metrics/active_duration/active-duration-bar-chart.tsx
import { useIntl as useIntl30 } from "@leagueplatform/locales";
import {
  LONG_WEEKDAY_DATE_FORMAT,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation17
} from "@leagueplatform/web-common";

// src/components/charts/metrics/metric-bar-chart.tsx
import * as React87 from "react";
import { useIntl as useIntl29 } from "@leagueplatform/locales";
function MetricBarChart(_a) {
  var _b = _a, {
    data,
    view,
    type
  } = _b, props = __objRest(_b, [
    "data",
    "view",
    "type"
  ]);
  const { $tmap, $tifelse } = useIntl29();
  const Chart4 = view === CHART_VIEWS.WEEKLY ? WeeklyBarGraph : MonthlyBarGraph;
  const axisBottomLabel = $tifelse(
    view === CHART_VIEWS.WEEKLY,
    "DAY_OF_THE_WEEK",
    "DAY_OF_THE_MONTH"
  );
  const insightHeaderMessage = $tmap({
    distance: "INSIGHT_CARD_HEADER_DISTANCE",
    steps: "INSIGHT_CARD_HEADER_STEPS",
    active_duration: "INSIGHT_CARD_HEADER_ACTIVE_DURATION",
    mindful_duration: "INSIGHT_CARD_HEADER_MINDFUL_DURATION",
    floors_climbed: "INSIGHT_CARD_HEADER_FLOORS_CLIMBED",
    energy_burned: "INSIGHT_CARD_HEADER_ENERGY_BURNED"
  })(type);
  return /* @__PURE__ */ React87.createElement(
    Chart4,
    __spreadValues({
      data,
      accessors: {
        xAccessor: (datum) => datum.timestamp,
        yAccessor: (datum) => datum.value
      },
      title: $tifelse(
        view === CHART_VIEWS.WEEKLY,
        "INSIGHT_CHART_WEEK_TITLE",
        "INSIGHT_CHART_MONTH_TITLE",
        {
          type: insightHeaderMessage
        }
      ),
      axisBottomLabel
    }, props)
  );
}

// src/components/charts/metrics/active_duration/active-duration-bar-chart.tsx
function ActiveDurationBarChart({
  data,
  view,
  type,
  unit
}) {
  const { formatMessage, $tifelse } = useIntl30();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation17();
  const { formatMetricValue } = useLocaleMetricValueFormatter();
  const { formatUnit } = useLocaleUnitFormatter();
  return /* @__PURE__ */ React88.createElement(
    MetricBarChart,
    {
      yMaxFromEnums: 0,
      data,
      view,
      type,
      description: $tifelse(
        view === CHART_VIEWS.WEEKLY,
        "INSIGHT_CHART_ACTIVE_DURATION_WEEK_DESCRIPTION",
        "INSIGHT_CHART_ACTIVE_DURATION_MONTH_DESCRIPTION"
      ),
      axisLeftLabel: `${formatMessage({
        id: "ACTIVE_DURATION"
      })} (${formatUnit(type, unit)})`.toLocaleUpperCase(),
      ariaDatumLabel: (datum) => formatMessage(
        { id: "INSIGHT_CHART_ACTIVE_DURATION_DATUM_LABEL" },
        {
          value: formatMetricValue(datum.value, type),
          date: formatDateWithUserProfileLocation(
            new Date(datum.timestamp),
            LONG_WEEKDAY_DATE_FORMAT
          )
        }
      ),
      renderTooltip: (datum) => /* @__PURE__ */ React88.createElement(
        SingleMeasurementTooltip,
        __spreadValues({
          title: formatMessage({ id: "ACTIVE_DURATION" })
        }, datum)
      )
    }
  );
}

// src/components/charts/metrics/distance/distance-bar-chart.tsx
import * as React89 from "react";
import { useIntl as useIntl31 } from "@leagueplatform/locales";
import {
  LONG_WEEKDAY_DATE_FORMAT as LONG_WEEKDAY_DATE_FORMAT2,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation18
} from "@leagueplatform/web-common";
function DistanceBarChart({
  data,
  view,
  type,
  unit
}) {
  const { formatMessage, $tifelse } = useIntl31();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation18();
  const { formatUnit } = useLocaleUnitFormatter();
  const { formatMetricValue } = useLocaleMetricValueFormatter();
  return /* @__PURE__ */ React89.createElement(
    MetricBarChart,
    {
      yMaxFromEnums: 0,
      data,
      view,
      type,
      description: $tifelse(
        view === CHART_VIEWS.WEEKLY,
        "INSIGHT_CHART_DISTANCE_WEEK_DESCRIPTION",
        "INSIGHT_CHART_DISTANCE_MONTH_DESCRIPTION",
        { unit }
      ),
      axisLeftLabel: `${formatMessage({
        id: "INSIGHT_CARD_HEADER_DISTANCE"
      })} (${formatUnit(type, unit)})`.toLocaleUpperCase(),
      ariaDatumLabel: (datum) => formatMessage(
        { id: "INSIGHT_CHART_DISTANCE_DATUM_LABEL" },
        {
          distance: formatMetricValue(datum.value, type),
          unit: formatUnit(datum.type, datum.unit),
          date: formatDateWithUserProfileLocation(
            new Date(datum.timestamp),
            LONG_WEEKDAY_DATE_FORMAT2
          )
        }
      ),
      renderTooltip: (datum) => /* @__PURE__ */ React89.createElement(
        SingleMeasurementTooltip,
        __spreadValues({
          title: formatMessage({ id: "INSIGHT_CARD_HEADER_DISTANCE" })
        }, datum)
      )
    }
  );
}

// src/components/charts/metrics/energy_burned/energy-burned-bar-chart.tsx
import * as React90 from "react";
import { useIntl as useIntl32 } from "@leagueplatform/locales";
import {
  LONG_WEEKDAY_DATE_FORMAT as LONG_WEEKDAY_DATE_FORMAT3,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation19
} from "@leagueplatform/web-common";
function EnergyBurnedBarChart({
  data,
  view,
  type,
  unit
}) {
  const { formatMessage, $tifelse } = useIntl32();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation19();
  const { formatUnit } = useLocaleUnitFormatter();
  const { formatMetricValue } = useLocaleMetricValueFormatter();
  return /* @__PURE__ */ React90.createElement(
    MetricBarChart,
    {
      yMaxFromEnums: 0,
      data,
      view,
      type,
      description: $tifelse(
        view === CHART_VIEWS.WEEKLY,
        "INSIGHT_CHART_ENERGY_BURNED_WEEK_DESCRIPTION",
        "INSIGHT_CHART_ENERGY_BURNED_MONTH_DESCRIPTION",
        { unit }
      ),
      axisLeftLabel: `${formatMessage({
        id: "INSIGHT_CARD_HEADER_ENERGY_BURNED"
      })} (${formatUnit(type, unit)})`.toLocaleUpperCase(),
      ariaDatumLabel: (datum) => formatMessage(
        { id: "INSIGHT_CHART_ENERGY_BURNED_DATUM_LABEL" },
        {
          energy: formatMetricValue(datum.value, type),
          unit: formatUnit(datum.type, datum.unit),
          date: formatDateWithUserProfileLocation(
            new Date(datum.timestamp),
            LONG_WEEKDAY_DATE_FORMAT3
          )
        }
      ),
      renderTooltip: (datum) => /* @__PURE__ */ React90.createElement(
        SingleMeasurementTooltip,
        __spreadValues({
          title: formatMessage({ id: "INSIGHT_CARD_HEADER_ENERGY_BURNED" })
        }, datum)
      )
    }
  );
}

// src/components/charts/metrics/floors_climbed/floors-climbed-bar-chart.tsx
import * as React91 from "react";
import { useIntl as useIntl33 } from "@leagueplatform/locales";
import {
  LONG_WEEKDAY_DATE_FORMAT as LONG_WEEKDAY_DATE_FORMAT4,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation20
} from "@leagueplatform/web-common";
function FloorsClimbedBarChart({
  data,
  view,
  type
}) {
  const { formatMessage, $tifelse } = useIntl33();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation20();
  const { formatMetricValue } = useLocaleMetricValueFormatter();
  return /* @__PURE__ */ React91.createElement(
    MetricBarChart,
    {
      yMaxFromEnums: 0,
      data,
      view,
      type,
      description: $tifelse(
        view === CHART_VIEWS.WEEKLY,
        "INSIGHT_CHART_FLOORS_CLIMBED_WEEK_DESCRIPTION",
        "INSIGHT_CHART_FLOORS_CLIMBED_MONTH_DESCRIPTION"
      ),
      axisLeftLabel: `${formatMessage({
        id: "INSIGHT_CARD_HEADER_FLOORS_CLIMBED"
      })}`.toLocaleUpperCase(),
      ariaDatumLabel: (datum) => formatMessage(
        { id: "INSIGHT_CHART_FLOORS_CLIMBED_DATUM_LABEL" },
        {
          value: formatMetricValue(datum.value, type),
          date: formatDateWithUserProfileLocation(
            new Date(datum.timestamp),
            LONG_WEEKDAY_DATE_FORMAT4
          )
        }
      ),
      renderTooltip: (datum) => /* @__PURE__ */ React91.createElement(
        SingleMeasurementTooltip,
        __spreadValues({
          title: formatMessage({ id: "INSIGHT_CARD_HEADER_FLOORS_CLIMBED" })
        }, datum)
      )
    }
  );
}

// src/components/charts/metrics/mindful_duration/mindful-duration-bar-chart.tsx
import * as React92 from "react";
import { useIntl as useIntl34 } from "@leagueplatform/locales";
import {
  LONG_WEEKDAY_DATE_FORMAT as LONG_WEEKDAY_DATE_FORMAT5,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation21
} from "@leagueplatform/web-common";
function MindfulDurationBarChart({
  data,
  view,
  type,
  unit
}) {
  const { formatMessage, $tifelse } = useIntl34();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation21();
  const { formatMetricValue } = useLocaleMetricValueFormatter();
  const { formatUnit } = useLocaleUnitFormatter();
  return /* @__PURE__ */ React92.createElement(
    MetricBarChart,
    {
      yMaxFromEnums: 0,
      data,
      type,
      view,
      description: $tifelse(
        view === CHART_VIEWS.WEEKLY,
        "INSIGHT_CHART_MINDFUL_DURATION_WEEK_DESCRIPTION",
        "INSIGHT_CHART_MINDFUL_DURATION_MONTH_DESCRIPTION"
      ),
      axisLeftLabel: `${formatMessage({
        id: "MINDFUL_DURATION"
      })} (${formatUnit(type, unit)})`.toLocaleUpperCase(),
      ariaDatumLabel: (datum) => formatMessage(
        { id: "INSIGHT_CHART_MINDFUL_DURATION_DATUM_LABEL" },
        {
          value: formatMetricValue(datum.value, type),
          date: formatDateWithUserProfileLocation(
            new Date(datum.timestamp),
            LONG_WEEKDAY_DATE_FORMAT5
          )
        }
      ),
      renderTooltip: (datum) => /* @__PURE__ */ React92.createElement(
        SingleMeasurementTooltip,
        __spreadValues({
          title: formatMessage({ id: "MINDFUL_DURATION" })
        }, datum)
      )
    }
  );
}

// src/components/charts/metrics/steps/steps-bar-chart.tsx
import * as React93 from "react";
import { useIntl as useIntl35 } from "@leagueplatform/locales";
import {
  LONG_WEEKDAY_DATE_FORMAT as LONG_WEEKDAY_DATE_FORMAT6,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation22
} from "@leagueplatform/web-common";
function StepsBarChart({ data, type, view }) {
  const { formatMessage, $tifelse } = useIntl35();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation22();
  const { formatUnit } = useLocaleUnitFormatter();
  const { formatMetricValue } = useLocaleMetricValueFormatter();
  return /* @__PURE__ */ React93.createElement(
    MetricBarChart,
    {
      yMaxFromEnums: 0,
      data,
      type,
      view,
      description: $tifelse(
        view === CHART_VIEWS.WEEKLY,
        "INSIGHT_CHART_STEPS_WEEK_DESCRIPTION",
        "INSIGHT_CHART_STEPS_MONTH_DESCRIPTION"
      ),
      axisLeftLabel: `${formatMessage({
        id: "INSIGHT_CARD_HEADER_STEPS"
      })}`.toLocaleUpperCase(),
      ariaDatumLabel: (datum) => formatMessage(
        { id: "INSIGHT_CHART_STEPS_DATUM_LABEL" },
        {
          distance: formatMetricValue(datum.value, type),
          unit: formatUnit(datum.type, datum.unit),
          date: formatDateWithUserProfileLocation(
            new Date(datum.timestamp),
            LONG_WEEKDAY_DATE_FORMAT6
          )
        }
      ),
      renderTooltip: (datum) => /* @__PURE__ */ React93.createElement(
        SingleMeasurementTooltip,
        __spreadValues({
          title: formatMessage({ id: "INSIGHT_CARD_HEADER_STEPS" })
        }, datum)
      )
    }
  );
}

// src/pages/details/components/legacy-chart.tsx
var charts = {
  distance: DistanceBarChart,
  steps: StepsBarChart,
  active_duration: ActiveDurationBarChart,
  energy_burned: EnergyBurnedBarChart,
  floors_climbed: FloorsClimbedBarChart,
  mindful_duration: MindfulDurationBarChart
};
function LegacyChart({
  healthMetrics,
  chartView,
  metricsFrom,
  unit,
  metric,
  hasPreviousPage
}) {
  const groomedHealthMetrics = useGroomedHealthMetrics({
    healthMetrics,
    metric,
    unit,
    metricsFrom,
    chartView,
    hasPreviousPage
  });
  const Chart4 = charts[metric];
  return /* @__PURE__ */ React94.createElement(
    Chart4,
    {
      view: chartView,
      data: groomedHealthMetrics,
      type: metric,
      unit
    }
  );
}

// src/pages/details/components/health-metrics-chart.tsx
function HealthMetricsChart({
  healthMetrics,
  chartView,
  metricsFrom,
  unit,
  metric,
  hasPreviousPage,
  hasNextPage,
  onPreviousPage,
  onNextPage,
  onViewChange
}) {
  var _a, _b;
  const { $tmap } = useIntl36();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation23();
  const lastUpdated = useLastUpdatedValue(healthMetrics);
  const dateRangeStart = (_a = healthMetrics[healthMetrics.length - 1]) == null ? void 0 : _a.timestamp;
  const dateRangeEnd = (_b = healthMetrics[0]) == null ? void 0 : _b.timestamp;
  const averageMeasurement = useAverageMeasurement(metric, unit, healthMetrics);
  const todaysMeasurement = useTodaysMeasurement(metric, unit, healthMetrics);
  const previousLabel = $tmap({
    weekly: "PREVIOUS_WEEK",
    monthly: "PREVIOUS_30_DAYS"
  })(chartView);
  const nextLabel = $tmap({
    weekly: "NEXT_WEEK",
    monthly: "NEXT_30_DAYS"
  })(chartView);
  return /* @__PURE__ */ React95.createElement(React95.Fragment, null, /* @__PURE__ */ React95.createElement(
    WeekMonthViewSwitch,
    {
      onChange: (view) => onViewChange(view)
    }
  ), /* @__PURE__ */ React95.createElement(Flex16, { flexDirection: "column", alignItems: "center", marginBottom: "two" }, /* @__PURE__ */ React95.createElement(
    PaginationControls,
    {
      title: `${formatDateWithUserProfileLocation(
        dateRangeStart,
        SHORT_MONTH_FORMAT3
      )} - ${formatDateWithUserProfileLocation(
        dateRangeEnd,
        SHORT_DATE_FORMAT2
      )}`,
      previous: {
        label: previousLabel,
        enabled: hasPreviousPage,
        onClick: onPreviousPage
      },
      next: {
        label: nextLabel,
        enabled: hasNextPage,
        onClick: onNextPage
      }
    }
  ), /* @__PURE__ */ React95.createElement(AverageValuePanel, { measurement: averageMeasurement }), /* @__PURE__ */ React95.createElement(Flex16, { width: "100%", height: "500px", marginBottom: "twoAndHalf" }, /* @__PURE__ */ React95.createElement(
    LegacyChart,
    {
      chartView,
      healthMetrics,
      metric,
      unit,
      metricsFrom,
      hasPreviousPage
    }
  )), /* @__PURE__ */ React95.createElement(
    TodaysMeasurementPanel,
    {
      lastUpdated,
      measurement: todaysMeasurement
    }
  )));
}

// src/pages/details/no-data-available.tsx
import {
  BodyOne as BodyOne4,
  Box as Box22,
  Flex as Flex17,
  Image as Image8,
  SubtitleOne as SubtitleOne6,
  SecondaryButton as SecondaryButton2
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl37 } from "@leagueplatform/locales";
import * as React96 from "react";
import { handleStaticAsset as handleStaticAsset7 } from "@leagueplatform/asset-config";
import { UnavailableDeviceConnectModal as UnavailableDeviceConnectModal2 } from "@leagueplatform/health-programs";
var NoDataAvailable2 = (_a) => {
  var _b = _a, { metric } = _b, props = __objRest(_b, ["metric"]);
  const { formatMessage } = useIntl37();
  const connectedDeviceImage = handleStaticAsset7(
    "DASHBOARD_NO_HEALTH_METRIC_DATA" /* DASHBOARD_NO_HEALTH_METRIC_DATA */
  );
  const [displayUnavailableOnWebModal, setDisplayUnavailableOnWebModal] = React96.useState(false);
  const metricMessage = useDataTypeConfigMap().metric(metric);
  if (!isSupportedUnitMetricType(metric)) {
    return null;
  }
  return /* @__PURE__ */ React96.createElement(React96.Fragment, null, /* @__PURE__ */ React96.createElement(
    Flex17,
    __spreadValues({
      backgroundColor: "surface.background.secondary",
      borderWidth: "thin",
      borderColor: "onSurface.border.subdued",
      flexDirection: "column",
      alignItems: "center"
    }, props),
    /* @__PURE__ */ React96.createElement(Box22, { marginTop: "oneAndHalf", marginBottom: "one" }, /* @__PURE__ */ React96.createElement(Image8, { width: 215, src: connectedDeviceImage, alt: "altTxt" })),
    /* @__PURE__ */ React96.createElement(Flex17, { flexDirection: "column", alignItems: "center" }, /* @__PURE__ */ React96.createElement(SubtitleOne6, { marginBottom: "quarter", fontWeight: "semibold" }, formatMessage({
      id: "NO_DATA_AVAILABLE"
    })), /* @__PURE__ */ React96.createElement(BodyOne4, { textAlign: "center", marginBottom: "oneAndHalf" }, formatMessage(
      { id: "CURRENTLY_NOT_SHARING_DATA" },
      {
        metric: metricMessage
      }
    )), /* @__PURE__ */ React96.createElement(
      SecondaryButton2,
      {
        onClick: () => {
          setDisplayUnavailableOnWebModal(true);
        },
        marginBottom: "oneAndHalf"
      },
      formatMessage(
        { id: "START_TRACKING_METRIC" },
        {
          metric: metricMessage
        }
      )
    ))
  ), displayUnavailableOnWebModal ? /* @__PURE__ */ React96.createElement(
    UnavailableDeviceConnectModal2,
    {
      onClose: () => setDisplayUnavailableOnWebModal(false)
    }
  ) : null);
};

// src/pages/details/details.tsx
function QueryStateHandler({
  children,
  query,
  metric
}) {
  var _a, _b;
  if (query.status === "loading") {
    return /* @__PURE__ */ React97.createElement(SkeletonBox3, { height: "450px", marginTop: "twoAndHalf", marginBottom: "two" });
  }
  if (query.status === "error" || !query.data) {
    return /* @__PURE__ */ React97.createElement(
      ErrorPanel,
      {
        isRefetching: query.isRefetching,
        onRetry: query.refetch,
        marginBottom: "two",
        error: query.error
      }
    );
  }
  const isAnyDataAvailable = !!((_b = (_a = query.data) == null ? void 0 : _a.meta) == null ? void 0 : _b.isAnyDataAvailable);
  if (!isAnyDataAvailable) {
    return /* @__PURE__ */ React97.createElement(
      NoDataAvailable2,
      {
        marginTop: "twoAndHalf",
        marginBottom: "five",
        metric
      }
    );
  }
  return children;
}
var Details = () => {
  var _a, _b, _c;
  const { dataType } = useParams8();
  const { formatMessage } = useIntl38();
  const [chartView, setChartView] = React97.useState(
    CHART_VIEWS.WEEKLY
  );
  const [metricsFrom, setMetricsFrom] = React97.useState(/* @__PURE__ */ new Date());
  const chartDataQuery = useChartData({
    chartView,
    metric: dataType,
    from: metricsFrom
  });
  const metric = useDataTypeConfigMap().metric(dataType);
  const { data: healthMetrics } = chartDataQuery;
  const isAnyDataAvailable = !!((_a = healthMetrics == null ? void 0 : healthMetrics.meta) == null ? void 0 : _a.isAnyDataAvailable);
  const unit = (_b = healthMetrics == null ? void 0 : healthMetrics.meta) == null ? void 0 : _b.health_metric_unit;
  const hasPreviousPage = chartDataQuery.isPreviousData;
  const hasNextPage = chartDataQuery.isPreviousData || isToday5(metricsFrom) || isFuture(metricsFrom);
  useHealthMetricDocumentTitle(
    formatMessage({
      id: "METRIC_DETAILS"
    }),
    metric
  );
  usePageViewAnalytics4({
    product_area: "dashboard" /* DASHBOARD */,
    screen_name: "dashboard metrics screen" /* DASHBOARD_METRIC_SCREEN */,
    metric_type: dataType
  });
  return /* @__PURE__ */ React97.createElement(
    HealthProfilePageWrapper7,
    {
      title: metric,
      sidebar: /* @__PURE__ */ React97.createElement(Sidebar5, null, isAnyDataAvailable ? /* @__PURE__ */ React97.createElement(MoreOptionsCard5, null, /* @__PURE__ */ React97.createElement(MoreOptionsLink4, { to: "all-recorded-data" }, formatMessage(
        { id: "VIEW_ALL_METRIC_DATA" },
        {
          metric
        }
      )), /* @__PURE__ */ React97.createElement(MoreOptionsLink4, { to: "data-sources" }, formatMessage({ id: "VIEW_DATA_SOURCES" }))) : null)
    },
    /* @__PURE__ */ React97.createElement(QueryStateHandler, { query: chartDataQuery, metric: dataType }, /* @__PURE__ */ React97.createElement(
      HealthMetricsChart,
      {
        healthMetrics: (_c = healthMetrics == null ? void 0 : healthMetrics.data) != null ? _c : [],
        chartView,
        metricsFrom,
        metric: dataType,
        unit,
        hasPreviousPage,
        hasNextPage,
        onPreviousPage: () => {
          setMetricsFrom(
            sub2(metricsFrom, {
              days: chartView === CHART_VIEWS.WEEKLY ? 7 : 30
            })
          );
        },
        onNextPage: () => {
          let newMetricsFrom = add(metricsFrom, {
            days: chartView === CHART_VIEWS.WEEKLY ? 7 : 30
          });
          if (isFuture(newMetricsFrom)) {
            newMetricsFrom = /* @__PURE__ */ new Date();
          }
          setMetricsFrom(newMetricsFrom);
        },
        onViewChange: (view) => {
          setChartView(view);
          setMetricsFrom(/* @__PURE__ */ new Date());
        }
      }
    )),
    /* @__PURE__ */ React97.createElement(HealthPrograms2, { metric: dataType }),
    /* @__PURE__ */ React97.createElement(HealthLiteracyContent, { metric: dataType })
  );
};

// src/pages/details2/details.tsx
import * as React113 from "react";
import sub3 from "date-fns/sub";
import add2 from "date-fns/add";
import isFuture2 from "date-fns/isFuture";
import isToday6 from "date-fns/isToday";
import {
  HealthProfilePageWrapper as HealthProfilePageWrapper8,
  MoreOptionsCard as MoreOptionsCard6,
  MoreOptionsLink as MoreOptionsLink5
} from "@leagueplatform/health-profile-common";
import { useIntl as useIntl45 } from "@leagueplatform/locales";
import { Sidebar as Sidebar6, SkeletonBox as SkeletonBox4 } from "@leagueplatform/web-common-components";
import { trackAnalyticsEvent as trackAnalyticsEvent13, EVENT_NAME as EVENT_NAME13 } from "@leagueplatform/analytics";
import { useParamsLegacy as useParams11 } from "@leagueplatform/routing";

// src/pages/details2/hooks/use-chart-data.ts
import { formatISO } from "date-fns";
function useChartData2({ chartView, metric, from }) {
  const useGetHealthMetricsQuery = useGetHealthMetricsV2({
    interval: chartView === CHART_VIEWS.WEEKLY ? "weekly" : "monthly",
    filter: { type: metric },
    fields: { type: ["type", "value", "unit", "timestamp"] },
    from: formatISO(from, { representation: "date" })
  });
  return useGetHealthMetricsQuery;
}

// src/pages/details2/components/health-metrics-chart.tsx
import * as React111 from "react";
import { Flex as Flex21 } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl43 } from "@leagueplatform/locales";
import {
  SHORT_DATE_FORMAT as SHORT_DATE_FORMAT3,
  SHORT_MONTH_FORMAT as SHORT_MONTH_FORMAT4,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation31
} from "@leagueplatform/web-common";

// src/pages/details2/components/week-month-view-switch.tsx
import * as React98 from "react";
import { Flex as Flex18, genesisStyled as genesisStyled11, css as css8 } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl39 } from "@leagueplatform/locales";
import {
  PillTabs as PillTabs2,
  PillTabList as PillTabList2,
  PillTab as PillTab2
} from "@leagueplatform/web-common-components";
import { trackAnalyticsEvent as trackAnalyticsEvent11, EVENT_NAME as EVENT_NAME11 } from "@leagueplatform/analytics";
import { useParamsLegacy as useParams9 } from "@leagueplatform/routing";
import { Box as Box23 } from "@leagueplatform/genesis-core";
var ViewSwitcherContainer2 = genesisStyled11(Flex18)(
  css8({
    marginTop: "-30px"
  })
);
var handleAnalyticsClick = (metricType, detail) => trackAnalyticsEvent11(EVENT_NAME11.BUTTON_CLICKED, {
  product_area: "dashboard" /* DASHBOARD */,
  screen_name: "dashboard metrics screen" /* DASHBOARD_METRIC_SCREEN */,
  metric_type: metricType,
  detail
});
function WeekMonthViewSwitch2({ onChange }) {
  const { formatMessage } = useIntl39();
  const { dataType } = useParams9();
  return /* @__PURE__ */ React98.createElement(ViewSwitcherContainer2, null, /* @__PURE__ */ React98.createElement(PillTabs2, { onValueChange: onChange, defaultValue: CHART_VIEWS.WEEKLY }, /* @__PURE__ */ React98.createElement(Box23, { css: { width: "fit-content" } }, /* @__PURE__ */ React98.createElement(PillTabList2, null, /* @__PURE__ */ React98.createElement(
    PillTab2,
    {
      value: CHART_VIEWS.WEEKLY,
      onClick: () => handleAnalyticsClick(dataType, "last 7 days")
    },
    formatMessage({
      id: "LAST_7_DAYS"
    })
  ), /* @__PURE__ */ React98.createElement(
    PillTab2,
    {
      value: CHART_VIEWS.MONTHLY,
      onClick: () => handleAnalyticsClick(dataType, "last 30 days")
    },
    formatMessage({
      id: "LAST_30_DAYS"
    })
  )))));
}

// src/pages/details2/components/pagination-controls.tsx
import * as React99 from "react";
import { Flex as Flex19, HeadingOne as HeadingOne8, Box as Box24 } from "@leagueplatform/genesis-commons";
function PaginationControls2({
  title,
  previous,
  next
}) {
  return /* @__PURE__ */ React99.createElement(Flex19, { paddingBottom: "twoAndHalf", paddingTop: "five", alignItems: "flex-end" }, /* @__PURE__ */ React99.createElement(Box24, { marginBottom: "quarter" }, /* @__PURE__ */ React99.createElement(
    ArrowButton,
    {
      ariaLabel: previous.label,
      disabled: previous.enabled,
      onClick: previous.onClick,
      direction: "back"
    }
  )), /* @__PURE__ */ React99.createElement(
    HeadingOne8,
    {
      textAlign: "center",
      as: "h2",
      paddingInlineStart: "oneAndHalf",
      paddingInlineEnd: "oneAndHalf"
    },
    title
  ), /* @__PURE__ */ React99.createElement(Box24, { marginBottom: "quarter" }, /* @__PURE__ */ React99.createElement(
    ArrowButton,
    {
      ariaLabel: next.label,
      disabled: next.enabled,
      onClick: next.onClick,
      direction: "forward"
    }
  )));
}

// src/pages/details2/components/average-value-panel.tsx
import * as React100 from "react";
import { useIntl as useIntl40 } from "@leagueplatform/locales";
import { StackLayout as StackLayout16, HeadingText as HeadingText8 } from "@leagueplatform/genesis-core";
function AverageValuePanel2({ averages }) {
  const { formatMessage } = useIntl40();
  return /* @__PURE__ */ React100.createElement(
    StackLayout16,
    {
      orientation: "horizontal",
      horizontalAlignment: "center",
      spacing: "$three"
    },
    averages.sort((a, b) => a.config.data.order < b.config.data.order ? -1 : 1).map((average2) => {
      const shape = shapes[average2.config.data.order];
      const unit = getHealthMetricUnitDisplayValue(
        average2.value,
        average2.config.data.unit
      );
      return /* @__PURE__ */ React100.createElement(StackLayout16, { horizontalAlignment: "center", key: average2.id }, averages.length > 1 ? /* @__PURE__ */ React100.createElement(
        DatumLegend,
        {
          shape,
          name: average2.config.data.name.toUpperCase(),
          value: average2.value,
          unit
        }
      ) : /* @__PURE__ */ React100.createElement(React100.Fragment, null, /* @__PURE__ */ React100.createElement(HeadingText8, { level: "4", size: "md", emphasis: "subtle" }, formatMessage({
        id: "AVERAGE"
      }).toUpperCase()), /* @__PURE__ */ React100.createElement(StackLayout16, { orientation: "horizontal", spacing: "$half" }, getValueUnitDisplayLabel({
        value: average2.value,
        unitOptions: average2.config.data.unit
      }).map(([displayValue, displayUnit]) => /* @__PURE__ */ React100.createElement(
        DatumValueWithUnit,
        {
          value: displayValue,
          unit: displayUnit
        }
      )))));
    })
  );
}

// src/pages/details2/components/todays-measurement-panel.tsx
import * as React101 from "react";
import compareDesc from "date-fns/compareDesc";
import { useIntl as useIntl41 } from "@leagueplatform/locales";
import { Box as Box25, StackLayout as StackLayout17 } from "@leagueplatform/genesis-core";
import {
  useTheme as useTheme14,
  HeadingOne as HeadingOne9,
  HeadingTwo as HeadingTwo6,
  Flex as Flex20,
  Caption as Caption5
} from "@leagueplatform/genesis-commons";
import { useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation24 } from "@leagueplatform/web-common";
function TodaysMeasurementPanel2({
  todaysValues: initialTodaysValues
}) {
  var _a;
  const [todaysValues] = React101.useState(initialTodaysValues);
  const { formatMessage, formatList } = useIntl41();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation24();
  const theme = useTheme14();
  const lastUpdated = (_a = todaysValues.sort(
    (a, b) => compareDesc(new Date(a.timestamp), new Date(b.timestamp))
  )[0]) == null ? void 0 : _a.timestamp;
  todaysValues.sort((a, b) => a.config.data.order - b.config.data.order);
  return /* @__PURE__ */ React101.createElement(React101.Fragment, null, /* @__PURE__ */ React101.createElement(
    Flex20,
    {
      alignItems: "center",
      justifyContent: "space-between",
      paddingInlineStart: "oneAndHalf",
      paddingInlineEnd: "oneAndHalf",
      paddingTop: "one",
      marginInlineEnd: "two",
      paddingBottom: "one",
      backgroundColor: "surface.background.secondary",
      width: `calc(100% - ${theme.space.two}px)`
    },
    /* @__PURE__ */ React101.createElement(HeadingTwo6, null, formatMessage({
      id: "TODAY"
    })),
    /* @__PURE__ */ React101.createElement(Flex20, { alignItems: "baseline" }, /* @__PURE__ */ React101.createElement(
      StackLayout17,
      {
        orientation: "horizontal",
        horizontalAlignment: "center",
        spacing: "$half"
      },
      todaysValues.map((todaysValue) => {
        const shape = shapes[todaysValue.config.data.order];
        const unit = getHealthMetricUnitDisplayValue(
          todaysValue.label,
          todaysValue.config.data.unit
        );
        return todaysValues.length > 1 ? /* @__PURE__ */ React101.createElement(
          StackLayout17,
          {
            key: todaysValue.type,
            horizontalAlignment: "center"
          },
          /* @__PURE__ */ React101.createElement(
            DatumLegend,
            {
              shape,
              name: todaysValue.config.data.name.toUpperCase(),
              value: todaysValue.label,
              unit
            }
          )
        ) : getValueUnitDisplayLabel({
          value: todaysValue.value,
          label: todaysValue.label,
          unitOptions: todaysValue.config.data.unit
        }).map(([displayValue, displayUnit], index) => (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ React101.createElement(Box25, { key: `${index} + ${todaysValue.type}` }, /* @__PURE__ */ React101.createElement(HeadingOne9, { as: "span" }, displayValue), /* @__PURE__ */ React101.createElement(
            Caption5,
            {
              as: "span",
              paddingInlineStart: "quarter",
              color: "onSurface.text.subdued"
            },
            displayUnit
          ))
        ));
      }),
      todaysValues.length === 0 ? /* @__PURE__ */ React101.createElement(HeadingOne9, { as: "span" }, "--") : null
    ))
  ), lastUpdated ? /* @__PURE__ */ React101.createElement(
    Flex20,
    {
      width: `calc(100% - ${theme.space.two}px)`,
      paddingTop: "half",
      paddingBottom: "quarter",
      justifyContent: "flex-end",
      marginInlineEnd: "two"
    },
    /* @__PURE__ */ React101.createElement(
      Caption5,
      {
        as: "span",
        paddingInlineStart: "quarter",
        color: "onSurface.text.subdued",
        fontWeight: "bold"
      },
      formatMessage({
        id: "LAST_UPDATED"
      }),
      ":"
    ),
    /* @__PURE__ */ React101.createElement(
      Caption5,
      {
        as: "span",
        paddingInlineStart: "quarter",
        color: "onSurface.text.subdued",
        minWidth: theme.space.five
      },
      formatList(
        [
          formatMessage({
            id: "TODAY"
          }),
          formatDateWithUserProfileLocation(lastUpdated, {
            hour: "numeric",
            minute: "numeric"
          })
        ],
        { type: "conjunction", style: "narrow" }
      )
    )
  ) : null);
}

// src/pages/details2/components/chart.tsx
import * as React110 from "react";

// src/components/charts/core/line-graph/line-graph.tsx
import * as React104 from "react";

// src/components/charts/core/line-graph/weekly-line-graph.tsx
import * as React102 from "react";
import {
  SHORT_WEEKDAY_FORMAT as SHORT_WEEKDAY_FORMAT2,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation25
} from "@leagueplatform/web-common";
var NUM_Y_TICKS3 = 5;
function WeeklyLineGraph({
  data,
  accessors,
  title,
  description,
  axisLeftLabel,
  ariaDatumLabel,
  axisBottomLabel,
  renderTooltip,
  yMaxFromEnums
}) {
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation25();
  const yMin = 0;
  const yMax = useGetRoundedYMax(data, accessors, 100, yMaxFromEnums);
  const labelOffset = useGetLeftAxisLabelOffset(yMax);
  const [leftMargin, setLeftMargin] = React102.useState(0);
  const [bottomMargin, setBottomMargin] = React102.useState(0);
  return /* @__PURE__ */ React102.createElement(
    XYChart,
    {
      title,
      desc: description,
      data,
      accessors,
      margin: {
        left: leftMargin,
        bottom: bottomMargin
      },
      xScale: {
        type: "point",
        padding: 0.5
      },
      yScale: {
        type: "linear",
        domain: [yMin, yMax]
      }
    },
    /* @__PURE__ */ React102.createElement(Grid2, { numTicksRows: NUM_Y_TICKS3, centerColumns: true }),
    /* @__PURE__ */ React102.createElement(
      AxisLeft2,
      {
        label: axisLeftLabel,
        labelOffset,
        numTicks: NUM_Y_TICKS3,
        hideTicks: true,
        onWidthChange: (width) => setLeftMargin(width)
      }
    ),
    /* @__PURE__ */ React102.createElement(
      AxisBottom2,
      {
        label: axisBottomLabel,
        tickFormat: (timestamp) => formatDateWithUserProfileLocation(timestamp, SHORT_WEEKDAY_FORMAT2),
        onHeightChange: (height) => setBottomMargin(height)
      }
    ),
    /* @__PURE__ */ React102.createElement(LinePath2, { accessors, data }),
    /* @__PURE__ */ React102.createElement(
      Circles,
      {
        ariaDatumLabel,
        accessors,
        data
      }
    ),
    /* @__PURE__ */ React102.createElement(Tooltip, { snapToDatum: true }, renderTooltip)
  );
}

// src/components/charts/core/line-graph/monthly-line-graph.tsx
import * as React103 from "react";
var NUM_Y_TICKS4 = 5;
function MonthlyLineGraph({
  data,
  accessors,
  title,
  description,
  axisLeftLabel,
  ariaDatumLabel,
  axisBottomLabel,
  renderTooltip,
  yMaxFromEnums
}) {
  const defaultTimezone = useGetDefaultTimezone();
  const yMin = 0;
  const yMax = useGetRoundedYMax(data, accessors, 100, yMaxFromEnums);
  const labelOffset = useGetLeftAxisLabelOffset(yMax);
  const [leftMargin, setLeftMargin] = React103.useState(0);
  const [bottomMargin, setBottomMargin] = React103.useState(0);
  const [formatBottomTick, xAxisTicks] = useMonthlyTicks(
    data.map((datum) => accessors.xAccessor(datum)),
    defaultTimezone
  );
  return /* @__PURE__ */ React103.createElement(
    XYChart,
    {
      title,
      desc: description,
      data,
      accessors,
      margin: {
        left: leftMargin,
        bottom: bottomMargin
      },
      xScale: {
        type: "point",
        padding: 1
      },
      yScale: {
        type: "linear",
        domain: [yMin, yMax]
      }
    },
    /* @__PURE__ */ React103.createElement(Grid2, { numTicksRows: NUM_Y_TICKS4, columnTickValues: xAxisTicks }),
    /* @__PURE__ */ React103.createElement(
      AxisLeft2,
      {
        label: axisLeftLabel,
        labelOffset,
        numTicks: NUM_Y_TICKS4,
        hideTicks: true,
        onWidthChange: (width) => setLeftMargin(width)
      }
    ),
    /* @__PURE__ */ React103.createElement(
      AxisBottom2,
      {
        label: axisBottomLabel,
        tickValues: xAxisTicks,
        tickFormat: formatBottomTick,
        onHeightChange: (height) => setBottomMargin(height)
      }
    ),
    /* @__PURE__ */ React103.createElement(LinePath2, { accessors, data }),
    /* @__PURE__ */ React103.createElement(
      Circles,
      {
        ariaDatumLabel,
        accessors,
        data
      }
    ),
    /* @__PURE__ */ React103.createElement(Tooltip, { snapToDatum: true }, renderTooltip)
  );
}

// src/components/charts/core/line-graph/line-graph.tsx
function LineGraph(_a) {
  var _b = _a, {
    chartView
  } = _b, props = __objRest(_b, [
    "chartView"
  ]);
  if (chartView === CHART_VIEWS.WEEKLY) {
    return /* @__PURE__ */ React104.createElement(WeeklyLineGraph, __spreadValues({}, props));
  }
  if (chartView === CHART_VIEWS.MONTHLY) {
    return /* @__PURE__ */ React104.createElement(MonthlyLineGraph, __spreadValues({}, props));
  }
  return null;
}

// src/components/charts/core/range-graph/weekly-range-graph.tsx
import * as React105 from "react";
import {
  NUMERIC_YEAR_MONTH_DAY as NUMERIC_YEAR_MONTH_DAY3,
  SHORT_WEEKDAY_FORMAT as SHORT_WEEKDAY_FORMAT3,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation26
} from "@leagueplatform/web-common";
var NUM_Y_TICKS5 = 5;
function WeeklyRangeGraph({
  data,
  accessors,
  title,
  description,
  axisLeftLabel,
  ariaDatumLabel,
  axisBottomLabel,
  renderTooltip,
  getShape,
  yMaxFromEnums
}) {
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation26();
  const yMin = 0;
  const yMax = useGetRoundedYMax(data, accessors, 100, yMaxFromEnums);
  const labelOffset = useGetLeftAxisLabelOffset(yMax);
  const [leftMargin, setLeftMargin] = React105.useState(0);
  const [bottomMargin, setBottomMargin] = React105.useState(0);
  const groupedByDate = groupByKey(
    (datum) => formatDateWithUserProfileLocation(accessors.xAccessor(datum), __spreadValues({}, NUMERIC_YEAR_MONTH_DAY3)),
    data
  );
  return /* @__PURE__ */ React105.createElement(
    XYChart,
    {
      title,
      desc: description,
      data,
      accessors,
      margin: {
        left: leftMargin,
        bottom: bottomMargin
      },
      xScale: {
        type: "band",
        paddingInner: 0.9,
        paddingOuter: 0.45
      },
      yScale: {
        type: "linear",
        domain: [yMin, yMax]
      }
    },
    /* @__PURE__ */ React105.createElement(Grid2, { numTicksRows: NUM_Y_TICKS5, centerColumns: true }),
    /* @__PURE__ */ React105.createElement(
      AxisLeft2,
      {
        label: axisLeftLabel,
        labelOffset,
        numTicks: NUM_Y_TICKS5,
        hideTicks: true,
        onWidthChange: (width) => setLeftMargin(width)
      }
    ),
    /* @__PURE__ */ React105.createElement(
      AxisBottom2,
      {
        label: axisBottomLabel,
        tickFormat: (timestamp) => formatDateWithUserProfileLocation(timestamp, SHORT_WEEKDAY_FORMAT3),
        onHeightChange: (height) => setBottomMargin(height)
      }
    ),
    /* @__PURE__ */ React105.createElement(Tooltip, { snapToDatum: false }, renderTooltip),
    Object.values(groupedByDate).filter(
      (datums) => datums.filter((datum) => accessors.yAccessor(datum) !== null).length > 0
    ).map((datums) => /* @__PURE__ */ React105.createElement(
      TooltipMarker,
      {
        data: datums,
        accessors,
        ariaLabel: ariaDatumLabel(datums)
      }
    )),
    data.filter((datum) => accessors.yAccessor(datum) !== null).map((datum) => {
      const shape = getShape(datum);
      return /* @__PURE__ */ React105.createElement(
        RangeBar,
        {
          key: `bar-${accessors.xAccessor(datum)}:${accessors.yAccessor(
            datum
          )}`,
          datum,
          shape,
          accessors
        }
      );
    })
  );
}

// src/components/charts/core/range-graph/monthly-range-graph.tsx
import * as React106 from "react";
import {
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation27,
  NUMERIC_YEAR_MONTH_DAY as NUMERIC_YEAR_MONTH_DAY4
} from "@leagueplatform/web-common";
var NUM_Y_TICKS6 = 5;
function MonthlyRangeGraph({
  data,
  accessors,
  title,
  description,
  axisLeftLabel,
  ariaDatumLabel,
  axisBottomLabel,
  renderTooltip,
  getShape,
  yMaxFromEnums
}) {
  const defaultTimezone = useGetDefaultTimezone();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation27();
  const yMin = 0;
  const yMax = useGetRoundedYMax(data, accessors, 100, yMaxFromEnums);
  const labelOffset = useGetLeftAxisLabelOffset(yMax);
  const [leftMargin, setLeftMargin] = React106.useState(0);
  const [bottomMargin, setBottomMargin] = React106.useState(0);
  const groupedByDate = groupByKey(
    (datum) => formatDateWithUserProfileLocation(accessors.xAccessor(datum), __spreadValues({}, NUMERIC_YEAR_MONTH_DAY4)),
    data
  );
  const [formatBottomTick, xAxisTicks] = useMonthlyTicks(
    data.map((datum) => accessors.xAccessor(datum)),
    defaultTimezone
  );
  return /* @__PURE__ */ React106.createElement(
    XYChart,
    {
      title,
      desc: description,
      data,
      accessors,
      margin: {
        left: leftMargin,
        bottom: bottomMargin
      },
      xScale: {
        type: "band",
        paddingInner: 0.6,
        paddingOuter: 0.3
      },
      yScale: {
        type: "linear",
        domain: [yMin, yMax]
      }
    },
    /* @__PURE__ */ React106.createElement(
      Grid2,
      {
        numTicksRows: NUM_Y_TICKS6,
        columnTickValues: xAxisTicks,
        centerColumns: true
      }
    ),
    /* @__PURE__ */ React106.createElement(
      AxisLeft2,
      {
        label: axisLeftLabel,
        labelOffset,
        numTicks: NUM_Y_TICKS6,
        hideTicks: true,
        onWidthChange: (width) => setLeftMargin(width)
      }
    ),
    /* @__PURE__ */ React106.createElement(
      AxisBottom2,
      {
        label: axisBottomLabel,
        tickValues: xAxisTicks,
        tickFormat: formatBottomTick,
        onHeightChange: (height) => setBottomMargin(height)
      }
    ),
    /* @__PURE__ */ React106.createElement(Tooltip, { snapToDatum: false }, renderTooltip),
    Object.values(groupedByDate).filter(
      (datums) => datums.filter((datum) => accessors.yAccessor(datum) !== null).length > 0
    ).map((datums) => /* @__PURE__ */ React106.createElement(
      TooltipMarker,
      {
        data: datums,
        accessors,
        ariaLabel: ariaDatumLabel(datums)
      }
    )),
    data.filter((datum) => accessors.yAccessor(datum) !== null).map((datum) => {
      const shape = getShape(datum);
      return /* @__PURE__ */ React106.createElement(
        RangeBar,
        {
          key: `bar-${accessors.xAccessor(datum)}:${accessors.yAccessor(
            datum
          )}`,
          datum,
          shape,
          accessors
        }
      );
    })
  );
}

// src/components/charts/core/range-graph/range-graph.tsx
import * as React107 from "react";
function RangeGraph(_a) {
  var _b = _a, {
    chartView
  } = _b, props = __objRest(_b, [
    "chartView"
  ]);
  if (chartView === CHART_VIEWS.WEEKLY) {
    return /* @__PURE__ */ React107.createElement(WeeklyRangeGraph, __spreadValues({}, props));
  }
  if (chartView === CHART_VIEWS.MONTHLY) {
    return /* @__PURE__ */ React107.createElement(MonthlyRangeGraph, __spreadValues({}, props));
  }
  return null;
}

// src/pages/details2/components/chart.tsx
import { useIntl as useIntl42 } from "@leagueplatform/locales";
import {
  DATE_FORMAT as DATE_FORMAT7,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation30
} from "@leagueplatform/web-common";

// src/components/charts/core/chart-tooltip/multiple-measurements-tooltip.tsx
import * as React108 from "react";
import {
  StackItem as StackItem3,
  StackLayout as StackLayout18,
  UtilityText as UtilityText9
} from "@leagueplatform/genesis-core";
import {
  DATE_FORMAT as DATE_FORMAT5,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation28
} from "@leagueplatform/web-common";
function MultipleMeasurementsTooltip({
  data
}) {
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation28();
  return /* @__PURE__ */ React108.createElement(ChartTooltip, null, /* @__PURE__ */ React108.createElement(StackLayout18, { spacing: "$half" }, data.map((datum) => {
    const shape = shapes[datum.metric.data.order];
    const value = getHealthMetricDisplayValue(datum);
    const unit = getHealthMetricUnitDisplayValue(
      value,
      datum.metric.data.unit
    );
    return /* @__PURE__ */ React108.createElement(StackItem3, null, /* @__PURE__ */ React108.createElement(
      DatumLegend,
      {
        size: "small",
        shape,
        name: datum.metric.data.name.toUpperCase(),
        value,
        unit
      }
    ));
  }), /* @__PURE__ */ React108.createElement(UtilityText9, { size: "eyebrow" }, formatDateWithUserProfileLocation(data[0].timestamp, DATE_FORMAT5))));
}

// src/components/charts/core/chart-tooltip/v2/single-measurement-tooltip.tsx
import * as React109 from "react";
import {
  DATE_FORMAT as DATE_FORMAT6,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation29
} from "@leagueplatform/web-common";
import { Box as Box26, StackLayout as StackLayout19, UtilityText as UtilityText10 } from "@leagueplatform/genesis-core";
function SingleMeasurementTooltip2({
  datum
}) {
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation29();
  return /* @__PURE__ */ React109.createElement(ChartTooltip, null, /* @__PURE__ */ React109.createElement(StackLayout19, { spacing: "$quarter" }, /* @__PURE__ */ React109.createElement(
    UtilityText10,
    {
      size: "xs",
      emphasis: "subtle",
      css: { typography: "$overline" }
    },
    datum.metric.data.name
  ), /* @__PURE__ */ React109.createElement(StackLayout19, { orientation: "horizontal", spacing: "$half" }, getValueUnitDisplayLabel({
    value: datum.value,
    label: datum.label,
    unitOptions: datum.metric.data.unit
  }).map(([displayValue, displayUnit], index) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ React109.createElement(Box26, { key: `${index} + ${datum.type}` }, /* @__PURE__ */ React109.createElement(UtilityText10, { as: "span", css: { typography: "$headingOne" } }, displayValue), " ", /* @__PURE__ */ React109.createElement(UtilityText10, { emphasis: "subtle", css: { typography: "$bodyOne" } }, displayUnit))
  ))), /* @__PURE__ */ React109.createElement(UtilityText10, { size: "eyebrow" }, formatDateWithUserProfileLocation(datum.timestamp, DATE_FORMAT6))));
}

// src/pages/details2/components/chart.tsx
var generateLabel2 = (singleDatum) => {
  if (singleDatum.value === null) {
    return "";
  }
  const metricName = singleDatum.metric.data.name;
  const value = Array.isArray(singleDatum.value) ? singleDatum.value.join("\u2013") : singleDatum.value;
  const unitName = getHealthMetricUnitDisplayValue(
    singleDatum.value,
    singleDatum.metric.data.unit
  );
  return `${metricName} ${value} ${unitName}`;
};
function useDatumLabel2() {
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation30();
  return (datum) => {
    if (Array.isArray(datum)) {
      const label2 = datum.filter((d) => d.value !== null).map(generateLabel2);
      const date2 = formatDateWithUserProfileLocation(
        new Date(datum[0].timestamp),
        DATE_FORMAT7
      );
      if (label2.length === 0) {
        return "";
      }
      return `${date2}, ${label2.join(", ")}`;
    }
    if (datum.value === null) {
      return "";
    }
    const label = generateLabel2(datum);
    const date = formatDateWithUserProfileLocation(
      new Date(datum.timestamp),
      DATE_FORMAT7
    );
    return `${date}, ${label}`;
  };
}
function Chart2({ chartView, chartData }) {
  const { $tifelse } = useIntl42();
  const { screenReaderTitle, screenReaderDescription } = chartData;
  const axisLeftLabel = chartData.axisLeftLabel.toLocaleUpperCase();
  const axisBottomLabel = $tifelse(
    chartView === CHART_VIEWS.WEEKLY,
    "DAY_OF_THE_WEEK",
    "DAY_OF_THE_MONTH"
  );
  const generateDatumLabel = useDatumLabel2();
  const data = useHealthMetricValues(chartData.values.data);
  switch (chartData.chartType) {
    case "bar": {
      return /* @__PURE__ */ React110.createElement(
        BarGraph,
        {
          chartView,
          data,
          accessors: {
            xAccessor: (datum) => datum.timestamp,
            yAccessor: (datum) => datum.value
          },
          title: screenReaderTitle,
          description: screenReaderDescription,
          axisLeftLabel,
          axisBottomLabel,
          ariaDatumLabel: generateDatumLabel,
          renderTooltip: (datum) => /* @__PURE__ */ React110.createElement(SingleMeasurementTooltip2, { datum }),
          yMaxFromEnums: 0
        }
      );
    }
    case "line": {
      return /* @__PURE__ */ React110.createElement(
        LineGraph,
        {
          chartView,
          data,
          accessors: {
            xAccessor: (datum) => datum.timestamp,
            yAccessor: (datum) => datum.value
          },
          title: screenReaderTitle,
          description: screenReaderDescription,
          axisLeftLabel,
          axisBottomLabel,
          ariaDatumLabel: generateDatumLabel,
          renderTooltip: (datum) => /* @__PURE__ */ React110.createElement(SingleMeasurementTooltip2, { datum }),
          yMaxFromEnums: 0
        }
      );
    }
    case "range": {
      return /* @__PURE__ */ React110.createElement(
        RangeGraph,
        {
          chartView,
          data,
          accessors: {
            xAccessor: (datum) => datum.timestamp,
            yAccessor: (datum) => datum.value
          },
          title: screenReaderTitle,
          description: screenReaderDescription,
          axisLeftLabel,
          axisBottomLabel,
          ariaDatumLabel: generateDatumLabel,
          getShape: (datum) => shapes[datum.metric.data.order],
          renderTooltip: (datum) => /* @__PURE__ */ React110.createElement(MultipleMeasurementsTooltip, { data: datum }),
          yMaxFromEnums: 0
        }
      );
    }
    default:
      return null;
  }
}

// src/pages/details2/components/health-metrics-chart.tsx
function HealthMetricsChart2({
  chartData,
  chartView,
  hasPreviousPage,
  hasNextPage,
  onPreviousPage,
  onNextPage,
  onViewChange
}) {
  var _a, _b;
  const { $tmap } = useIntl43();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation31();
  const { values: healthMetrics } = chartData;
  const dateRangeStart = (_a = healthMetrics.data[healthMetrics.data.length - 1]) == null ? void 0 : _a.timestamp;
  const dateRangeEnd = (_b = healthMetrics.data[0]) == null ? void 0 : _b.timestamp;
  const previousLabel = $tmap({
    weekly: "PREVIOUS_WEEK",
    monthly: "PREVIOUS_30_DAYS"
  })(chartView);
  const nextLabel = $tmap({
    weekly: "NEXT_WEEK",
    monthly: "NEXT_30_DAYS"
  })(chartView);
  return /* @__PURE__ */ React111.createElement(React111.Fragment, null, /* @__PURE__ */ React111.createElement(
    WeekMonthViewSwitch2,
    {
      onChange: (view) => onViewChange(view)
    }
  ), /* @__PURE__ */ React111.createElement(Flex21, { flexDirection: "column", alignItems: "center", marginBottom: "two" }, /* @__PURE__ */ React111.createElement(
    PaginationControls2,
    {
      title: `${formatDateWithUserProfileLocation(
        dateRangeStart,
        SHORT_MONTH_FORMAT4
      )} - ${formatDateWithUserProfileLocation(
        dateRangeEnd,
        SHORT_DATE_FORMAT3
      )}`,
      previous: {
        label: previousLabel,
        enabled: hasPreviousPage,
        onClick: onPreviousPage
      },
      next: {
        label: nextLabel,
        enabled: hasNextPage,
        onClick: onNextPage
      }
    }
  ), /* @__PURE__ */ React111.createElement(AverageValuePanel2, { averages: chartData.averages.data }), /* @__PURE__ */ React111.createElement(Flex21, { width: "100%", height: "500px", marginBottom: "twoAndHalf" }, /* @__PURE__ */ React111.createElement(Chart2, { chartView, chartData })), /* @__PURE__ */ React111.createElement(TodaysMeasurementPanel2, { todaysValues: chartData.todaysValues.data })));
}

// src/pages/details2/components/no-data-available.tsx
import { Image as Image9 } from "@leagueplatform/genesis-commons";
import {
  Button as Button11,
  StackLayout as StackLayout20,
  Box as Box27,
  HeadingText as HeadingText9,
  UtilityText as UtilityText11
} from "@leagueplatform/genesis-core";
import { useParamsLegacy as useParams10 } from "@leagueplatform/routing";
import { useIntl as useIntl44 } from "@leagueplatform/locales";
import { trackAnalyticsEvent as trackAnalyticsEvent12, EVENT_NAME as EVENT_NAME12 } from "@leagueplatform/analytics";
import * as React112 from "react";
import { handleStaticAsset as handleStaticAsset8 } from "@leagueplatform/asset-config";
import { UnavailableDeviceConnectModal as UnavailableDeviceConnectModal3 } from "@leagueplatform/health-programs";
var NoDataAvailable3 = ({
  metric,
  canSelfRecordData,
  canConnectDevice
}) => {
  const { formatMessage } = useIntl44();
  const { isSelfReportedDataEnabled } = useIsSelfReportedDataEnabled();
  const { dataType } = useParams10();
  const connectedDeviceImage = handleStaticAsset8(
    "DASHBOARD_NO_HEALTH_METRIC_DATA" /* DASHBOARD_NO_HEALTH_METRIC_DATA */
  );
  const [displayUnavailableOnWebModal, setDisplayUnavailableOnWebModal] = React112.useState(false);
  const showAddDataButton = canSelfRecordData && isSelfReportedDataEnabled;
  return /* @__PURE__ */ React112.createElement(
    Box27,
    {
      css: {
        marginTop: "$twoAndHalf",
        marginBottom: "$five"
      }
    },
    /* @__PURE__ */ React112.createElement(
      StackLayout20,
      {
        horizontalAlignment: "center",
        verticalAlignment: "center",
        spacing: "$one",
        css: {
          paddingTop: "$two",
          paddingBottom: "$two",
          backgroundColor: "$surfaceBackgroundTertiary",
          borderColor: "$onSurfaceBorderSubdued",
          borderWidth: "$thin",
          borderRadius: "$small",
          borderStyle: "solid"
        }
      },
      /* @__PURE__ */ React112.createElement(Box27, null, /* @__PURE__ */ React112.createElement(Image9, { width: 215, src: connectedDeviceImage, alt: "altTxt" })),
      /* @__PURE__ */ React112.createElement(StackLayout20, { verticalAlignment: "center", horizontalAlignment: "center" }, /* @__PURE__ */ React112.createElement(
        HeadingText9,
        {
          size: "md",
          level: "2",
          css: { typography: "$subtitleOne", marginBottom: "$quarter" }
        },
        formatMessage({
          id: "NO_DATA_AVAILABLE"
        })
      ), /* @__PURE__ */ React112.createElement(UtilityText11, { as: "p", css: { marginBottom: "$oneAndHalf" } }, formatMessage(
        { id: "CURRENTLY_NOT_SHARING_DATA" },
        {
          metric
        }
      )), /* @__PURE__ */ React112.createElement(StackLayout20, { css: { maxWidth: 295, width: "100%" }, spacing: "$half" }, showAddDataButton ? /* @__PURE__ */ React112.createElement(AddMetricDataButton, null) : null, canConnectDevice ? /* @__PURE__ */ React112.createElement(
        Button11,
        {
          width: "fillContainer",
          priority: "secondary",
          onClick: () => {
            setDisplayUnavailableOnWebModal(true);
            trackAnalyticsEvent12(EVENT_NAME12.BUTTON_CLICKED, {
              product_area: "dashboard" /* DASHBOARD */,
              screen_name: "dashboard metrics screen" /* DASHBOARD_METRIC_SCREEN */,
              metric_type: dataType,
              detail: "connect a device"
            });
          }
        },
        formatMessage({ id: "CONNECT_A_DEVICE" })
      ) : null))
    ),
    displayUnavailableOnWebModal ? /* @__PURE__ */ React112.createElement(
      UnavailableDeviceConnectModal3,
      {
        onClose: () => setDisplayUnavailableOnWebModal(false)
      }
    ) : null
  );
};

// src/pages/details2/details.tsx
function QueryStateHandler2({
  children,
  query
}) {
  var _a;
  if (query.status === "loading") {
    return /* @__PURE__ */ React113.createElement(SkeletonBox4, { height: "450px", marginTop: "twoAndHalf", marginBottom: "two" });
  }
  if (query.status === "error" || !query.data) {
    return /* @__PURE__ */ React113.createElement(
      ErrorPanel,
      {
        isRefetching: query.isRefetching,
        onRetry: query.refetch,
        marginBottom: "two",
        error: query.error
      }
    );
  }
  const [chartData] = query.data.data;
  const isAnyDataAvailable = !!((_a = query.data.meta) == null ? void 0 : _a.isAnyDataAvailable);
  const canSelfRecordData = !!chartData.addDataUrl;
  const canConnectDevice = chartData.configs.data.some(
    (config) => config.source === "device"
  );
  if (!isAnyDataAvailable) {
    return /* @__PURE__ */ React113.createElement(
      NoDataAvailable3,
      {
        metric: chartData.metricDisplayName,
        canSelfRecordData,
        canConnectDevice
      }
    );
  }
  return children(query.data);
}
var handleAnalytics3 = ({
  eventName,
  metricType,
  isEmptyState,
  detail
}) => trackAnalyticsEvent13(eventName, __spreadValues(__spreadValues({
  product_area: "dashboard" /* DASHBOARD */,
  screen_name: "dashboard metrics screen" /* DASHBOARD_METRIC_SCREEN */,
  metric_type: metricType
}, isEmptyState !== void 0 && { is_empty_state: isEmptyState }), detail && { detail }));
var Details2 = () => {
  var _a, _b;
  const { dataType } = useParams11();
  const { isSelfReportedDataEnabled } = useIsSelfReportedDataEnabled();
  const pageViewAnalyticsRef = React113.useRef(false);
  const { formatMessage } = useIntl45();
  const [chartViewTab, setChartViewTab] = React113.useState(
    CHART_VIEWS.WEEKLY
  );
  const [chartView, setChartView] = React113.useState(chartViewTab);
  const [metricsFrom, setMetricsFrom] = React113.useState(/* @__PURE__ */ new Date());
  const chartDataQuery = useChartData2({
    chartView: chartViewTab,
    metric: dataType,
    from: metricsFrom
  });
  const chartData = (_a = chartDataQuery == null ? void 0 : chartDataQuery.data) == null ? void 0 : _a.data[0];
  const meta = (_b = chartDataQuery == null ? void 0 : chartDataQuery.data) == null ? void 0 : _b.meta;
  const isAnyDataAvailable = !!(meta == null ? void 0 : meta.isAnyDataAvailable);
  const metricDisplayName = chartData == null ? void 0 : chartData.metricDisplayName;
  const hasPreviousPage = chartDataQuery.isPreviousData;
  const hasNextPage = chartDataQuery.isPreviousData || isToday6(metricsFrom) || isFuture2(metricsFrom);
  useHealthMetricDocumentTitle(
    formatMessage({
      id: "METRIC_DETAILS"
    }),
    metricDisplayName
  );
  React113.useEffect(() => {
    if (metricDisplayName && !pageViewAnalyticsRef.current) {
      handleAnalytics3({
        eventName: EVENT_NAME13.SCREEN_LOADED,
        metricType: dataType,
        isEmptyState: !isAnyDataAvailable
      });
      pageViewAnalyticsRef.current = true;
    }
  }, [dataType, metricDisplayName, isAnyDataAvailable]);
  const showAddDataButton = (chartData == null ? void 0 : chartData.addDataUrl) && isSelfReportedDataEnabled;
  React113.useEffect(() => {
    if (!chartDataQuery.isPreviousData) {
      setChartView(chartViewTab);
    }
  }, [chartDataQuery.isPreviousData, chartViewTab]);
  return /* @__PURE__ */ React113.createElement(
    HealthProfilePageWrapper8,
    {
      title: metricDisplayName || formatMessage({ id: "METRIC_DETAILS" }),
      sidebar: /* @__PURE__ */ React113.createElement(Sidebar6, null, isAnyDataAvailable ? /* @__PURE__ */ React113.createElement(React113.Fragment, null, /* @__PURE__ */ React113.createElement(MoreOptionsCard6, null, /* @__PURE__ */ React113.createElement(
        MoreOptionsLink5,
        {
          to: "all-recorded-data",
          onClick: () => handleAnalytics3({
            eventName: EVENT_NAME13.BUTTON_CLICKED,
            metricType: dataType,
            detail: "view all data"
          })
        },
        formatMessage(
          { id: "VIEW_ALL_METRIC_DATA" },
          {
            metric: metricDisplayName
          }
        )
      ), /* @__PURE__ */ React113.createElement(
        MoreOptionsLink5,
        {
          to: "data-sources",
          onClick: () => handleAnalytics3({
            eventName: EVENT_NAME13.BUTTON_CLICKED,
            metricType: dataType,
            detail: "view data sources"
          })
        },
        formatMessage({ id: "VIEW_DATA_SOURCES" })
      )), showAddDataButton ? /* @__PURE__ */ React113.createElement(
        AddMetricDataButton,
        {
          onClick: () => handleAnalytics3({
            eventName: EVENT_NAME13.BUTTON_CLICKED,
            metricType: dataType,
            detail: "add data",
            isEmptyState: !isAnyDataAvailable
          })
        }
      ) : null) : null)
    },
    /* @__PURE__ */ React113.createElement(QueryStateHandler2, { query: chartDataQuery }, ({ data: [definedChartData] }) => /* @__PURE__ */ React113.createElement(
      HealthMetricsChart2,
      {
        chartData: definedChartData,
        chartView,
        hasPreviousPage,
        hasNextPage,
        onPreviousPage: () => {
          setMetricsFrom(
            sub3(metricsFrom, {
              days: chartView === CHART_VIEWS.WEEKLY ? 7 : 30
            })
          );
          handleAnalytics3({
            eventName: EVENT_NAME13.BUTTON_CLICKED,
            metricType: dataType,
            detail: "backward date navigation"
          });
        },
        onNextPage: () => {
          let newMetricsFrom = add2(metricsFrom, {
            days: chartView === CHART_VIEWS.WEEKLY ? 7 : 30
          });
          if (isFuture2(newMetricsFrom)) {
            newMetricsFrom = /* @__PURE__ */ new Date();
          }
          handleAnalytics3({
            eventName: EVENT_NAME13.BUTTON_CLICKED,
            metricType: dataType,
            detail: "forward date navigation"
          });
          setMetricsFrom(newMetricsFrom);
        },
        onViewChange: (view) => {
          setChartViewTab(view);
          setMetricsFrom(/* @__PURE__ */ new Date());
        }
      }
    )),
    /* @__PURE__ */ React113.createElement(HealthPrograms, { metric: dataType }),
    /* @__PURE__ */ React113.createElement(HealthLiteracyContent, { metric: dataType })
  );
};

// src/pages/details3/details.tsx
import * as React122 from "react";
import sub4 from "date-fns/sub";
import add3 from "date-fns/add";
import isFuture3 from "date-fns/isFuture";
import isToday7 from "date-fns/isToday";
import {
  HealthProfilePageWrapper as HealthProfilePageWrapper9,
  MoreOptionsCard as MoreOptionsCard7,
  MoreOptionsLink as MoreOptionsLink6
} from "@leagueplatform/health-profile-common";
import { useIntl as useIntl51 } from "@leagueplatform/locales";
import { Sidebar as Sidebar7, SkeletonBox as SkeletonBox5 } from "@leagueplatform/web-common-components";
import { trackAnalyticsEvent as trackAnalyticsEvent15, EVENT_NAME as EVENT_NAME15 } from "@leagueplatform/analytics";

// src/components/charts/core/utils/get-chart-view-date.ts
import { addDays, differenceInCalendarDays as differenceInCalendarDays4 } from "date-fns";
function getChartViewDate({ date, chartView }) {
  const differenceInDays = differenceInCalendarDays4(/* @__PURE__ */ new Date(), date);
  const numberOfDaysInView = chartView === "weekly" ? 7 : 30;
  if (differenceInDays < numberOfDaysInView) {
    return date;
  }
  const numberOfDaysToMove = differenceInDays % numberOfDaysInView;
  const chartDateToSet = addDays(date, numberOfDaysToMove);
  return chartDateToSet;
}

// src/pages/details3/details.tsx
import { useParamsLegacy as useParams13 } from "@leagueplatform/routing";

// src/pages/details3/hooks/use-chart-data.ts
import { formatISO as formatISO2 } from "date-fns";
function useChartData3({ chartView, metric, from }) {
  const useGetHealthMetricsQuery = useGetHealthMetricsV3({
    interval: chartView === CHART_VIEWS.WEEKLY ? "weekly" : "monthly",
    filter: { type: metric },
    fields: { type: ["type", "value", "unit", "timestamp"] },
    from: formatISO2(from, { representation: "date" })
  });
  return useGetHealthMetricsQuery;
}

// src/pages/details3/components/health-programs.tsx
import * as React114 from "react";
import {
  HealthProgramCarousels as HealthProgramCarousels3,
  useHealthProgramsCategory as useHealthProgramsCategory3
} from "@leagueplatform/health-programs";
import { Box as Box28 } from "@leagueplatform/genesis-core";
function HealthPrograms3({ metric }) {
  const healthProgramsCategory = useHealthProgramsCategory3({
    categoryId: metric
  });
  return /* @__PURE__ */ React114.createElement(Box28, { css: { width: "100%" } }, /* @__PURE__ */ React114.createElement(
    HealthProgramCarousels3,
    {
      hideLoadingSkeleton: true,
      isLoading: healthProgramsCategory.isLoading,
      carousels: [
        {
          title: healthProgramsCategory.name,
          programs: healthProgramsCategory.programs,
          analyticsProps: { metricType: metric }
        }
      ],
      carouselsCategory: "dashboard metrics screen" /* DASHBOARD_METRIC_SCREEN */
    }
  ));
}

// src/pages/details3/components/health-metrics-chart.tsx
import * as React121 from "react";
import { Flex as Flex25 } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl50 } from "@leagueplatform/locales";
import {
  SHORT_DATE_FORMAT as SHORT_DATE_FORMAT4,
  SHORT_MONTH_FORMAT as SHORT_MONTH_FORMAT5,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation33
} from "@leagueplatform/web-common";

// src/pages/details3/components/week-month-view-switch.tsx
import * as React115 from "react";
import { Flex as Flex22, genesisStyled as genesisStyled12, css as css9 } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl46 } from "@leagueplatform/locales";
import {
  PillTabs as PillTabs3,
  PillTabList as PillTabList3,
  PillTab as PillTab3
} from "@leagueplatform/web-common-components";
import { trackAnalyticsEvent as trackAnalyticsEvent14, EVENT_NAME as EVENT_NAME14 } from "@leagueplatform/analytics";
import { useParamsLegacy as useParams12 } from "@leagueplatform/routing";
import { Box as Box29 } from "@leagueplatform/genesis-core";
var ViewSwitcherContainer3 = genesisStyled12(Flex22)(
  css9({
    marginTop: "-30px"
  })
);
var handleAnalyticsClick2 = (metricType, detail) => trackAnalyticsEvent14(EVENT_NAME14.BUTTON_CLICKED, {
  product_area: "dashboard" /* DASHBOARD */,
  screen_name: "dashboard metrics screen" /* DASHBOARD_METRIC_SCREEN */,
  metric_type: metricType,
  detail
});
function WeekMonthViewSwitch3({ onChange }) {
  const { formatMessage } = useIntl46();
  const { dataType } = useParams12();
  return /* @__PURE__ */ React115.createElement(ViewSwitcherContainer3, null, /* @__PURE__ */ React115.createElement(PillTabs3, { onValueChange: onChange, defaultValue: CHART_VIEWS.WEEKLY }, /* @__PURE__ */ React115.createElement(Box29, { css: { width: "fit-content" } }, /* @__PURE__ */ React115.createElement(PillTabList3, null, /* @__PURE__ */ React115.createElement(
    PillTab3,
    {
      value: CHART_VIEWS.WEEKLY,
      onClick: () => handleAnalyticsClick2(dataType, "last 7 days")
    },
    formatMessage({
      id: "LAST_7_DAYS"
    })
  ), /* @__PURE__ */ React115.createElement(
    PillTab3,
    {
      value: CHART_VIEWS.MONTHLY,
      onClick: () => handleAnalyticsClick2(dataType, "last 30 days")
    },
    formatMessage({
      id: "LAST_30_DAYS"
    })
  )))));
}

// src/pages/details3/components/pagination-controls.tsx
import * as React116 from "react";
import { Flex as Flex23, HeadingOne as HeadingOne10, Box as Box30 } from "@leagueplatform/genesis-commons";
function PaginationControls3({
  title,
  previous,
  next
}) {
  return /* @__PURE__ */ React116.createElement(Flex23, { paddingBottom: "twoAndHalf", paddingTop: "five", alignItems: "flex-end" }, /* @__PURE__ */ React116.createElement(Box30, { marginBottom: "quarter" }, /* @__PURE__ */ React116.createElement(
    ArrowButton,
    {
      ariaLabel: previous.label,
      disabled: previous.enabled,
      onClick: previous.onClick,
      direction: "back"
    }
  )), /* @__PURE__ */ React116.createElement(
    HeadingOne10,
    {
      textAlign: "center",
      as: "h2",
      paddingInlineStart: "oneAndHalf",
      paddingInlineEnd: "oneAndHalf"
    },
    title
  ), /* @__PURE__ */ React116.createElement(Box30, { marginBottom: "quarter" }, /* @__PURE__ */ React116.createElement(
    ArrowButton,
    {
      ariaLabel: next.label,
      disabled: next.enabled,
      onClick: next.onClick,
      direction: "forward"
    }
  )));
}

// src/pages/details3/components/average-value-panel.tsx
import * as React118 from "react";
import { useIntl as useIntl47 } from "@leagueplatform/locales";
import { StackLayout as StackLayout22, HeadingText as HeadingText11 } from "@leagueplatform/genesis-core";

// src/pages/details3/components/datum-legend.tsx
import * as React117 from "react";
import {
  StackLayout as StackLayout21,
  HeadingText as HeadingText10,
  UtilityText as UtilityText12
} from "@leagueplatform/genesis-core";
function DatumValueWithUnit2({
  size = "normal",
  value,
  unit
}) {
  return /* @__PURE__ */ React117.createElement("div", { style: { whiteSpace: "nowrap" } }, /* @__PURE__ */ React117.createElement(
    UtilityText12,
    {
      css: { typography: size === "normal" ? "$headingOne" : "$headingTwo" }
    },
    value,
    " "
  ), /* @__PURE__ */ React117.createElement(UtilityText12, { emphasis: "subtle", css: { typography: "$bodyOne" } }, unit));
}
function DatumLegend2({
  size = "normal",
  shape,
  name,
  value,
  unit
}) {
  return /* @__PURE__ */ React117.createElement(React117.Fragment, null, /* @__PURE__ */ React117.createElement(
    StackLayout21,
    {
      orientation: "horizontal",
      verticalAlignment: "center",
      spacing: "$quarter"
    },
    shape && /* @__PURE__ */ React117.createElement(ShapeIcon, { shape }),
    /* @__PURE__ */ React117.createElement(
      HeadingText10,
      {
        level: "4",
        size: size === "normal" ? "md" : "xs",
        emphasis: "subtle"
      },
      name
    )
  ), /* @__PURE__ */ React117.createElement(DatumValueWithUnit2, { size, value, unit }));
}

// src/pages/details3/components/average-value-panel.tsx
function AverageValuePanel3({
  averages,
  chartType
}) {
  const { formatMessage } = useIntl47();
  return /* @__PURE__ */ React118.createElement(
    StackLayout22,
    {
      orientation: "horizontal",
      horizontalAlignment: "center",
      spacing: "$three"
    },
    averages.sort(
      (a, b) => a.metricComponent.data.order < b.metricComponent.data.order ? -1 : 1
    ).map((average2) => {
      const shape = shapes[average2.metricComponent.data.order];
      const unit = getHealthMetricUnitDisplayValue(
        average2.value,
        average2.metricComponent.data.unit
      );
      return /* @__PURE__ */ React118.createElement(StackLayout22, { horizontalAlignment: "center", key: average2.id }, chartType === "range" ? /* @__PURE__ */ React118.createElement(
        DatumLegend2,
        {
          shape: averages.length > 1 ? shape : void 0,
          name: average2.metricComponent.data.name.toUpperCase(),
          value: average2.value,
          unit
        }
      ) : /* @__PURE__ */ React118.createElement(React118.Fragment, null, /* @__PURE__ */ React118.createElement(HeadingText11, { level: "4", size: "md", emphasis: "subtle" }, formatMessage({
        id: "AVERAGE"
      }).toUpperCase()), /* @__PURE__ */ React118.createElement(StackLayout22, { orientation: "horizontal", spacing: "$half" }, getValueUnitDisplayLabel({
        value: average2.value,
        unitOptions: average2.metricComponent.data.unit
      }).map(([displayValue, displayUnit]) => /* @__PURE__ */ React118.createElement(
        DatumValueWithUnit2,
        {
          value: displayValue,
          unit: displayUnit
        }
      )))));
    })
  );
}

// src/pages/details3/components/todays-measurement-panel.tsx
import * as React119 from "react";
import compareDesc2 from "date-fns/compareDesc";
import { useIntl as useIntl48 } from "@leagueplatform/locales";
import { Box as Box31, StackLayout as StackLayout23 } from "@leagueplatform/genesis-core";
import {
  useTheme as useTheme15,
  HeadingOne as HeadingOne11,
  HeadingTwo as HeadingTwo7,
  Flex as Flex24,
  Caption as Caption6
} from "@leagueplatform/genesis-commons";
import { useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation32 } from "@leagueplatform/web-common";
function useCachedTodaysValues(todaysValues) {
  const [cachedTodaysValues, setCachedTodaysValues] = React119.useState(todaysValues);
  const memoizedValues = React119.useMemo(() => {
    var _a;
    if (todaysValues.length > 0) {
      setCachedTodaysValues(todaysValues);
    }
    const lastUpdated = (_a = [...cachedTodaysValues].sort(
      (a, b) => compareDesc2(new Date(a.timestamp), new Date(b.timestamp))
    )[0]) == null ? void 0 : _a.timestamp;
    cachedTodaysValues.sort(
      (a, b) => a.metricComponent.data.order - b.metricComponent.data.order
    );
    return { cachedTodaysValues, lastUpdated };
  }, [todaysValues, cachedTodaysValues]);
  return memoizedValues;
}
function Values({ todaysValues }) {
  if (todaysValues.length === 0) {
    return /* @__PURE__ */ React119.createElement(HeadingOne11, { as: "span" }, "--");
  }
  return /* @__PURE__ */ React119.createElement(React119.Fragment, null, todaysValues.map((todaysValue) => {
    const shape = shapes[todaysValue.metricComponent.data.order];
    const unit = getHealthMetricUnitDisplayValue(
      todaysValue.label,
      todaysValue.metricComponent.data.unit
    );
    return todaysValues.length > 1 ? /* @__PURE__ */ React119.createElement(StackLayout23, { key: todaysValue.type, horizontalAlignment: "center" }, /* @__PURE__ */ React119.createElement(
      DatumLegend2,
      {
        shape,
        name: todaysValue.metricComponent.data.name.toUpperCase(),
        value: todaysValue.label,
        unit
      }
    )) : getValueUnitDisplayLabel({
      value: todaysValue.value,
      label: todaysValue.label,
      unitOptions: todaysValue.metricComponent.data.unit
    }).map(([displayValue, displayUnit], index) => (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ React119.createElement(Box31, { key: `${index} + ${todaysValue.type}` }, /* @__PURE__ */ React119.createElement(HeadingOne11, { as: "span" }, displayValue), /* @__PURE__ */ React119.createElement(
        Caption6,
        {
          as: "span",
          paddingInlineStart: "quarter",
          color: "onSurface.text.subdued"
        },
        displayUnit
      ))
    ));
  }));
}
function TodaysMeasurementPanel3({
  todaysValues
}) {
  const { formatMessage, formatList } = useIntl48();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation32();
  const theme = useTheme15();
  const { cachedTodaysValues, lastUpdated } = useCachedTodaysValues(todaysValues);
  return /* @__PURE__ */ React119.createElement(React119.Fragment, null, /* @__PURE__ */ React119.createElement(
    Flex24,
    {
      alignItems: "center",
      justifyContent: "space-between",
      paddingInlineStart: "oneAndHalf",
      paddingInlineEnd: "oneAndHalf",
      paddingTop: "one",
      paddingBottom: "one",
      backgroundColor: "surface.background.secondary",
      width: "100%"
    },
    /* @__PURE__ */ React119.createElement(HeadingTwo7, null, formatMessage({
      id: "TODAY"
    })),
    /* @__PURE__ */ React119.createElement(Flex24, { alignItems: "baseline" }, /* @__PURE__ */ React119.createElement(
      StackLayout23,
      {
        orientation: "horizontal",
        horizontalAlignment: "center",
        spacing: "$half"
      },
      /* @__PURE__ */ React119.createElement(Values, { todaysValues: cachedTodaysValues })
    ))
  ), lastUpdated ? /* @__PURE__ */ React119.createElement(
    Flex24,
    {
      width: `calc(100% - ${theme.space.two}px)`,
      paddingTop: "half",
      paddingBottom: "quarter",
      justifyContent: "flex-end",
      marginInlineEnd: "two"
    },
    /* @__PURE__ */ React119.createElement(
      Caption6,
      {
        as: "span",
        paddingInlineStart: "quarter",
        color: "onSurface.text.subdued",
        fontWeight: "bold"
      },
      formatMessage({
        id: "LAST_UPDATED"
      }),
      ":"
    ),
    /* @__PURE__ */ React119.createElement(
      Caption6,
      {
        as: "span",
        paddingInlineStart: "quarter",
        color: "onSurface.text.subdued",
        minWidth: theme.space.five
      },
      formatList(
        [
          formatMessage({
            id: "TODAY"
          }),
          formatDateWithUserProfileLocation(lastUpdated, {
            hour: "numeric",
            minute: "numeric"
          })
        ],
        { type: "conjunction", style: "narrow" }
      )
    )
  ) : null);
}

// src/pages/details3/components/chart.tsx
import * as React120 from "react";
import { useIntl as useIntl49 } from "@leagueplatform/locales";
function getHighestValueFromEnums(chartData) {
  var _a;
  const enumOptionValues = [];
  (_a = chartData.addInputConfig) == null ? void 0 : _a.data.healthMetricInputs.forEach(
    (input) => input.valueFields.forEach(
      (valueField) => {
        var _a2;
        return (_a2 = valueField.options) == null ? void 0 : _a2.forEach(
          (option) => enumOptionValues.push(option.value)
        );
      }
    )
  );
  const highestEnumValue = Math.max(...enumOptionValues);
  return highestEnumValue;
}
function Chart3({ chartView, chartData }) {
  const { $tifelse } = useIntl49();
  const { screenReaderTitle, screenReaderDescription } = chartData;
  const axisLeftLabel = chartData.axisLeftLabel.toLocaleUpperCase();
  const axisBottomLabel = $tifelse(
    chartView === CHART_VIEWS.WEEKLY,
    "DAY_OF_THE_WEEK",
    "DAY_OF_THE_MONTH"
  );
  const generateDatumLabel = useDatumLabel();
  const data = useHealthMetricValuesV3(chartData.values.data);
  const highestEnumValue = getHighestValueFromEnums(chartData);
  switch (chartData.chartType) {
    case "bar": {
      return /* @__PURE__ */ React120.createElement(
        BarGraph,
        {
          chartView,
          data,
          accessors: {
            xAccessor: (datum) => datum.timestamp,
            yAccessor: (datum) => datum.value
          },
          title: screenReaderTitle,
          description: screenReaderDescription,
          axisLeftLabel,
          axisBottomLabel,
          ariaDatumLabel: generateDatumLabel,
          renderTooltip: (datum) => /* @__PURE__ */ React120.createElement(SingleMeasurementTooltipV3, { datum, interval: chartView }),
          yMaxFromEnums: highestEnumValue
        }
      );
    }
    case "line": {
      return /* @__PURE__ */ React120.createElement(
        LineGraph,
        {
          chartView,
          data,
          accessors: {
            xAccessor: (datum) => datum.timestamp,
            yAccessor: (datum) => datum.value
          },
          title: screenReaderTitle,
          description: screenReaderDescription,
          axisLeftLabel,
          axisBottomLabel,
          ariaDatumLabel: generateDatumLabel,
          renderTooltip: (datum) => /* @__PURE__ */ React120.createElement(SingleMeasurementTooltipV3, { datum, interval: chartView }),
          yMaxFromEnums: highestEnumValue
        }
      );
    }
    case "range": {
      return /* @__PURE__ */ React120.createElement(
        RangeGraph,
        {
          chartView,
          data,
          accessors: {
            xAccessor: (datum) => datum.timestamp,
            yAccessor: (datum) => datum.value
          },
          title: screenReaderTitle,
          description: screenReaderDescription,
          axisLeftLabel,
          axisBottomLabel,
          ariaDatumLabel: generateDatumLabel,
          getShape: (datum) => shapes[datum.metric.data.order],
          renderTooltip: (datum) => /* @__PURE__ */ React120.createElement(MultipleMeasurementsTooltipV3, { data: datum, interval: chartView }),
          yMaxFromEnums: highestEnumValue
        }
      );
    }
    default:
      return null;
  }
}

// src/pages/details3/components/health-metrics-chart.tsx
function HealthMetricsChart3({
  chartData,
  chartView,
  hasPreviousPage,
  hasNextPage,
  onPreviousPage,
  onNextPage,
  onViewChange
}) {
  var _a, _b;
  const { $tmap } = useIntl50();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation33();
  const { values: healthMetrics } = chartData;
  const dateRangeStart = (_a = healthMetrics.data[healthMetrics.data.length - 1]) == null ? void 0 : _a.timestamp;
  const dateRangeEnd = (_b = healthMetrics.data[0]) == null ? void 0 : _b.timestamp;
  const previousLabel = $tmap({
    weekly: "PREVIOUS_WEEK",
    monthly: "PREVIOUS_30_DAYS"
  })(chartView);
  const nextLabel = $tmap({
    weekly: "NEXT_WEEK",
    monthly: "NEXT_30_DAYS"
  })(chartView);
  return /* @__PURE__ */ React121.createElement(React121.Fragment, null, /* @__PURE__ */ React121.createElement(
    WeekMonthViewSwitch3,
    {
      onChange: (view) => onViewChange(view)
    }
  ), /* @__PURE__ */ React121.createElement(Flex25, { flexDirection: "column", alignItems: "center", marginBottom: "two" }, /* @__PURE__ */ React121.createElement(
    PaginationControls3,
    {
      title: `${formatDateWithUserProfileLocation(
        dateRangeStart,
        SHORT_MONTH_FORMAT5
      )} - ${formatDateWithUserProfileLocation(
        dateRangeEnd,
        SHORT_DATE_FORMAT4
      )}`,
      previous: {
        label: previousLabel,
        enabled: hasPreviousPage,
        onClick: onPreviousPage
      },
      next: {
        label: nextLabel,
        enabled: hasNextPage,
        onClick: onNextPage
      }
    }
  ), /* @__PURE__ */ React121.createElement(
    AverageValuePanel3,
    {
      averages: chartData.averages.data,
      chartType: chartData.chartType
    }
  ), /* @__PURE__ */ React121.createElement(Flex25, { width: "100%", height: "500px", marginBottom: "twoAndHalf" }, /* @__PURE__ */ React121.createElement(Chart3, { chartView, chartData })), /* @__PURE__ */ React121.createElement(TodaysMeasurementPanel3, { todaysValues: chartData.todaysValues.data })));
}

// src/pages/details3/details.tsx
function QueryStateHandler3({
  children,
  query
}) {
  var _a, _b;
  if (query.status === "loading") {
    return /* @__PURE__ */ React122.createElement(
      SkeletonBox5,
      {
        height: "450px",
        marginTop: "twoAndHalf",
        marginBottom: "two",
        "data-testid": "loading"
      }
    );
  }
  if (query.status === "error" || !query.data) {
    return /* @__PURE__ */ React122.createElement(
      ErrorPanel,
      {
        isRefetching: query.isRefetching,
        onRetry: query.refetch,
        marginBottom: "two",
        error: query.error
      }
    );
  }
  const [chartData] = query.data.data;
  const isAnyDataAvailable = !!((_a = query.data.meta) == null ? void 0 : _a.isAnyDataAvailable);
  const canConnectDevice = chartData.metricComponents.data.some(
    (config) => config.sourceType === "device"
  );
  const canSelfReport = chartData.metricComponents.data.some(
    (config) => config.sourceType === "self_reported"
  );
  if (!isAnyDataAvailable) {
    return /* @__PURE__ */ React122.createElement(
      NoDataAvailable,
      {
        metric: chartData.metricDisplayName,
        canSelfRecordData: canSelfReport,
        canConnectDevice,
        metricConfigId: chartData.id,
        inputConfig: (_b = chartData.addInputConfig) == null ? void 0 : _b.data
      }
    );
  }
  return children(query.data);
}
var handleAnalytics4 = ({
  eventName,
  metricType,
  isEmptyState,
  detail
}) => trackAnalyticsEvent15(eventName, __spreadValues(__spreadValues({
  product_area: "dashboard" /* DASHBOARD */,
  screen_name: "dashboard metrics screen" /* DASHBOARD_METRIC_SCREEN */,
  metric_type: metricType
}, isEmptyState !== void 0 && { is_empty_state: isEmptyState }), detail && { detail }));
var Details3 = () => {
  var _a, _b;
  const { dataType } = useParams13();
  const { isSelfReportedDataEnabled } = useIsSelfReportedDataEnabled();
  const pageViewAnalyticsRef = React122.useRef(false);
  const { formatMessage } = useIntl51();
  const [chartViewTab, setChartViewTab] = React122.useState(
    CHART_VIEWS.WEEKLY
  );
  const [chartView, setChartView] = React122.useState(chartViewTab);
  const [metricsFrom, setMetricsFrom] = React122.useState(/* @__PURE__ */ new Date());
  const chartDataQuery = useChartData3({
    chartView: chartViewTab,
    metric: dataType,
    from: metricsFrom
  });
  const chartData = (_a = chartDataQuery == null ? void 0 : chartDataQuery.data) == null ? void 0 : _a.data[0];
  const meta = (_b = chartDataQuery == null ? void 0 : chartDataQuery.data) == null ? void 0 : _b.meta;
  const isAnyDataAvailable = !!(meta == null ? void 0 : meta.isAnyDataAvailable);
  const metricDisplayName = chartData == null ? void 0 : chartData.metricDisplayName;
  const hasPreviousPage = chartDataQuery.isPreviousData;
  const hasNextPage = chartDataQuery.isPreviousData || isToday7(metricsFrom) || isFuture3(metricsFrom);
  useHealthMetricDocumentTitle(
    formatMessage({
      id: "METRIC_DETAILS"
    }),
    metricDisplayName
  );
  React122.useEffect(() => {
    if (metricDisplayName && !pageViewAnalyticsRef.current) {
      handleAnalytics4({
        eventName: EVENT_NAME15.SCREEN_LOADED,
        metricType: dataType,
        isEmptyState: !isAnyDataAvailable
      });
      pageViewAnalyticsRef.current = true;
    }
  }, [dataType, metricDisplayName, isAnyDataAvailable]);
  const showAddDataButton = chartData && chartData.metricComponents.data.some(
    (config) => config.sourceType === "self_reported"
  ) && isSelfReportedDataEnabled && chartData.addInputConfig;
  React122.useEffect(() => {
    if (!chartDataQuery.isPreviousData) {
      setChartView(chartViewTab);
    }
  }, [chartDataQuery.isPreviousData, chartViewTab]);
  return /* @__PURE__ */ React122.createElement(
    HealthProfilePageWrapper9,
    {
      title: metricDisplayName || formatMessage({ id: "METRIC_DETAILS" }),
      sidebar: /* @__PURE__ */ React122.createElement(Sidebar7, null, isAnyDataAvailable ? /* @__PURE__ */ React122.createElement(React122.Fragment, null, /* @__PURE__ */ React122.createElement(MoreOptionsCard7, null, /* @__PURE__ */ React122.createElement(
        MoreOptionsLink6,
        {
          to: "all-recorded-data",
          onClick: () => handleAnalytics4({
            eventName: EVENT_NAME15.BUTTON_CLICKED,
            metricType: dataType,
            detail: "view all data"
          })
        },
        formatMessage(
          { id: "VIEW_ALL_METRIC_DATA" },
          {
            metric: metricDisplayName
          }
        )
      ), /* @__PURE__ */ React122.createElement(
        MoreOptionsLink6,
        {
          to: "data-sources",
          onClick: () => handleAnalytics4({
            eventName: EVENT_NAME15.BUTTON_CLICKED,
            metricType: dataType,
            detail: "view data sources"
          })
        },
        formatMessage({ id: "VIEW_DATA_SOURCES" })
      )), showAddDataButton ? /* @__PURE__ */ React122.createElement(
        AddEditDataModal,
        {
          metricConfigId: chartData.id,
          inputConfig: chartData.addInputConfig.data,
          onAddData: (date) => {
            const chartDateToSet = getChartViewDate({
              date,
              chartView
            });
            if (chartDateToSet === date) {
              return null;
            }
            return setMetricsFrom(chartDateToSet);
          },
          modalTrigger: /* @__PURE__ */ React122.createElement(
            AddMetricDataButton2,
            {
              onClick: () => handleAnalytics4({
                eventName: EVENT_NAME15.BUTTON_CLICKED,
                metricType: dataType,
                detail: "add data",
                isEmptyState: !isAnyDataAvailable
              })
            }
          )
        }
      ) : null) : null)
    },
    /* @__PURE__ */ React122.createElement(QueryStateHandler3, { query: chartDataQuery }, ({ data: [definedChartData] }) => /* @__PURE__ */ React122.createElement(
      HealthMetricsChart3,
      {
        chartData: definedChartData,
        chartView,
        hasPreviousPage,
        hasNextPage,
        onPreviousPage: () => {
          setMetricsFrom(
            sub4(metricsFrom, {
              days: chartView === CHART_VIEWS.WEEKLY ? 7 : 30
            })
          );
          handleAnalytics4({
            eventName: EVENT_NAME15.BUTTON_CLICKED,
            metricType: dataType,
            detail: "backward date navigation"
          });
        },
        onNextPage: () => {
          let newMetricsFrom = add3(metricsFrom, {
            days: chartView === CHART_VIEWS.WEEKLY ? 7 : 30
          });
          if (isFuture3(newMetricsFrom)) {
            newMetricsFrom = /* @__PURE__ */ new Date();
          }
          handleAnalytics4({
            eventName: EVENT_NAME15.BUTTON_CLICKED,
            metricType: dataType,
            detail: "forward date navigation"
          });
          setMetricsFrom(newMetricsFrom);
        },
        onViewChange: (view) => {
          setChartViewTab(view);
          setMetricsFrom(/* @__PURE__ */ new Date());
        }
      }
    )),
    /* @__PURE__ */ React122.createElement(HealthPrograms3, { metric: dataType }),
    /* @__PURE__ */ React122.createElement(HealthLiteracyContent, { metric: dataType })
  );
};

// src/pages/details4/details.tsx
import * as React125 from "react";
import {
  HealthProfilePageWrapper as HealthProfilePageWrapper10,
  MoreOptionsCard as MoreOptionsCard8,
  MoreOptionsLink as MoreOptionsLink7
} from "@leagueplatform/health-profile-common";
import { useIntl as useIntl52 } from "@leagueplatform/locales";
import { Sidebar as Sidebar8 } from "@leagueplatform/web-common-components";
import { trackAnalyticsEvent as trackAnalyticsEvent17, EVENT_NAME as EVENT_NAME17 } from "@leagueplatform/analytics";
import { Box as Box32 } from "@leagueplatform/genesis-core";

// src/components/add-edit-data/add-edit-data-managed-modal.tsx
import * as React123 from "react";
import { Modal as Modal5 } from "@leagueplatform/genesis-core";
import { trackAnalyticsEvent as trackAnalyticsEvent16, EVENT_NAME as EVENT_NAME16 } from "@leagueplatform/analytics";
function AddEditDataManagedModal({
  opened,
  onClose,
  inputConfig,
  metricConfigId,
  observationId,
  value,
  label,
  timestamp,
  effectiveDateTime
}) {
  React123.useEffect(() => {
    if (opened) {
      trackAnalyticsEvent16(EVENT_NAME16.SCREEN_LOADED, {
        product_area: "dashboard" /* DASHBOARD */,
        screen_name: "add metric data" /* ADD_METRIC_DATA */,
        metric_type: metricConfigId
      });
    }
  }, [metricConfigId, opened]);
  return /* @__PURE__ */ React123.createElement(
    Modal5.Root,
    {
      open: opened,
      onOpenChange: (open) => {
        if (!open) {
          onClose();
        }
      }
    },
    /* @__PURE__ */ React123.createElement(
      AddEditDataModalContent,
      {
        inputConfig,
        metricConfigId,
        observationId,
        value,
        label,
        timestamp,
        effectiveDateTime,
        onSuccessSubmit: () => {
          onClose();
        }
      }
    )
  );
}

// src/pages/details4/details.tsx
import { useParamsLegacy as useParams14 } from "@leagueplatform/routing";
import { UnavailableDeviceConnectModal as UnavailableDeviceConnectModal4 } from "@leagueplatform/health-programs";
import { DEFAULT_NAMESPACE } from "@leagueplatform/masonry-engine";

// src/pages/details4/hooks/use-chart-data.ts
import { formatISO as formatISO3 } from "date-fns";
function useChartData4({ metric, from }) {
  const useGetHealthMetricsQuery = useGetHealthMetricsV3({
    interval: "all",
    filter: { type: metric },
    fields: { type: ["type", "value", "unit", "timestamp"] },
    from: formatISO3(from, { representation: "date" })
  });
  return useGetHealthMetricsQuery;
}

// src/pages/details4/hooks/use-about-me-metric-details-masonry-engine-instance.ts
import * as React124 from "react";
import {
  getMasonryDriver as getMasonryDriver2,
  MasonryDriverActionController as MasonryDriverActionController2
} from "@leagueplatform/masonry";
import {
  createMasonryEngineInstance,
  MasonryEngineEvent
} from "@leagueplatform/masonry-engine";
var ABOUT_ME_METRIC_DETAILS_ROOT_NODE_ID = "aboutMeMetricDetails$root";
function useAboutMeMetricDetailsMasonryEngineInstance({
  metricType,
  onAddDataClick,
  onConnectDeviceClick
}) {
  React124.useEffect(() => {
    const unsubscribePrimaryCta = MasonryDriverActionController2.addEventListener(
      "deeplink",
      DASHBOARD_MASONRY_HANDLERS.DASHBOARD_METRIC_DETAILS_EMPTY_STATE_PRIMARY_CTA,
      MasonryEngineEvent.ALL,
      onAddDataClick
    );
    const unsubscribeSecondaryCta = MasonryDriverActionController2.addEventListener(
      "deeplink",
      DASHBOARD_MASONRY_HANDLERS.DASHBOARD_METRIC_DETAILS_EMPTY_STATE_SECONDARY_CTA,
      MasonryEngineEvent.ALL,
      onConnectDeviceClick
    );
    return () => {
      unsubscribePrimaryCta();
      unsubscribeSecondaryCta();
    };
  }, [onAddDataClick, onConnectDeviceClick]);
  const masonryEngineInstance = React124.useMemo(
    () => createMasonryEngineInstance(
      getMasonryDriver2({
        rootNodeId: ABOUT_ME_METRIC_DETAILS_ROOT_NODE_ID,
        queryParams: {
          metricType
        }
      })
    ),
    [metricType]
  );
  return masonryEngineInstance;
}

// src/pages/details4/details.tsx
var handleAnalytics5 = ({
  eventName,
  metricType,
  isEmptyState,
  detail
}) => trackAnalyticsEvent17(eventName, __spreadValues(__spreadValues({
  product_area: "dashboard" /* DASHBOARD */,
  screen_name: "dashboard metrics screen" /* DASHBOARD_METRIC_SCREEN */,
  metric_type: metricType
}, isEmptyState !== void 0 && { is_empty_state: isEmptyState }), detail && { detail }));
var Details4 = () => {
  var _a, _b;
  const { dataType } = useParams14();
  const { isSelfReportedDataEnabled } = useIsSelfReportedDataEnabled();
  const pageViewAnalyticsRef = React125.useRef(false);
  const { formatMessage } = useIntl52();
  const [addEditDataModalOpened, setAddEditDataModalOpened] = React125.useState(false);
  const [displayUnavailableOnWebModal, setDisplayUnavailableOnWebModal] = React125.useState(false);
  const MasonryEngineInstance = useAboutMeMetricDetailsMasonryEngineInstance({
    metricType: dataType,
    onAddDataClick: () => {
      setAddEditDataModalOpened(true);
    },
    onConnectDeviceClick: () => {
      setDisplayUnavailableOnWebModal(true);
    }
  });
  const chartDataQuery = useChartData4({
    metric: dataType,
    from: /* @__PURE__ */ new Date()
  });
  const chartData = (_a = chartDataQuery == null ? void 0 : chartDataQuery.data) == null ? void 0 : _a.data[0];
  const meta = (_b = chartDataQuery == null ? void 0 : chartDataQuery.data) == null ? void 0 : _b.meta;
  const isAnyDataAvailable = !!(meta == null ? void 0 : meta.isAnyDataAvailable);
  const metricDisplayName = chartData == null ? void 0 : chartData.metricDisplayName;
  useHealthMetricDocumentTitle(
    formatMessage({
      id: "METRIC_DETAILS"
    }),
    metricDisplayName
  );
  React125.useEffect(() => {
    if (metricDisplayName && !pageViewAnalyticsRef.current) {
      handleAnalytics5({
        eventName: EVENT_NAME17.SCREEN_LOADED,
        metricType: dataType,
        isEmptyState: !isAnyDataAvailable
      });
      pageViewAnalyticsRef.current = true;
    }
  }, [dataType, metricDisplayName, isAnyDataAvailable]);
  const showAddDataButton = chartData && chartData.metricComponents.data.some(
    (config) => config.sourceType === "self_reported"
  ) && isSelfReportedDataEnabled && chartData.addInputConfig;
  return /* @__PURE__ */ React125.createElement(
    HealthProfilePageWrapper10,
    {
      title: metricDisplayName || formatMessage({ id: "METRIC_DETAILS" }),
      sidebar: /* @__PURE__ */ React125.createElement(Sidebar8, null, isAnyDataAvailable ? /* @__PURE__ */ React125.createElement(React125.Fragment, null, /* @__PURE__ */ React125.createElement(MoreOptionsCard8, null, /* @__PURE__ */ React125.createElement(
        MoreOptionsLink7,
        {
          to: "all-recorded-data",
          onClick: () => handleAnalytics5({
            eventName: EVENT_NAME17.BUTTON_CLICKED,
            metricType: dataType,
            detail: "view all data"
          })
        },
        formatMessage(
          { id: "VIEW_ALL_METRIC_DATA" },
          {
            metric: metricDisplayName
          }
        )
      ), /* @__PURE__ */ React125.createElement(
        MoreOptionsLink7,
        {
          to: "data-sources",
          onClick: () => handleAnalytics5({
            eventName: EVENT_NAME17.BUTTON_CLICKED,
            metricType: dataType,
            detail: "view data sources"
          })
        },
        formatMessage({ id: "VIEW_DATA_SOURCES" })
      )), showAddDataButton ? /* @__PURE__ */ React125.createElement(
        AddEditDataModal,
        {
          metricConfigId: chartData.id,
          inputConfig: chartData.addInputConfig.data,
          onAddData: () => {
            MasonryEngineInstance.invokeAction({
              type: "reload",
              namespace: DEFAULT_NAMESPACE,
              payload: {
                nodeIds: [ABOUT_ME_METRIC_DETAILS_ROOT_NODE_ID]
              }
            });
          },
          modalTrigger: /* @__PURE__ */ React125.createElement(
            AddMetricDataButton2,
            {
              onClick: () => handleAnalytics5({
                eventName: EVENT_NAME17.BUTTON_CLICKED,
                metricType: dataType,
                detail: "add data",
                isEmptyState: !isAnyDataAvailable
              })
            }
          )
        }
      ) : null) : null)
    },
    /* @__PURE__ */ React125.createElement(
      Box32,
      {
        css: {
          ".GDS-vertical-stack-layout": {
            height: "fit-content"
          }
        }
      },
      /* @__PURE__ */ React125.createElement(MasonryEngineInstance.Component, null)
    ),
    /* @__PURE__ */ React125.createElement(HealthPrograms3, { metric: dataType }),
    /* @__PURE__ */ React125.createElement(HealthLiteracyContent, { metric: dataType }),
    showAddDataButton ? /* @__PURE__ */ React125.createElement(
      AddEditDataManagedModal,
      {
        opened: addEditDataModalOpened,
        onClose: () => {
          setAddEditDataModalOpened(false);
        },
        metricConfigId: chartData.id,
        inputConfig: chartData.addInputConfig.data
      }
    ) : null,
    displayUnavailableOnWebModal ? /* @__PURE__ */ React125.createElement(
      UnavailableDeviceConnectModal4,
      {
        onClose: () => setDisplayUnavailableOnWebModal(false)
      }
    ) : null
  );
};

// src/dashboard.routes.tsx
import { useIntl as useIntl53 } from "@leagueplatform/locales";
import { useDocumentTitle as useDocumentTitle3 } from "@leagueplatform/web-common";

// src/hooks/use-dashboard-config.ts
import { isConfigSettled, useConfigSelection } from "@leagueplatform/core";
var defaultConfig2 = {
  masonry2MetricDetailsEnabled: false
};
function useDashboardConfig2() {
  return useConfigSelection(
    (config) => isConfigSettled(config) ? {
      masonry2MetricDetailsEnabled: config.config.release_about_me_masonry_2_for_metric_details
    } : {},
    defaultConfig2
  );
}

// src/dashboard.routes.tsx
var DashboardRoutes = () => {
  const { formatMessage } = useIntl53();
  useDocumentTitle3(formatMessage({ id: "ABOUT_ME" }));
  const { data: isDynamicDashboardEnabled } = useFeatureFlagQuery5(
    DYNAMIC_DASHBOARD_ENABLED
  );
  const { masonry2MetricDetailsEnabled } = useDashboardConfig2();
  const { isSelfReportedDataEnabled } = useIsSelfReportedDataEnabled();
  const showV1 = !isDynamicDashboardEnabled && !isSelfReportedDataEnabled;
  const showV2 = isDynamicDashboardEnabled && !isSelfReportedDataEnabled;
  const showV3 = isDynamicDashboardEnabled && isSelfReportedDataEnabled;
  const showV4 = masonry2MetricDetailsEnabled;
  return /* @__PURE__ */ React126.createElement(Routes, null, showV3 && /* @__PURE__ */ React126.createElement(
    Route,
    {
      path: ":dataType/all-recorded-data",
      element: /* @__PURE__ */ React126.createElement(AllRecordedData3, null)
    }
  ), showV2 && /* @__PURE__ */ React126.createElement(
    Route,
    {
      path: ":dataType/all-recorded-data",
      element: /* @__PURE__ */ React126.createElement(AllRecordedData2, null)
    }
  ), showV1 && /* @__PURE__ */ React126.createElement(
    Route,
    {
      path: ":dataType/all-recorded-data",
      element: /* @__PURE__ */ React126.createElement(AllRecordedData, null)
    }
  ), (showV1 || showV2) && /* @__PURE__ */ React126.createElement(Route, { path: ":dataType/data-sources", element: /* @__PURE__ */ React126.createElement(DataSources, null) }), showV3 && /* @__PURE__ */ React126.createElement(Route, { path: ":dataType/data-sources", element: /* @__PURE__ */ React126.createElement(DataSourcesV3, null) }), showV4 && /* @__PURE__ */ React126.createElement(Route, { path: ":dataType/details", element: /* @__PURE__ */ React126.createElement(Details4, null) }), showV3 && !showV4 && /* @__PURE__ */ React126.createElement(Route, { path: ":dataType/details", element: /* @__PURE__ */ React126.createElement(Details3, null) }), showV2 && /* @__PURE__ */ React126.createElement(Route, { path: ":dataType/details", element: /* @__PURE__ */ React126.createElement(Details2, null) }), showV1 && /* @__PURE__ */ React126.createElement(Route, { path: ":dataType/details", element: /* @__PURE__ */ React126.createElement(Details, null) }), /* @__PURE__ */ React126.createElement(Route, { element: /* @__PURE__ */ React126.createElement(InsightsPage, null), path: "/*" }));
};

// src/components/insights/your-insights/your-insights.tsx
import * as React127 from "react";
import {
  useLocationLegacy as useLocation3,
  LinkLegacy as Link3
} from "@leagueplatform/routing";
import {
  trackAnalyticsEvent as trackAnalyticsEvent18,
  SCREEN_NAMES as GLOBAL_SCREEN_NAMES,
  EVENT_NAME as EVENT_NAME18
} from "@leagueplatform/analytics";
import {
  genesisStyled as genesisStyled13,
  Flex as Flex26,
  Box as Box33,
  HeadingTwo as HeadingTwo8,
  SubtleButton as SubtleButton2,
  BodyOneSecondary,
  HeadingThree as HeadingThree3,
  BodyTwoSecondary,
  Image as Image10,
  PrimaryButton,
  Overline as Overline3
} from "@leagueplatform/genesis-commons";
import {
  SkeletonBox as SkeletonBox6,
  GenesisRouterLink
} from "@leagueplatform/web-common-components";
import { useIntl as useIntl54 } from "@leagueplatform/locales";
import { Icon as Icon7, ICONS as ICONS5 } from "@leagueplatform/ui-kit";
import { UnavailableDeviceConnectModal as UnavailableDeviceConnectModal5 } from "@leagueplatform/health-programs";
import { handleStaticAsset as handleStaticAsset9 } from "@leagueplatform/asset-config";
var InsightCardContainer2 = genesisStyled13(Box33)`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto;
    grid-gap: ${({ theme }) => `${theme == null ? void 0 : theme.space.one}px`};
    @media screen and (max-width: ${({ theme }) => `${theme == null ? void 0 : theme.breakpoints.tablet}`}) {
      grid-template-columns: 1fr;
    }
`;
function StartTrackingInsights() {
  const { formatMessage } = useIntl54();
  const [displayUnavailableOnWebModal, setDisplayUnavailableOnWebModal] = React127.useState(false);
  const { pathname: path } = useLocation3();
  return /* @__PURE__ */ React127.createElement(React127.Fragment, null, /* @__PURE__ */ React127.createElement(Flex26, { flexDirection: "column", marginY: "five" }, /* @__PURE__ */ React127.createElement(HeadingTwo8, null, formatMessage({ id: "YOUR_METRICS" })), /* @__PURE__ */ React127.createElement(
    Flex26,
    {
      paddingInlineStart: { laptop: "twoAndHalf" },
      paddingTop: { tablet: "twoAndHalf", phone: "one" },
      justifyContent: "space-between",
      alignItems: "center"
    },
    /* @__PURE__ */ React127.createElement(Box33, { display: { tablet: "initial", phone: "none" } }, /* @__PURE__ */ React127.createElement(
      Image10,
      {
        src: handleStaticAsset9(
          "DASHBOARD_START_TRACKING_INSIGHTS" /* DASHBOARD_START_TRACKING_INSIGHTS */
        ),
        alt: "",
        width: "100%",
        height: "100%",
        maxWidth: "405px"
      }
    )),
    /* @__PURE__ */ React127.createElement(
      Flex26,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        width: "100%",
        maxWidth: "375px",
        marginInlineStart: { tablet: "one" }
      },
      /* @__PURE__ */ React127.createElement(Box33, null, /* @__PURE__ */ React127.createElement(HeadingThree3, { marginBottom: "half" }, formatMessage({ id: "START_TRACKING_HEALTH_HEADER" })), /* @__PURE__ */ React127.createElement(
        BodyTwoSecondary,
        {
          color: "onSurface.text.primary",
          marginBottom: "one"
        },
        formatMessage({ id: "START_TRACKING_HEALTH_BODY" })
      )),
      /* @__PURE__ */ React127.createElement(
        Flex26,
        {
          alignItems: { tablet: "center", phone: "flex-start" },
          flexDirection: "column",
          maxWidth: 300
        },
        /* @__PURE__ */ React127.createElement(
          PrimaryButton,
          {
            onClick: () => {
              setDisplayUnavailableOnWebModal(true);
            }
          },
          formatMessage({ id: "CONNECT_APPS_DEVICES" })
        ),
        /* @__PURE__ */ React127.createElement(GenesisRouterLink, { to: `${path}/insights`, marginTop: "one" }, /* @__PURE__ */ React127.createElement(Flex26, { alignItems: "center" }, /* @__PURE__ */ React127.createElement(Box33, { display: "inline", marginInlineEnd: "half" }, formatMessage({ id: "BROWSE_SUPPORTED_DATA" })), /* @__PURE__ */ React127.createElement(Icon7, { size: 12, icon: ICONS5.FORWARD_CHEVRON })))
      )
    )
  )), displayUnavailableOnWebModal ? /* @__PURE__ */ React127.createElement(
    UnavailableDeviceConnectModal5,
    {
      onClose: () => setDisplayUnavailableOnWebModal(false)
    }
  ) : null);
}
var YourInsights = () => {
  var _a;
  const { formatMessage } = useIntl54();
  const { pathname: path } = useLocation3();
  const {
    isLoading,
    isError,
    isRefetching,
    data: healthMetrics,
    refetch,
    error
  } = useGetHealthMetrics({
    interval: "instant",
    fields: { type: ["type", "value", "unit", "trend", "timestamp"] }
  });
  if (isLoading) {
    return /* @__PURE__ */ React127.createElement(SkeletonBox6, { height: "450px", marginTop: "twoAndHalf" });
  }
  if (isError) {
    return /* @__PURE__ */ React127.createElement(
      ErrorPanel,
      {
        error,
        isRefetching,
        onRetry: () => refetch()
      }
    );
  }
  if (!((_a = healthMetrics == null ? void 0 : healthMetrics.data) == null ? void 0 : _a.length)) {
    return /* @__PURE__ */ React127.createElement(StartTrackingInsights, null);
  }
  return /* @__PURE__ */ React127.createElement(Flex26, { flexDirection: "column", marginTop: "twoAndHalf" }, /* @__PURE__ */ React127.createElement(HeadingTwo8, { marginBottom: "oneAndHalf" }, formatMessage({ id: "YOUR_METRICS" })), /* @__PURE__ */ React127.createElement(Overline3, { as: "h3", marginBottom: "threeQuarters" }, formatMessage({ id: "APPS_AND_DEVICES" })), /* @__PURE__ */ React127.createElement(BodyOneSecondary, { marginBottom: "oneAndHalf" }, formatMessage({ id: "YOUR_METRICS_SUBTITLE" })), /* @__PURE__ */ React127.createElement(InsightCardContainer2, null, healthMetrics.data.map(({ type, unit, value, trend, timestamp }) => /* @__PURE__ */ React127.createElement(
    InsightsCard,
    {
      key: type,
      type,
      trend,
      timestamp,
      onClick: () => {
        trackAnalyticsEvent18(EVENT_NAME18.BUTTON_CLICKED, {
          product_area: "dashboard" /* DASHBOARD */,
          screen_name: GLOBAL_SCREEN_NAMES.HEALTH_PROFILE,
          metric_type: type,
          detail: "click metric cards"
        });
      },
      unit,
      value
    }
  ))), /* @__PURE__ */ React127.createElement(
    SubtleButton2,
    {
      alignSelf: "center",
      marginTop: "three",
      marginBottom: "two",
      as: Link3,
      to: `${path}/insights`,
      textDecoration: "none",
      onClick: () => {
        trackAnalyticsEvent18(EVENT_NAME18.BUTTON_CLICKED, {
          product_area: "dashboard" /* DASHBOARD */,
          screen_name: GLOBAL_SCREEN_NAMES.HEALTH_PROFILE,
          detail: "click all insights"
        });
      }
    },
    formatMessage({ id: "VIEW_ALL_METRICS" })
  ));
};

// src/components/insight-highlight-card/insight-highlight-card.tsx
import * as React128 from "react";
import { Box as Box34 } from "@leagueplatform/genesis-commons";
import {
  HighlightCard,
  CalloutBanner
} from "@leagueplatform/web-common-components";
import { ParagraphText as ParagraphText4 } from "@leagueplatform/genesis-core";
var InsightHighlightCard = ({
  heading,
  seeMoreLink,
  callout,
  children,
  onClick
}) => /* @__PURE__ */ React128.createElement(HighlightCard, { title: heading, actionLink: seeMoreLink, onClick }, /* @__PURE__ */ React128.createElement(CalloutBanner, { icon: callout.image, label: callout.image_alt_text }, /* @__PURE__ */ React128.createElement(ParagraphText4, null, callout.description)), /* @__PURE__ */ React128.createElement(Box34, { mt: "two" }, children));

// src/components/charts/insight-card-horizontal-bar-graph/insight-card-horizontal-bar-graph.tsx
import * as React129 from "react";
import useMeasure2 from "react-use-measure";
import { createScale as createScale2 } from "@visx/scale";
import { Text as Text3 } from "@visx/text";
import { Group as Group3 } from "@visx/group";
import { BarRounded } from "@visx/shape";
import { AxisBottom as AxisBottom3 } from "@visx/axis";
import { useTheme as useTheme16, useThemeRawValues as useThemeRawValues11 } from "@leagueplatform/genesis-core";

// src/components/charts/core/bar-graph/utils/get-axis-ticks.ts
function getAxisTicks(largestNumber, numTicks = 4) {
  let tick = largestNumber;
  if (largestNumber < numTicks) {
    tick = numTicks;
  }
  tick = Math.ceil(largestNumber / numTicks);
  if (tick > 10) {
    tick = roundAxisValueUp(tick);
  }
  const ticks = Array(numTicks + 1).fill(0).map((_value, index) => index * tick);
  return ticks;
}

// src/components/charts/insight-card-horizontal-bar-graph/insight-card-horizontal-bar-graph.tsx
function HorizontalInsightBar({
  timeframe,
  value,
  type,
  unit,
  xScale,
  yScale,
  primary = false
}) {
  var _a, _b, _c;
  const rawTheme = useThemeRawValues11();
  const theme = useTheme16();
  const { formatMetricValue } = useLocaleMetricValueFormatter();
  const { formatUnit } = useLocaleUnitFormatter();
  return /* @__PURE__ */ React129.createElement(Group3, { top: (_a = yScale(timeframe)) == null ? void 0 : _a.valueOf() }, /* @__PURE__ */ React129.createElement(
    Text3,
    {
      verticalAnchor: "start",
      x: 1,
      y: 0,
      style: {
        fontWeight: theme.fontWeights.bodyTwo,
        fontSize: theme.fontSizes.bodyTwo,
        fill: theme.colors.onSurfaceTextSubdued
      }
    },
    timeframe
  ), /* @__PURE__ */ React129.createElement(
    Text3,
    {
      verticalAnchor: "start",
      x: 1,
      y: 24,
      style: {
        fontWeight: theme.fontWeights.headingThree,
        fontSize: theme.fontSizes.headingThree,
        fill: theme.colors.onSurfaceTextPrimary
      }
    },
    `${formatMetricValue(value, type)} ${formatUnit(type, unit, value)}`
  ), value === 0 ? null : /* @__PURE__ */ React129.createElement(
    BarRounded,
    {
      width: (_c = (_b = xScale(value)) == null ? void 0 : _b.valueOf()) != null ? _c : 0,
      x: 0,
      y: 50,
      height: rawTheme.sizes.threeQuarters,
      radius: rawTheme.radii.extraLarge,
      top: true,
      bottom: true,
      strokeWidth: theme.borderWidths.thick,
      fill: primary ? theme.colors.decorativeBrandPrimaryDark : theme.colors.decorativeBrandPrimaryBright,
      style: {
        // Adds radius to the outline when focused.
        borderStartStartRadius: theme.borderWidths.thick,
        borderStartEndRadius: theme.borderWidths.thick,
        borderEndStartRadius: theme.borderWidths.thick,
        borderEndEndRadius: theme.borderWidths.thick
      }
    }
  ));
}
var insightBarHeight = 90;
var axisBottomHeight = 20;
var margin = {
  right: 50,
  bottom: 20
};
function InsightCardHorizontalBarGraph({
  title,
  description,
  type,
  unit,
  items
}) {
  const theme = useTheme16();
  const largestValue = Math.max(...items.map(({ value }) => value));
  const ticks = getAxisTicks(largestValue);
  const shouldAbbreviateTicks = !ticks.every((t) => t < 1e3);
  const totalChartHeight = insightBarHeight * items.length + axisBottomHeight;
  const [ref, bounds] = useMeasure2();
  const { width, height } = bounds;
  const chartWidth = width - margin.right;
  const chartHeight = height - margin.bottom;
  const xScale = createScale2({
    type: "linear",
    domain: [0, ticks[ticks.length - 1]],
    range: [0, chartWidth]
  });
  const yScale = createScale2({
    type: "band",
    domain: items.map((f) => f.timeframelabel),
    range: [0, chartHeight]
  });
  return /* @__PURE__ */ React129.createElement(
    "svg",
    {
      ref,
      width: "100%",
      height: totalChartHeight,
      viewBox: `0 0 ${width} ${height}`
    },
    /* @__PURE__ */ React129.createElement("title", null, title),
    /* @__PURE__ */ React129.createElement("desc", null, description),
    items.map(({ timeframelabel, value }, index) => /* @__PURE__ */ React129.createElement(
      HorizontalInsightBar,
      {
        key: timeframelabel,
        timeframe: timeframelabel,
        type,
        unit,
        value,
        xScale,
        yScale,
        primary: index === 0
      }
    )),
    /* @__PURE__ */ React129.createElement(
      AxisBottom3,
      {
        scale: xScale,
        top: chartHeight,
        tickFormat: (value) => {
          const numValue = typeof value === "number" ? value : Number(value);
          if (shouldAbbreviateTicks && value !== 0) {
            return `${numValue.valueOf() / 1e3}k`;
          }
          return `${numValue.valueOf()}`;
        },
        tickValues: ticks,
        hideAxisLine: true,
        hideTicks: true,
        tickLabelProps: (_value, index) => ({
          fontSize: theme.fontSizes.bodyTwo,
          fill: theme.colors.onSurfaceTextPrimary,
          textAnchor: index === 0 ? "start" : "middle"
        }),
        labelProps: {
          fill: theme.colors.onSurfaceTextPrimary,
          fontSize: theme.fontSizes.headingThree,
          textAnchor: "middle",
          fontWeight: "bold"
        }
      }
    )
  );
}

// src/components/charts/insight-card-horizontal-bar-graph-v2/insight-card-horizontal-bar-graph.tsx
import * as React130 from "react";
import useMeasure3 from "react-use-measure";
import { createScale as createScale3 } from "@visx/scale";
import { Text as Text4 } from "@visx/text";
import { Group as Group4 } from "@visx/group";
import { BarRounded as BarRounded2 } from "@visx/shape";
import { AxisBottom as AxisBottom4 } from "@visx/axis";
import { useTheme as useTheme17, useThemeRawValues as useThemeRawValues12 } from "@leagueplatform/genesis-core";
function HorizontalInsightBarV2({
  timeframe,
  value,
  displayValue,
  label,
  xScale,
  yScale,
  primary = false
}) {
  var _a, _b, _c;
  const rawTheme = useThemeRawValues12();
  const theme = useTheme17();
  return /* @__PURE__ */ React130.createElement(Group4, { top: (_a = yScale(timeframe)) == null ? void 0 : _a.valueOf() }, /* @__PURE__ */ React130.createElement(
    Text4,
    {
      verticalAnchor: "start",
      x: 1,
      y: 0,
      style: {
        fontWeight: theme.fontWeights.bodyTwo,
        fontSize: theme.fontSizes.bodyTwo,
        fill: theme.colors.onSurfaceTextSubdued
      }
    },
    label
  ), /* @__PURE__ */ React130.createElement(
    Text4,
    {
      verticalAnchor: "start",
      x: 1,
      y: 24,
      style: {
        fontWeight: theme.fontWeights.headingThree,
        fontSize: theme.fontSizes.headingThree,
        fill: theme.colors.onSurfaceTextPrimary
      }
    },
    displayValue
  ), value === 0 ? null : /* @__PURE__ */ React130.createElement(
    BarRounded2,
    {
      width: (_c = (_b = xScale(value)) == null ? void 0 : _b.valueOf()) != null ? _c : 0,
      x: 0,
      y: 50,
      height: rawTheme.sizes.threeQuarters,
      radius: rawTheme.radii.extraLarge,
      top: true,
      bottom: true,
      strokeWidth: theme.borderWidths.thick,
      fill: primary ? theme.colors.data : theme.colors.decorativeBrandPrimaryBright,
      style: {
        // Adds radius to the outline when focused.
        borderStartStartRadius: theme.borderWidths.thick,
        borderStartEndRadius: theme.borderWidths.thick,
        borderEndStartRadius: theme.borderWidths.thick,
        borderEndEndRadius: theme.borderWidths.thick
      }
    }
  ));
}
var insightBarHeight2 = 90;
var axisBottomHeight2 = 20;
var margin2 = {
  right: 50,
  bottom: 20
};
function InsightCardHorizontalBarGraphV2({
  title,
  description,
  items
}) {
  const theme = useTheme17();
  const largestValue = Math.max(...items.map(({ value }) => value));
  const ticks = getAxisTicks(largestValue);
  const shouldAbbreviateTicks = !ticks.every((t) => t < 1e3);
  const totalChartHeight = insightBarHeight2 * items.length + axisBottomHeight2;
  const [ref, bounds] = useMeasure3();
  const { width, height } = bounds;
  const chartWidth = width - margin2.right;
  const chartHeight = height - margin2.bottom;
  const xScale = createScale3({
    type: "linear",
    domain: [0, ticks[ticks.length - 1]],
    range: [0, chartWidth]
  });
  const yScale = createScale3({
    type: "band",
    domain: items.map((f) => f.label),
    range: [0, chartHeight]
  });
  return /* @__PURE__ */ React130.createElement(
    "svg",
    {
      ref,
      width: "100%",
      height: totalChartHeight,
      viewBox: `0 0 ${width} ${height}`
    },
    /* @__PURE__ */ React130.createElement("title", null, title),
    /* @__PURE__ */ React130.createElement("desc", null, description),
    items.map(({ label, value, displayValue }, index) => /* @__PURE__ */ React130.createElement(
      HorizontalInsightBarV2,
      {
        key: label,
        timeframe: label,
        value,
        xScale,
        yScale,
        displayValue,
        label,
        primary: index === 0
      }
    )),
    /* @__PURE__ */ React130.createElement(
      AxisBottom4,
      {
        scale: xScale,
        top: chartHeight,
        tickFormat: (value) => {
          const numValue = typeof value === "number" ? value : Number(value);
          if (shouldAbbreviateTicks && value !== 0) {
            return `${numValue.valueOf() / 1e3}k`;
          }
          return `${numValue.valueOf()}`;
        },
        tickValues: ticks,
        hideAxisLine: true,
        hideTicks: true,
        tickLabelProps: (_value, index) => ({
          fontSize: theme.fontSizes.bodyTwo,
          fill: theme.colors.onSurfaceTextPrimary,
          textAnchor: index === 0 ? "start" : "middle"
        }),
        labelProps: {
          fill: theme.colors.onSurfaceTextPrimary,
          fontSize: theme.fontSizes.headingThree,
          textAnchor: "middle",
          fontWeight: "bold"
        }
      }
    )
  );
}

// src/components/charts/insight-card-vertical-bar-graph/insight-card-vertical-bar-graph.tsx
import * as React132 from "react";
import {
  useTheme as useTheme19,
  useThemeRawValues as useThemeRawValues14,
  StackLayout as StackLayout25
} from "@leagueplatform/genesis-core";
import { Group as Group5 } from "@visx/group";
import { BarGroup, BarRounded as BarRounded4 } from "@visx/shape";
import { AxisBottom as AxisBottom5, AxisLeft as AxisLeft3 } from "@visx/axis";
import { scaleBand, scaleLinear } from "@visx/scale";
import { GridRows } from "@visx/grid";
import useMeasure4 from "react-use-measure";
import { useIntl as useIntl55 } from "@leagueplatform/locales";
import {
  SHORT_MONTH_FORMAT as SHORT_MONTH_FORMAT6,
  useFormatDateByUserProfileLocation as useFormatDateByUserProfileLocation34
} from "@leagueplatform/web-common";
import { getStringWidth as getStringWidth2 } from "@visx/text";

// src/components/charts/insight-card-vertical-bar-graph/legend.tsx
import * as React131 from "react";
import { BarRounded as BarRounded3 } from "@visx/shape";
import {
  useTheme as useTheme18,
  useThemeRawValues as useThemeRawValues13,
  UtilityText as UtilityText13,
  HeadingText as HeadingText12,
  StackLayout as StackLayout24
} from "@leagueplatform/genesis-core";
function average(numbers) {
  return numbers.reduce((sum, num) => sum + num, 0) / numbers.length;
}
function Legend({ unit, metric, items }) {
  const rawTheme = useThemeRawValues13();
  const theme = useTheme18();
  const { formatMetricValue } = useLocaleMetricValueFormatter();
  const { formatUnit } = useLocaleUnitFormatter();
  return /* @__PURE__ */ React131.createElement(StackLayout24, { orientation: "horizontal", as: "ul", spacing: "$three", "aria-hidden": true }, items.map((datum, index) => {
    const datumAverage = average(datum.values);
    return /* @__PURE__ */ React131.createElement("li", { key: datum.timeframelabel }, /* @__PURE__ */ React131.createElement(
      StackLayout24,
      {
        orientation: "horizontal",
        verticalAlignment: "center",
        spacing: "$one"
      },
      /* @__PURE__ */ React131.createElement("svg", { width: 12, height: rawTheme.sizes.three }, /* @__PURE__ */ React131.createElement(
        BarRounded3,
        {
          x: 0,
          y: 0,
          height: rawTheme.sizes.three,
          width: rawTheme.sizes.threeQuarters,
          radius: rawTheme.radii.extraLarge,
          top: true,
          bottom: true,
          strokeWidth: theme.borderWidths.thick,
          fill: index === 0 ? theme.colors.decorativeBrandPrimaryBright : theme.colors.decorativeBrandPrimaryDark
        }
      )),
      /* @__PURE__ */ React131.createElement(StackLayout24, { verticalAlignment: "center", spacing: "$none" }, /* @__PURE__ */ React131.createElement(UtilityText13, { emphasis: "subtle", size: "sm" }, datum.timeframelabel), /* @__PURE__ */ React131.createElement(HeadingText12, { level: "3", size: "lg" }, `${formatMetricValue(datumAverage, metric)} ${formatUnit(
        metric,
        unit,
        datumAverage
      )}`))
    ));
  }));
}

// src/components/charts/insight-card-vertical-bar-graph/insight-card-vertical-bar-graph.tsx
var CHART_HEIGHT = 150;
var TICK_WIDTH = 8;
function InsightCardVerticalBarGraph({
  title,
  description,
  metric,
  unit,
  items
}) {
  var _a;
  const theme = useTheme19();
  const rawTheme = useThemeRawValues14();
  const { formatNumber } = useIntl55();
  const formatDateWithUserProfileLocation = useFormatDateByUserProfileLocation34();
  const chartData = items.map((input) => {
    const newData = __spreadValues({}, input);
    input.values.forEach((value, index) => {
      newData[index] = value;
    });
    return newData;
  });
  const largestValue = Math.max(
    ...chartData.map((values) => Math.max(...values.values))
  );
  const keys = Object.keys(chartData[0].values).map(Number);
  const getDate = (d) => {
    const start = formatDateWithUserProfileLocation(
      new Date(d.timeframe.start_date),
      SHORT_MONTH_FORMAT6
    );
    const end = formatDateWithUserProfileLocation(
      new Date(d.timeframe.end_date),
      SHORT_MONTH_FORMAT6
    );
    return `${start} - ${end}`;
  };
  const ticks = getAxisTicks(largestValue);
  const yScaleMax = ticks[ticks.length - 1];
  const [ref, bounds] = useMeasure4();
  const { width, height } = bounds;
  const margin3 = {
    top: 15,
    left: ((_a = getStringWidth2(formatNumber(yScaleMax))) != null ? _a : 0) + TICK_WIDTH,
    bottom: 30
  };
  const chartWidth = width - margin3.left;
  const chartHeight = height - margin3.top - margin3.bottom;
  const groupScale = scaleBand({
    domain: chartData.map(getDate),
    padding: 0.1,
    range: [0, chartWidth]
  });
  const xScale = scaleBand({
    domain: keys,
    range: [0, groupScale.bandwidth()]
  });
  const yScale = scaleLinear({
    domain: [0, yScaleMax],
    range: [chartHeight, 0]
  });
  return /* @__PURE__ */ React132.createElement(StackLayout25, { spacing: "$two" }, /* @__PURE__ */ React132.createElement(Legend, { unit, metric, items }), /* @__PURE__ */ React132.createElement(
    "svg",
    {
      ref,
      width: "100%",
      height: CHART_HEIGHT,
      viewBox: `0 0 ${width} ${height}`
    },
    /* @__PURE__ */ React132.createElement("title", null, title),
    /* @__PURE__ */ React132.createElement("desc", null, description),
    /* @__PURE__ */ React132.createElement(Group5, { top: margin3.top, left: margin3.left }, /* @__PURE__ */ React132.createElement(
      GridRows,
      {
        scale: yScale,
        width: chartWidth,
        strokeDasharray: "7,7",
        strokeWidth: rawTheme.radii.thin,
        stroke: theme.colors.onSurfaceBorderSubdued,
        tickValues: ticks
      }
    ), /* @__PURE__ */ React132.createElement(
      BarGroup,
      {
        data: chartData,
        keys,
        height: chartHeight,
        x0: getDate,
        x0Scale: groupScale,
        x1Scale: xScale,
        yScale,
        color: () => ""
      },
      (barGroups) => barGroups.map((barGroup, index) => /* @__PURE__ */ React132.createElement(
        Group5,
        {
          key: `bar-group-${barGroup.index}-${barGroup.x0}`,
          left: barGroup.x0
        },
        barGroup.bars.map((bar) => {
          if (bar.value === 0) {
            return null;
          }
          return /* @__PURE__ */ React132.createElement(
            BarRounded4,
            {
              key: `bar-rounded-${bar.index}-${bar.x}`,
              x: bar.x,
              y: bar.y,
              width: rawTheme.sizes.threeQuarters,
              height: bar.height,
              top: true,
              bottom: true,
              radius: rawTheme.radii.extraLarge,
              fill: index === 0 ? theme.colors.decorativeBrandPrimaryBright : theme.colors.decorativeBrandPrimaryDark
            }
          );
        })
      ))
    ), /* @__PURE__ */ React132.createElement(
      AxisBottom5,
      {
        top: chartHeight,
        scale: groupScale,
        hideAxisLine: true,
        hideTicks: true,
        tickLabelProps: () => ({
          fill: theme.colors.onSurfaceTextPrimary,
          fontSize: theme.fontSizes.bodyTwo,
          textAnchor: "middle"
        }),
        tickLength: 20
      }
    ), /* @__PURE__ */ React132.createElement(
      AxisLeft3,
      {
        scale: yScale,
        tickValues: ticks,
        hideAxisLine: true,
        hideTicks: true,
        tickLabelProps: () => ({
          fontSize: theme.fontSizes.bodyTwo,
          fill: theme.colors.onSurfaceTextPrimary,
          textAnchor: "end",
          dy: 4
        })
      }
    ))
  ));
}

// src/components/charts/insight-card-vertical-bar-graph-v2/insight-card-vertical-bar-graph.tsx
import * as React134 from "react";
import {
  useTheme as useTheme21,
  useThemeRawValues as useThemeRawValues16,
  StackLayout as StackLayout27
} from "@leagueplatform/genesis-core";
import { Group as Group6 } from "@visx/group";
import { BarGroup as BarGroup2, BarRounded as BarRounded6 } from "@visx/shape";
import { AxisBottom as AxisBottom6, AxisLeft as AxisLeft4 } from "@visx/axis";
import { scaleBand as scaleBand2, scaleLinear as scaleLinear2 } from "@visx/scale";
import { GridRows as GridRows2 } from "@visx/grid";
import useMeasure5 from "react-use-measure";
import { useIntl as useIntl56 } from "@leagueplatform/locales";
import { getStringWidth as getStringWidth3 } from "@visx/text";

// src/components/charts/insight-card-vertical-bar-graph-v2/legend.tsx
import * as React133 from "react";
import { BarRounded as BarRounded5 } from "@visx/shape";
import {
  useTheme as useTheme20,
  useThemeRawValues as useThemeRawValues15,
  UtilityText as UtilityText14,
  HeadingText as HeadingText13,
  StackLayout as StackLayout26
} from "@leagueplatform/genesis-core";
function LegendV2({ items }) {
  const rawTheme = useThemeRawValues15();
  const theme = useTheme20();
  return /* @__PURE__ */ React133.createElement(StackLayout26, { orientation: "horizontal", as: "ul", spacing: "$three", "aria-hidden": true }, items.map((datum, index) => /* @__PURE__ */ React133.createElement("li", { key: datum.indexLabel }, /* @__PURE__ */ React133.createElement(
    StackLayout26,
    {
      orientation: "horizontal",
      verticalAlignment: "center",
      spacing: "$one"
    },
    /* @__PURE__ */ React133.createElement("svg", { width: 12, height: rawTheme.sizes.three }, /* @__PURE__ */ React133.createElement(
      BarRounded5,
      {
        x: 0,
        y: 0,
        height: rawTheme.sizes.three,
        width: rawTheme.sizes.threeQuarters,
        radius: rawTheme.radii.extraLarge,
        top: true,
        bottom: true,
        strokeWidth: theme.borderWidths.thick,
        fill: index === 0 ? theme.colors.decorativeBrandPrimaryBright : theme.colors.decorativeBrandPrimaryDark
      }
    )),
    /* @__PURE__ */ React133.createElement(StackLayout26, { verticalAlignment: "center", spacing: "$none" }, /* @__PURE__ */ React133.createElement(UtilityText14, { emphasis: "subtle", size: "sm" }, datum.indexLabel), /* @__PURE__ */ React133.createElement(HeadingText13, { level: "3", size: "lg" }, datum.indexValue))
  ))));
}

// src/components/charts/insight-card-vertical-bar-graph-v2/insight-card-vertical-bar-graph.tsx
var CHART_HEIGHT2 = 150;
var TICK_WIDTH2 = 8;
function InsightCardVerticalBarGraphV2({
  title,
  description,
  items
}) {
  var _a;
  const theme = useTheme21();
  const rawTheme = useThemeRawValues16();
  const { formatNumber } = useIntl56();
  const chartData = items.map((input) => {
    const newData = __spreadValues({}, input);
    input.values.forEach((value, index) => {
      newData[index] = value;
    });
    return newData;
  });
  const largestValue = Math.max(
    ...chartData.map((values) => Math.max(...values.values))
  );
  const keys = Object.keys(chartData[0].values).map(Number);
  const getDate = (d) => d.xAxisLabel;
  const ticks = getAxisTicks(largestValue);
  const yScaleMax = ticks[ticks.length - 1];
  const [ref, bounds] = useMeasure5();
  const { width, height } = bounds;
  const margin3 = {
    top: 15,
    left: ((_a = getStringWidth3(formatNumber(yScaleMax))) != null ? _a : 0) + TICK_WIDTH2,
    bottom: 30
  };
  const chartWidth = width - margin3.left;
  const chartHeight = height - margin3.top - margin3.bottom;
  const groupScale = scaleBand2({
    domain: chartData.map(getDate),
    padding: 0.1,
    range: [0, chartWidth]
  });
  const xScale = scaleBand2({
    domain: keys,
    range: [0, groupScale.bandwidth()]
  });
  const yScale = scaleLinear2({
    domain: [0, yScaleMax],
    range: [chartHeight, 0]
  });
  return /* @__PURE__ */ React134.createElement(StackLayout27, { spacing: "$two" }, /* @__PURE__ */ React134.createElement(LegendV2, { items }), /* @__PURE__ */ React134.createElement(
    "svg",
    {
      ref,
      width: "100%",
      height: CHART_HEIGHT2,
      viewBox: `0 0 ${width} ${height}`
    },
    /* @__PURE__ */ React134.createElement("title", null, title),
    /* @__PURE__ */ React134.createElement("desc", null, description),
    /* @__PURE__ */ React134.createElement(Group6, { top: margin3.top, left: margin3.left }, /* @__PURE__ */ React134.createElement(
      GridRows2,
      {
        scale: yScale,
        width: chartWidth,
        strokeDasharray: "7,7",
        strokeWidth: rawTheme.radii.thin,
        stroke: theme.colors.onSurfaceBorderSubdued,
        tickValues: ticks
      }
    ), /* @__PURE__ */ React134.createElement(
      BarGroup2,
      {
        data: chartData,
        keys,
        height: chartHeight,
        x0: getDate,
        x0Scale: groupScale,
        x1Scale: xScale,
        yScale,
        color: () => ""
      },
      (barGroups) => barGroups.map((barGroup, index) => /* @__PURE__ */ React134.createElement(
        Group6,
        {
          key: `bar-group-${barGroup.index}-${barGroup.x0}`,
          left: barGroup.x0
        },
        barGroup.bars.map((bar) => {
          if (bar.value === 0) {
            return null;
          }
          return /* @__PURE__ */ React134.createElement(
            BarRounded6,
            {
              key: `bar-rounded-${bar.index}-${bar.x}`,
              x: bar.x,
              y: bar.y,
              width: rawTheme.sizes.threeQuarters,
              height: bar.height,
              top: true,
              bottom: true,
              radius: rawTheme.radii.extraLarge,
              fill: index === 0 ? theme.colors.decorativeBrandPrimaryBright : theme.colors.decorativeBrandPrimaryDark
            }
          );
        })
      ))
    ), /* @__PURE__ */ React134.createElement(
      AxisBottom6,
      {
        top: chartHeight - 1,
        scale: groupScale,
        hideAxisLine: true,
        hideTicks: true,
        tickLabelProps: () => ({
          fill: theme.colors.onSurfaceTextPrimary,
          fontSize: theme.fontSizes.bodyTwo,
          textAnchor: "middle"
        }),
        tickLength: 20
      }
    ), /* @__PURE__ */ React134.createElement(
      AxisLeft4,
      {
        scale: yScale,
        tickValues: ticks,
        hideAxisLine: true,
        hideTicks: true,
        tickLabelProps: () => ({
          fontSize: theme.fontSizes.bodyTwo,
          fill: theme.colors.onSurfaceTextPrimary,
          textAnchor: "end",
          dy: 4
        })
      }
    ))
  ));
}

// src/index.ts
initModule();
initMasonryRegistry();
export {
  AllInsights,
  DashboardRoutes,
  ErrorPanel,
  InsightCardHorizontalBarGraph,
  InsightCardHorizontalBarGraphV2,
  InsightCardVerticalBarGraph,
  InsightCardVerticalBarGraphV2,
  InsightHighlightCard,
  ManageUnitsLink,
  YourInsights,
  useIsDashboardEnabled
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/dashboard'] = window.leagueSDKsPresent['@leagueplatform/dashboard'] || [];
    window.leagueSDKsPresent['@leagueplatform/dashboard'].push('2.28.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/dashboard'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/dashboard module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map